import cn from 'classnames'
import { GetSignatureId } from 'legacy/lut/classes/helpers/partner360/CommitmentHelper'
import { usePartnerId } from 'legacy/lut/classes/helpers/partner360/usePartnerId'
import { usePartnerInfo } from 'legacy/lut/classes/helpers/partner360/usePartnerInfo'
import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { IFormPartnerBasicInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { formatMoneyInteger } from 'legacy/lut/components/widgets/public/partner360/helpers/formatMoneyInteger'
import { requestGlobalPartnerData } from 'legacy/lut/features/globalPartner'
import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import { selectPartnerAccess } from 'legacy/lut/features/partner360/configuration'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import {
  selectSectionSettings,
  updateSectionSettings,
} from 'legacy/lut/features/partner360/sectionSettings'
import { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { Button } from 'core-components/library/button'
import { Checkbox, Switch } from 'core-components/library/checkbox'
import { Loader } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'
import {
  AbsolutePopup,
  NotificationController,
  TPopupHorizontal,
  TPopupVertical,
  TVisibilityTrigger,
} from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'
import { Controller, ValidationStatus } from 'core-components/library/validation'
import { URLContext } from 'core/routes/urlController'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import Logger from 'core/utils/Logger'
import { ActualsTypeButtons, useActualsTypes } from 'partner360/components/actualsTypeButtons'
import { CurrenciesButtons, useCurrencies } from 'partner360/components/currenciesButtons'
import { RowButtons } from 'partner360/components/rowButtons/RowButtons'
import { SellTypeButtons } from 'partner360/components/sellTypeButtons/SellTypeButtons'
import { AdditionalInfoKeys } from 'partner360/entities/planning'
import { isSubCategoryMandatory } from 'partner360/entities/planning'
import { invalidateFinancialCockpitData } from 'partner360/features/financialCockpit/model'
import {
  changeFinSobIsCategoryPlanningApplyingChangesLoading,
  changeFinSobIsCategoryPlanningDataLoading,
} from 'partner360/features/finSob/finSobSlice'
import { requestCompletenessStatusForFinSobSidePanelItem } from 'partner360/features/finSobSidePanel/api/requestCompletenessStatusForFinSobSidePanelItem'
import { PlanningSmbSwitcher } from 'partner360/features/planningSmb'
import { isSectionSettingOn } from 'partner360/helpers/sectionSettings/isSectionSettingOn'
import { useChangeNotApplicable } from 'partner360/hooks/finSob/useChangeNotApplicable'
import { scrollElementIntoPage } from 'partner360/lib/planSectionDialog'
import { ActualsValueTypes, DEFAULT_NETNDP_QBR } from 'partner360/models/actualValueTypes'

import { createSectionSettingsPatch } from '../../../../../features/partner360/sectionSettings/models/iSectionSettingsState'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch'
import { useUserRoles } from '../../../../../hooks/useUserRoles'
import { CommitmentChangeDialog } from '../commitment/CommitmentChangeDialog'
import { ValueTypeSwitcher } from '../common/valueTypeSwitcher/ValueTypeSwitcher'
import { CommentIcon } from '../components/CommentIcon'
import { useTargetsUrlDeps } from '../editors/useTargetsUrlDeps'
import { HelpSection } from '../helpButton'
import { useMarketShare } from '../hooks/useMarketShare'
import { IJBPPlanning, IJBPPlanningItem, SMBFractionTypes } from '../models/IJBPPlanning'
import { NotApplicableWidget } from '../notApplicableWidget/NotApplicable'
import { TypeChangeDialog } from '../programsManagementAdmin/TypeChangeDialog'
import { applyJBPPlanning } from '../services/applyJBPPlanning'
import { cleanPlanningItemForApi } from '../services/cleanPlanningItemForApi'
import { WidgetHeaderWithHelpButton } from '../widgetHeader'
import { WidgetHeader } from '../widgetHeader/WidgetHeader'

import { CategoryHeader } from './components/categoryHeader/CategoryHeader'
import { CategoryInfo } from './components/categoryInfo/CategoryInfo'
import { CategorySubTitle } from './components/categorySubTitle/CategorySubTitle'
import { CategoryTitle } from './components/categoryTitle/CategoryTitle'
import { ExtraFinRows } from './components/extraRows/ExtraFinRows'
import { ExtraSobRows } from './components/extraRows/ExtraSobRows'
import { actualsWrapper } from './components/fieldWrapper/actualsWrapper'
import { fieldWrapper } from './components/fieldWrapper/fieldWrapper'
import { smbVsEuWrapper } from './components/fieldWrapper/smbVsEuWrapper'
import { FloatingNumberInput } from './components/floatingNumberInput'
import { MandatoryField } from './components/mandatoryField/MandatoryField'
import { MapRow } from './components/mapRow/MapRow'
import { NoPlanCheckbox } from './components/noPlanCheckbox/NoPlanCheckbox'
import { PartnersCompletenessField } from './components/partnersCompletenessField/PartnersCompletenessField'
import { SplitPlanningRow } from './components/splitPlanningRow/SplitPlanningRow'
import { SubCategoryMapRow } from './components/subCategoryMapRow/SubCategoryMapRow'
import { WarningField } from './components/warningField/WarningField'
import {
  actualsColor,
  AIPC_CATEGORY,
  COMPLETENESS_INFO_FIN_SOB_PLAN_FIELD,
  CONTRACTUAL_CATEGORY,
  DISPLAY_OPTIONS,
  FIELD_STATE_DISABLED,
  FIELD_STATE_HIGHLIGHT,
  FIN_FRACTION_DIGITS_ROUNDING,
  GLOBAL_TOTAL_CATEGORY,
  HIDE_SOB_FOR_COUNTRY,
  IS_ALWAYS_SHOW_ACTUALS,
  IS_ALWAYS_SHOW_SOB,
  IS_ENABLE_ROUNDING,
  IS_NEW_LNF,
  IS_QUARTER_DEFAULT,
  IS_RECALC_SOB,
  IS_SHOW_COMPOSED_REPORT_EXPANDED_WARNING,
  IS_SHOW_INFORMATION_BANNERS,
  IS_SHOW_NOT_APPLICABLE,
  IS_SHOW_NULL,
  IS_SHOW_PARTNERS_COMPLETENESS_FOR_ALL_ROWS,
  IS_SHOW_PARTNERS_COMPLETENESS_FOR_CONTRACTUAL_PLAN,
  IS_SHOW_PARTNERS_COMPLETENESS_FOR_SUB_CATEGORIES,
  IS_SHOW_PREV_RECALC_ACTUALS,
  IS_SHOW_RETAIL_GTM_PRIORITIES,
  IS_USE_LEVEL_ICON,
  IS_USE_RECALC_PLANS_FROM_BOTTOM_FUNCTIONALITY,
  MANDATORY_CATEGORY,
  MANDATORY_CATEGORY_ALWAYS_EXPANDED,
  OVERALL_CATEGORY,
  P360_FIRST_FYEAR,
  PLAN_REQUEST_FOR_PREV_YEARS,
  PLAN_SECTION_KEY,
  PLAN_STATE_FIELD,
  PLANNING_BY_FY_FQ,
  PLANNING_COL_NUMBER,
  PLANNING_URL_DEPS,
  PlanningRounding,
  POLY_CATEGORY,
  POLY_SUB_CATEGORIES,
  quotaColor,
  ROOM_CATEGORY,
  ROUNDING_VALUES,
  SOB_DETAILS_MANDATORY_CATEGORIES,
  SOB_DETAILS_MANDATORY_OFFERINGS,
  SOB_FRACTION_DIGITS,
  SOB_NEW_LOGIC_FYEAR,
  SOB_STATE_FIELD,
  SST_MANDATORY_LOGIC_FYEAR,
} from './config'
import { ConfirmNotApplicableDialog } from './dialogs/confirmNotApplicableDialog/ConfirmNotApplicableDialog'
import { ConfirmPolyPlanningLevelDialog } from './dialogs/confirmPolyPlanningLevelDialog/ConfirmPolyPlanningLevelDialog'
import { ConfirmSwitchersChangeDialog } from './dialogs/confirmSwitchersChangeDialog/ConfirmSwitchersChangeDialog'
import { EditCommentDialog } from './dialogs/editCommentDialog/EditCommentDialog'
import { FinSobValidationPopupContent } from './dialogs/finSobValidationPopup/FinSobValidationPopupContent'
import { PartnersCompletenessDialog } from './dialogs/partnersCompletenessDialog/PartnersCompletenessDialog'
import { calcDiff2 } from './helpers/calcDiff'
import { calcPercentage, calcPercentage2 } from './helpers/calcPercentage'
import { calcSoBCategoryOverallForCategory } from './helpers/calcSoBOverallForCategory'
import { checkFinSobRate } from './helpers/checks/checkFinSobRate'
import { checkFinSobValues } from './helpers/checks/checkFinSobValues'
import { getJustifyField } from './helpers/checks/getJustifyField'
import { ICheckFinSobValues } from './helpers/checks/models'
import { cleanQuartersAndFY } from './helpers/cleanQuartersAndFY'
import { getCategoryNAField } from './helpers/getCategoryNAField'
import { getCompletenessItem } from './helpers/getCompletenessItem'
import { getDivisor } from './helpers/getDivisor'
import { getFinSobValue, IGetFinSobValueProps } from './helpers/getFinSobValue'
import { getFractionDigits } from './helpers/getFractionDigits'
import { getGtmPoints } from './helpers/getGtmPoints'
import { getIsCollapsedCategory } from './helpers/getIsCollapsedCategory'
import { getIsCollapsedL3Category } from './helpers/getIsCollapsedL3Category'
import { getIsNoPlan } from './helpers/getIsNoPlan'
import { getNAField } from './helpers/getNAField'
import { getPartnerFlags } from './helpers/getPartnerFlags'
import { getPlanningPeriodColumnColor } from './helpers/getPlanningColumnColor'
import { getPlanValue } from './helpers/getPlanValue'
import { getRestoredValue, getRoundedValue } from './helpers/getRoundedValue'
import { getRoundingField } from './helpers/getRoundingField'
import { getSmbEuDiff } from './helpers/getSmbEuDiff'
import { getSubCategoriesWithPlanCount } from './helpers/getSubCategoriesWithPlanCount'
import { getTwoYearsSum, IGetTwoYearsSum } from './helpers/getTwoYearsSum'
import { isTopPartner } from './helpers/isTopPartner'
import { getIsExpandedByFlags } from './helpers/partnerFlags/getIsExpandedByFlags'
import { getMandatoryLinesInCategoryCount } from './helpers/partnerFlags/getMandatoryLinesInCategoryCount'
import { isContractualsByFlag } from './helpers/partnerFlags/isContractualsByFlag'
import { isPartnerFlagActive } from './helpers/partnerFlags/isPartnerFlagActive'
import {
  IPreparePlanningItems,
  preparePlanningItems,
} from './helpers/prepareData/preparePlanningItems'
import { setFySobByQuarters } from './helpers/setFySobByQuarters'
import { setFYTotalByQuarters } from './helpers/setFYTotalByQuarters'
import { setItemValuesUniversal } from './helpers/setItemValuesUniversal'
import { setQuarterByFYTotal } from './helpers/setQuarterByFYTotal'
import { updateL3CollapsedItems } from './helpers/updateL3CollapsedItems'
import { updateOverallTotal } from './helpers/updateOverallTotal'
import { TCTType, TSettingsSuffix, TSplitType, TSType } from './models'
import { CustomFields } from './models/CustomFields'
import { ICategoryPlanningProps } from './models/ICategoryPlanningProps'
import { IFieldProps } from './models/IFieldProps'
import { IFinSobValidationError } from './models/IFinSobValidationError'
import { IPartnersCompleteness } from './models/IPartnersCompleteness'

import styles from './CategoryPlanning.module.scss'
import stylesCompensation from 'legacy/lut/components/widgets/public/partner360/Compensation.module.scss'
import stylesTable from 'legacy/lut/components/widgets/public/partner360/PartnerDevicesInfo.module.scss'

interface ISetFinSobParams {
  settingsIndex: number
  value: string | null
  type: 'actuals' | 'targets' | 'quota'
  fy: number
  fq: number
  isUnits: boolean
  isOverall: boolean
  sType: TSType
  isSoB: boolean
  isNoSplit: boolean
  itemsForUpdate?: IJBPPlanningItem[]
  isCleanChild?: boolean
  sTypeOriginal?: TSType
  isNotManual?: boolean
}

interface ICommentEditor {
  index: number
  year: number
  q: number
  comment: string
}

export const CategoryPlanning = (props: ICategoryPlanningProps) => {
  const { onPlanningDirtyStateChange } = props

  /** -------------------- States ----------------------- */

  const [actualsItems, setActualsItems] = useState<IJBPPlanningItem[]>([])
  const [actualsNoSplitItems, setActualsNoSplitItems] = useState<IJBPPlanningItem[]>([])
  const [categoryValueType, setCategoryValueType] = useState<ActualsValueTypes>(
    ActualsValueTypes.Ndp
  )
  const [categoryValueTypes, setCategoryValueTypes] = useState<ActualsValueTypes[]>([])
  const [editCommentEditor, setCommentEditor] = useState<ICommentEditor>()
  const [isChangeApplying, setIsChangeApplying] = useState(false)
  const [isCollapseAllowed, setIsCollapseAllowed] = useState<boolean>(true)
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true)
  const [isDataPresent, setIsDataPresent] = useState(false)
  const [isUnitsMandatory, setIsUnitsMandatory] = useState<boolean>(false)
  const [hideIfEmpty, setHideIfEmpty] = useState(false)
  const [quotaItems, setQuotaItems] = useState<IJBPPlanningItem[]>([])
  const [reservedActuals, setReservedActuals] = useState<IJBPPlanningItem[]>([])
  const [reservedTargets, setReservedTargets] = useState<IJBPPlanningItem[]>([])
  const [targetsItems, setTargetsItems] = useState<IJBPPlanningItem[]>([])
  const [targetsNoSplitItems, setTargetsNoSplitItems] = useState<IJBPPlanningItem[]>([])
  const [actualsRollupItems, setActualsRollupItems] = useState<IJBPPlanningItem[]>([])
  const [targetsRollupItems, setTargetsRollupItems] = useState<IJBPPlanningItem[]>([])
  const [actualsPartnerCountItems, setActualsPartnerCountItems] = useState<IJBPPlanningItem[]>([])

  // SMB vs EU split
  const [actualsSmbItems, setActualsSmbItems] = useState<IJBPPlanningItem[]>([])
  const [actualsEuItems, setActualsEuItems] = useState<IJBPPlanningItem[]>([])
  const [targetsSmbItems, setTargetsSmbItems] = useState<IJBPPlanningItem[]>([])
  const [targetsEuItems, setTargetsEuItems] = useState<IJBPPlanningItem[]>([])

  const [validationErrors, setValidationErrors] = useState<IFinSobValidationError[]>([])
  const [validationInputIndex, setValidationInputIndex] = useState(0)
  const [validationInputUnconfirmedCount, setValidationInputUnconfirmedCount] = useState(0)

  const [isRecalcPlans, setIsRecalcPlans] = useState(false)
  const [isShowAllSplits, setIsShowAllSplits] = useState(false)
  const [isShowConfirmNotApplicableDialog, setIsShowConfirmNotApplicableDialog] = useState(false)
  const [isShowConfirmSwitchersChangeDialog, setIsShowConfirmSwitchersChangeDialog] =
    useState(false)
  const [isShowComposedSoB, setIsShowComposedSoB] = useState(false)
  const [isShowOnlyCompletedPlans, setIsShowOnlyCompletedPlans] = useState(true)
  const [isShowRateDialog, setIsShowRateDialog] = useState(false)
  const [isShowSignDialog, setIsShowSignDialog] = useState(false)
  const [isShowSignDialogNA, setIsShowSignDialogNA] = useState(false)
  const [polyPlanningLevel, setPolyPlanningLevel] = useState('')
  const [partnersCompleteness, setPartnersCompleteness] = useState<IPartnersCompleteness>()
  const [splitType, setSplitType] = useState<TSplitType>('Total')
  const [validationStatus, setValidationStatus] = useState(ValidationStatus.Invalid)

  /** -------------------- Selectors ----------------------- */

  const { isDistributor, isRegionalDistributor } = useSelector(selectPartnerAccess)
  const sectionSettings = useSelector(selectSectionSettings)
  const isEditMode = useSelector(selectPublishingMode)

  /** -------------------- Hooks ----------------------- */

  const dispatch = useAppDispatch()
  const context = useContext(URLContext)
  const t = useSafetyTranslation()
  const partnerId = usePartnerId(props.widgetParams, props.pid)
  const {
    fyear: partnerFYear,
    partnerInfo,
    canEditPartner,
    buttonCurrType,
  } = usePartnerInfo({ partnerId })

  const changeNotApplicableHndl = useChangeNotApplicable({
    partnerId,
    fYear: partnerFYear,
  })

  const { jbpSettings } = useJbpSettings()
  const isFinSobPlanQuarterlyChecksEnabled = !!jbpSettings.finSobPlanQuarterlyChecks

  const fixedComposedReportFYear = props.composedReportFYear ?? jbpSettings.currentFYear
  const fixedQuarterlyBusinessReviewFYear =
    props.quarterlyBusinessReviewFYear ?? jbpSettings.currentFYear
  const composedReportFYear = props.composedReportMode ? fixedComposedReportFYear : partnerFYear
  const fyear = props.isQuarterlyBusinessReviewMode
    ? fixedQuarterlyBusinessReviewFYear
    : composedReportFYear
  const { activeCurrency: commonCurrency, availableCurrencies } = useCurrencies()

  const { actualsType: commonActualsType, onChangeActualsType, actualsTypes } = useActualsTypes()

  const { marketShareData } = useMarketShare({
    partnerId,
    fyear,
    programType: buttonCurrType,
    section: 'jbp-gtm-priorities',
  })
  const { signed, dropSignature } = GetSignatureId(
    partnerId,
    COMPLETENESS_INFO_FIN_SOB_PLAN_FIELD,
    buttonCurrType
  )

  /** -------------------- Variables ----------------------- */

  const {
    isYearlyPlanning,
    isShowDetailedPlanning,
    isShowPreviousPlans: isShowPrevTargets,
    isShowPlanAchievement,
    isShowQuotaAchievement,
    isShowYoYActualsVsActuals,
    isShowYoYActualsVsPlans,
    isShowYoYPlansVsPlans,
    isShowYoYQuotaVsActuals,
    isShowYoYPartnersVsPartners,
    isShowQoQActualsVsActuals,
    isShowQoQActualsVsPlans,
    isShowQoQPlansVsPlans,
    isShowQoQQuotaVsActuals,
    isShowQoQPartnersVsPartners,
    isShowPartnerCount,
    isShowActualsSplit,
    isShowSmbVsEuSplit,
  } = props.displaySettings.settings

  const currentCat = useMemo(() => props.dataSetInfo.category, [props.dataSetInfo.category])
  const planningSmbProgramType = props.dataSetInfo.ProgramType || buttonCurrType
  const categoryName = useMemo(() => t(props.dataSetInfo.category), [props.dataSetInfo.category, t])
  const fQuarters = useMemo(() => props.periodFQuarters || [1, 2, 3, 4], [props.periodFQuarters])

  const isSobDetailsMandatory = useMemo(() => {
    // Retail SOB
    if (
      SOB_DETAILS_MANDATORY_OFFERINGS.includes(buttonCurrType) ||
      SOB_DETAILS_MANDATORY_CATEGORIES.includes(currentCat)
    ) {
      return true
    }

    const flags = props.partnerFlagsState
    const cat = currentCat
    const formats = props.formats
    const isSobFlagsEnabledInSubCat = isPartnerFlagActive(flags, formats, cat, false, false, true)

    return isSobFlagsEnabledInSubCat
  }, [buttonCurrType, currentCat, props.partnerFlagsState, props.formats])

  const isAlwaysExpanded = useMemo(() => {
    return currentCat === ROOM_CATEGORY || currentCat === AIPC_CATEGORY
  }, [currentCat])

  const currency = useMemo(() => {
    const qbrCurrency = props.quarterlyBusinessReviewCurrency || 'USD'

    return !props.isQuarterlyBusinessReviewMode ? commonCurrency : qbrCurrency
  }, [commonCurrency, props.isQuarterlyBusinessReviewMode, props.quarterlyBusinessReviewCurrency])

  const prevCategoryValueTypesLengthRef = useRef<number | null>(null)

  const actualsType = useMemo(() => {
    const categoryTypesLengthChanged =
      prevCategoryValueTypesLengthRef.current !== categoryValueTypes.length

    if (categoryTypesLengthChanged && categoryValueTypes.length > 0) {
      return categoryValueType
    }

    if (
      categoryValueTypes.length > 0 &&
      (commonActualsType === ActualsValueTypes.TNet ||
        commonActualsType === ActualsValueTypes.UTNet) &&
      !categoryValueTypes.includes(commonActualsType)
    ) {
      // Convert TNet and UTNet to Net if they are not in categoryValueTypes
      return ActualsValueTypes.Net
    }

    return commonActualsType
  }, [categoryValueType, categoryValueTypes, commonActualsType])

  useEffect(() => {
    prevCategoryValueTypesLengthRef.current = categoryValueTypes.length
  })

  const currentValueType = useMemo(() => {
    let calcualtedValueType = actualsType

    if (props.isQuarterlyBusinessReviewMode) {
      calcualtedValueType =
        (props.quarterlyBusinessReviewNetNdp as ActualsValueTypes) || DEFAULT_NETNDP_QBR
    }

    return calcualtedValueType
  }, [actualsType, props.isQuarterlyBusinessReviewMode, props.quarterlyBusinessReviewNetNdp])

  const isShowValueTypeWarning = useMemo(() => {
    return currentValueType !== commonActualsType
  }, [commonActualsType, currentValueType])

  const isTargetsChanged = useMemo(
    () => targetsItems.some((el) => !!el.IsChanged || !!el.IsChangedSoB),
    [targetsItems]
  )
  const isTargetsValuesChanged = useMemo(
    () => targetsItems.some((el) => !!el.IsChanged),
    [targetsItems]
  )
  const isActualsChanged = useMemo(
    () => actualsItems.some((el) => !!el.IsChanged || !!el.IsChangedSoB),
    [actualsItems]
  )
  const isDataChanged = useMemo(
    () => isTargetsChanged || isActualsChanged,
    [isActualsChanged, isTargetsChanged]
  )
  const isShowUnits = useMemo(
    () => !!props.dataSetInfo.IsUnitsAvailable,
    [props.dataSetInfo.IsUnitsAvailable]
  )
  const catNAField = useMemo(() => getCategoryNAField(currentCat), [currentCat])
  const isOverallOnly = useMemo(
    () =>
      !props.formats.filter((el) => !!el.SubCategory && el.SubCategory !== OVERALL_CATEGORY).length,
    [props.formats]
  )
  const isTargetsNotChanged = useMemo(
    () =>
      JSON.stringify(
        targetsItems.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0 }
        })
      ) ===
      JSON.stringify(
        reservedTargets.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0 }
        })
      ),
    [reservedTargets, targetsItems]
  )
  const isTargetsSignedNotChanged = useMemo(
    () =>
      JSON.stringify(
        targetsItems.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0, Comment: '' }
        })
      ) ===
      JSON.stringify(
        reservedTargets.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0, Comment: '' }
        })
      ),
    [reservedTargets, targetsItems]
  )
  const isActualsNotChanged = useMemo(
    () =>
      JSON.stringify(
        actualsItems.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0 }
        })
      ) ===
      JSON.stringify(
        reservedActuals.map((el) => {
          return { ...el, IsChanged: 0, IsChangedSoB: 0 }
        })
      ),
    [actualsItems, reservedActuals]
  )
  const isNotChanged = useMemo(
    () => isTargetsNotChanged && isActualsNotChanged,
    [isActualsNotChanged, isTargetsNotChanged]
  )

  useEffect(() => {
    onPlanningDirtyStateChange?.(currentCat, !isNotChanged)
  }, [currentCat, isNotChanged, onPlanningDirtyStateChange])

  useEffect(
    () => () => onPlanningDirtyStateChange?.(currentCat, false),
    [currentCat, onPlanningDirtyStateChange]
  )

  const isTargetSignedChanged = useMemo(
    () => isTargetsChanged && !isTargetsSignedNotChanged,
    [isTargetsChanged, isTargetsSignedNotChanged]
  )
  const isNeedToShowSignNADialog = useMemo(() => signed > -1, [signed])
  const isNeedToShowSignDialog = useMemo(
    () => isNeedToShowSignNADialog && isTargetSignedChanged,
    [isNeedToShowSignNADialog, isTargetSignedChanged]
  )
  const isTargetValuesReallyChanged = useMemo(
    () => isTargetsValuesChanged && !isTargetsNotChanged,
    [isTargetsNotChanged, isTargetsValuesChanged]
  )
  const isHideSoB = useMemo(
    () => partnerInfo?.CountryCode === HIDE_SOB_FOR_COUNTRY,
    [partnerInfo?.CountryCode]
  )
  const { isPartnerUser } = useUserRoles()

  const isCurrencyChanged = useMemo(
    () => !!props.originalCurrency && props.originalCurrency !== currency,
    [currency, props.originalCurrency]
  )
  const isActualsValueTypeChanged = useMemo(
    () => !!props.originalActualsValueType && props.originalActualsValueType !== currentValueType,
    [currentValueType, props.originalActualsValueType]
  )

  const isSwitchersChanged = useMemo(
    () => isTargetValuesReallyChanged && (isCurrencyChanged || isActualsValueTypeChanged),
    [isActualsValueTypeChanged, isCurrencyChanged, isTargetValuesReallyChanged]
  )
  const isRetailer = useMemo(() => buttonCurrType === ProgramTypes.Retail, [buttonCurrType])
  const isShowRetailerGtmPriorities = useMemo(
    () => IS_SHOW_RETAIL_GTM_PRIORITIES && isRetailer,
    [isRetailer]
  )

  const isFixedCollapsed = isCollapsed
  const isComposedSobDisabled = false

  const isNotApplicableAllowed = useMemo(
    () =>
      props.dataSetInfo.MandatoryType !== MANDATORY_CATEGORY &&
      props.dataSetInfo.MandatoryType !== MANDATORY_CATEGORY_ALWAYS_EXPANDED,
    [props.dataSetInfo.MandatoryType]
  )

  const applyButtonKey = useMemo(
    () => (isFixedCollapsed ? 'jbp-hr-save-overall' : 'jbp-hr-save-details'),
    [isFixedCollapsed]
  )

  const isEditAllowed = useMemo(
    () =>
      !props.readOnly &&
      isEditMode &&
      !props.composedReportMode &&
      !props.isQuarterlyBusinessReviewMode &&
      canEditPartner &&
      (!isRegionalDistributor || props.isRegionalPlanning) &&
      (!props.globalCategory || !!props.globalCategory.IsEditable) &&
      actualsType !== ActualsValueTypes.UTNet,
    [
      actualsType,
      canEditPartner,
      isEditMode,
      isRegionalDistributor,
      props.composedReportMode,
      props.globalCategory,
      props.isQuarterlyBusinessReviewMode,
      props.isRegionalPlanning,
      props.readOnly,
    ]
  )

  const isShowComposedModeSwitchers = useMemo(
    () => !!props.composedReportMode,
    [props.composedReportMode]
  )

  const shortPrevFY = useMemo(() => (fyear || 2000) - 2001, [fyear])
  const showPrevTargetsParams = useMemo(
    () => [{ key: '{prevFY}', value: shortPrevFY.toString() }],
    [shortPrevFY]
  )

  const isShowCurrencyCtrl = useMemo(
    () => !props.dataSetInfo.Settings?.HideCurrencyCtrl && !props.composedReportMode,
    [props.composedReportMode, props.dataSetInfo.Settings?.HideCurrencyCtrl]
  )
  const isShowNetNdpCtrl = useMemo(
    () => !props.dataSetInfo.Settings?.HideNetNdpCtrl && !props.composedReportMode,
    [props.composedReportMode, props.dataSetInfo.Settings?.HideNetNdpCtrl]
  )
  const isShowActualsCtrl = useMemo(
    () => !props.dataSetInfo.Settings?.HideActualsCtrl && !props.composedReportMode,
    [props.composedReportMode, props.dataSetInfo.Settings?.HideActualsCtrl]
  )
  const isShowQuotaCtrl = useMemo(
    () =>
      !IS_NEW_LNF &&
      !props.dataSetInfo.Settings?.HideQuotaCtrl &&
      !props.composedReportMode &&
      !props.isQuarterlyBusinessReviewMode,
    [
      props.composedReportMode,
      props.dataSetInfo.Settings?.HideQuotaCtrl,
      props.isQuarterlyBusinessReviewMode,
    ]
  )
  const isShowCurrencyBlock = useMemo(
    () => !props.dataSetInfo.Settings?.HideCurrencyBlock,
    [props.dataSetInfo.Settings?.HideCurrencyBlock]
  )
  const isShowSalesTypeCtrl = useMemo(
    () =>
      !props.dataSetInfo.Settings?.HideSalesTypeCtrl &&
      !props.composedReportMode &&
      !props.isEltMode,
    [props.composedReportMode, props.dataSetInfo.Settings?.HideSalesTypeCtrl, props.isEltMode]
  )

  const isShowPrevTargetsCtrl = useMemo(
    () => !IS_NEW_LNF && !props.isQuarterlyBusinessReviewMode,
    [props.isQuarterlyBusinessReviewMode]
  )

  const isShowCtrlBeforeActuals = useMemo(
    () => isShowCurrencyCtrl || isShowNetNdpCtrl,
    [isShowCurrencyCtrl, isShowNetNdpCtrl]
  )
  const isShowActualsCtrlFirst = useMemo(
    () => !isShowCtrlBeforeActuals && isShowActualsCtrl,
    [isShowActualsCtrl, isShowCtrlBeforeActuals]
  )
  const isShowQuotaCtrlFirst = useMemo(
    () => !isShowCtrlBeforeActuals && !isShowActualsCtrl && isShowQuotaCtrl,
    [isShowActualsCtrl, isShowCtrlBeforeActuals, isShowQuotaCtrl]
  )
  const isShowDistributorCtrlFirst = useMemo(
    () => !isShowCtrlBeforeActuals && !isShowActualsCtrl && !isShowQuotaCtrl,
    [isShowActualsCtrl, isShowCtrlBeforeActuals, isShowQuotaCtrl]
  )

  const isOveralledCategory = useMemo(
    () =>
      props.formats.length === 1 &&
      !props.formats.some((el) => el.SubCategory === OVERALL_CATEGORY),
    [props.formats]
  )
  const isShowComposedReportCollapsedWarning = useMemo(
    () =>
      IS_SHOW_COMPOSED_REPORT_EXPANDED_WARNING &&
      props.composedReportMode &&
      !isRecalcPlans &&
      !isFixedCollapsed &&
      !isOveralledCategory,
    [isFixedCollapsed, isOveralledCategory, isRecalcPlans, props.composedReportMode]
  )

  const isMandatoryByFlagLogic = useMemo(() => fyear >= SST_MANDATORY_LOGIC_FYEAR, [fyear])
  const isSoBNewLogic = useMemo(() => fyear >= SOB_NEW_LOGIC_FYEAR, [fyear])

  // Show PrevFY and Cals Actuals logic
  const isShowCalcActuals = useMemo(
    () =>
      IS_SHOW_PREV_RECALC_ACTUALS &&
      fyear > jbpSettings.fYear &&
      jbpSettings.currentFQuarter === 4 &&
      !props.composedReportMode,
    [fyear, jbpSettings.currentFQuarter, jbpSettings.fYear, props.composedReportMode]
  )
  const planningColSpan = useMemo(
    () => PLANNING_COL_NUMBER + (isShowCalcActuals ? 1 : 0),
    [isShowCalcActuals]
  )

  const isUseContractuals = useMemo(() => {
    const flags = partnerInfo?.PartnerFlags || ''
    const isContrByFlag = isContractualsByFlag(flags, props.partnerFlagsState)
    const isStandartContractualPlanning =
      buttonCurrType === ProgramTypes.CorePrint &&
      currentCat === CONTRACTUAL_CATEGORY &&
      (props.isContractualPlanning || isContrByFlag)

    const isDistributorExtendedPlanning =
      props.isDistributorPlanner && !!jbpSettings.distributorExtendedPlanning

    return props.isDistributorPlanner
      ? isDistributorExtendedPlanning
      : isStandartContractualPlanning
  }, [
    partnerInfo?.PartnerFlags,
    props.partnerFlagsState,
    props.isContractualPlanning,
    props.isDistributorPlanner,
    buttonCurrType,
    currentCat,
    jbpSettings.distributorExtendedPlanning,
  ])

  const isShowAllSplitsCtrl = useMemo(
    () => isUseContractuals && splitType === 'Total',
    [isUseContractuals, splitType]
  )
  const isShowContrTrans = useMemo(
    () => isShowAllSplitsCtrl && isShowAllSplits,
    [isShowAllSplits, isShowAllSplitsCtrl]
  )
  const isEditFixed = useMemo(() => {
    const isEditContr = isEditAllowed && (!isUseContractuals || splitType !== 'Total')
    const isEditDistributor =
      isEditAllowed &&
      (!isUseContractuals ||
        (isShowContrTrans && splitType !== 'Total') ||
        (!isShowContrTrans && splitType !== 'Transactional'))

    return props.isDistributorPlanner ? isEditDistributor : isEditContr
  }, [isEditAllowed, isShowContrTrans, isUseContractuals, props.isDistributorPlanner, splitType])

  const isNoSplitPlans = useMemo(
    () => !isUseContractuals || splitType === 'Total',
    [isUseContractuals, splitType]
  )

  // Category title and tip keys
  const offeringName = useMemo(
    () => buttonCurrType || props.dataSetInfo.ProgramType,
    [buttonCurrType, props.dataSetInfo.ProgramType]
  )
  const offeringNameLower = useMemo(
    () => offeringName.replace(/\s/g, '').toLowerCase(),
    [offeringName]
  )
  const currentCatLower = useMemo(() => currentCat.replace(/\s/g, '').toLowerCase(), [currentCat])

  const globalCategoryKey = useMemo(() => {
    let key = props.globalCategory?.GlobalCategory
    if (
      props.globalCategory &&
      !!props.globalCategory.GlobalSubCategory &&
      props.globalCategory.GlobalSubCategory !== OVERALL_CATEGORY &&
      props.globalCategory.GlobalSubCategory !== GLOBAL_TOTAL_CATEGORY
    ) {
      key = props.globalCategory.GlobalSubCategory
    }

    return key
  }, [props.globalCategory])

  const globalShortKey = useMemo(() => {
    const key = (globalCategoryKey || '').replace(/jbp-/g, '')

    return !key ? `jbp-${offeringNameLower}` : `jbp-${offeringNameLower}-${key}`
  }, [globalCategoryKey, offeringNameLower])

  const globalKey = useMemo(
    () => `${globalShortKey}-${currentCatLower}`,
    [currentCatLower, globalShortKey]
  )
  const headerKey = useMemo(
    () => (!partnerInfo?.IsGlobal ? currentCat : globalKey),
    [currentCat, globalKey, partnerInfo?.IsGlobal]
  )
  const globalCategoryTipPrefix = useMemo(
    () => (!partnerInfo?.IsGlobal ? '' : globalShortKey),
    [globalShortKey, partnerInfo?.IsGlobal]
  )

  // Header key
  const headerComposedSuffix = useMemo(
    () => (props.composedReportMode ? '-composed' : '-editor'),
    [props.composedReportMode]
  )
  const headerSuffix = useMemo(
    () => (props.isQuarterlyBusinessReviewMode ? '-qbr' : headerComposedSuffix),
    [headerComposedSuffix, props.isQuarterlyBusinessReviewMode]
  )
  const categoryHeaderKey = useMemo(() => `${headerKey}${headerSuffix}`, [headerKey, headerSuffix])
  const categoryUnitsHeaderKey = useMemo(() => `${categoryHeaderKey}-units`, [categoryHeaderKey])

  const isShowInformationBanners = useMemo(() => {
    return (
      IS_SHOW_INFORMATION_BANNERS &&
      !props.composedReportMode &&
      !props.isQuarterlyBusinessReviewMode
    )
  }, [props.composedReportMode, props.isQuarterlyBusinessReviewMode])

  const isShowMapRow = useMemo(() => {
    return !isPartnerUser && !props.composedReportMode && !props.isQuarterlyBusinessReviewMode
  }, [isPartnerUser, props.composedReportMode, props.isQuarterlyBusinessReviewMode])

  const isShowFutureYears = useMemo(() => {
    return (
      props.isShowFutureYearsPlans &&
      fyear > 2024 &&
      !isRetailer &&
      (!props.isQuarterlyBusinessReviewMode || !!props.isEltMode)
    )
  }, [
    fyear,
    isRetailer,
    props.isEltMode,
    props.isQuarterlyBusinessReviewMode,
    props.isShowFutureYearsPlans,
  ])

  const isExistControlsAfterRounding = useMemo(
    () =>
      (isShowActualsCtrl && !IS_ALWAYS_SHOW_ACTUALS) ||
      isShowQuotaCtrl ||
      (isDistributor && isRegionalDistributor) ||
      isShowComposedModeSwitchers ||
      isShowPrevTargetsCtrl ||
      (isShowComposedModeSwitchers && IS_USE_RECALC_PLANS_FROM_BOTTOM_FUNCTIONALITY),
    [
      isDistributor,
      isRegionalDistributor,
      isShowActualsCtrl,
      isShowComposedModeSwitchers,
      isShowPrevTargetsCtrl,
      isShowQuotaCtrl,
    ]
  )

  const commonExtraRowsProps = useMemo(() => {
    return {
      isDistributorPlanner: props.isDistributorPlanner,
      isShowPartnerCount,

      isShowYoYActualsVsActuals,
      isShowYoYActualsVsPlans,
      isShowYoYPlansVsPlans,
      isShowYoYQuotaVsActuals,

      isShowPlanAchievement,
      isShowQuotaAchievement,

      isShowQoQActualsVsActuals,
      isShowQoQActualsVsPlans,
      isShowQoQPlansVsPlans,
      isShowQoQQuotaVsActuals,
    }
  }, [
    props.isDistributorPlanner,
    isShowPartnerCount,
    isShowPlanAchievement,
    isShowQoQActualsVsActuals,
    isShowQoQActualsVsPlans,
    isShowQoQPlansVsPlans,
    isShowQoQQuotaVsActuals,
    isShowQuotaAchievement,
    isShowYoYActualsVsActuals,
    isShowYoYActualsVsPlans,
    isShowYoYPlansVsPlans,
    isShowYoYQuotaVsActuals,
  ])

  const validationInputsCount = useMemo(() => {
    return Array.from(new Set(validationErrors.map((el) => el.inputIndex))).length
  }, [validationErrors])

  /**
   * True when current date is before 1 November of (jbpSettings.currentFYear - 1)
   */
  const isActualsFq4Come = useMemo(() => {
    const compareYear = jbpSettings.currentFYear - 1
    const cutoff = new Date(compareYear, 10, 1) // month is 0-based: 10 => November

    return new Date() >= cutoff
  }, [jbpSettings.currentFYear])

  const isShowCategoryValueTypes = useMemo(() => {
    return !!categoryValueTypes.length
  }, [categoryValueTypes.length])

  /** -------------------- Methods ----------------------- */

  const handleChangeCategoryValueType = useCallback(
    (value: ActualsValueTypes) => {
      setCategoryValueType(value)

      if (
        value === ActualsValueTypes.Net &&
        (commonActualsType === ActualsValueTypes.TNet ||
          commonActualsType === ActualsValueTypes.Net)
      ) {
        return
      }

      onChangeActualsType(value)
    },
    [commonActualsType, onChangeActualsType]
  )

  const generateTranslationKey = useCallback((option: string) => {
    const suffix = option.trim().replace(/\s/g, '').toLowerCase()

    return `${PLAN_SECTION_KEY}-displaymode-${suffix}`
  }, [])

  const { updatePendingData, registrUrlDeps } = useTargetsUrlDeps({
    resetChanged: () => {
      setTargetsItems(reservedTargets)
      setActualsItems(reservedActuals)
    },
    apply: () => {
      applyChangesHandler()
    },
    changed: isDataChanged,
    isNotChanged,
    urlDeps: PLANNING_URL_DEPS,
    isCancelIfChanged: true,
  })

  registrUrlDeps(context)

  const getL3Index = (format: IFormActualsTargetsSettings) => {
    let idx = 0
    let subCategory = ''
    let isFormatFound = false

    props.formats
      .filter((el) => !!el.L3Category)
      .filter((el) => el.Category === format.Category)
      .forEach((el) => {
        if (subCategory !== el.SubCategory && !isFormatFound) {
          subCategory = el.SubCategory
          if (el.SubCategory === format.SubCategory) {
            isFormatFound = true
          } else {
            idx++
          }
        }
      })

    return idx
  }

  const isCategoryNA = useMemo(() => {
    let isNotApplicable = isNotApplicableAllowed

    if (partnerInfo) {
      const sectionSetting = sectionSettings[catNAField]
      if (sectionSetting == undefined || sectionSetting == null) {
        // sectionSettings Not defined
        if (hideIfEmpty && !isDataPresent) {
          return true
        } else {
          // Not hideIfEmpty or dataPresent > use Original behave
          isNotApplicable = isNotApplicable && isSectionSettingOn(sectionSetting)
        }
      } else {
        // sectionSettings defined > use Original behave
        isNotApplicable = isNotApplicable && isSectionSettingOn(sectionSetting)
      }
    }

    return (
      !IS_SHOW_NOT_APPLICABLE &&
      isNotApplicable &&
      !props.composedReportMode &&
      !props.isQuarterlyBusinessReviewMode
    )
  }, [
    catNAField,
    sectionSettings,
    hideIfEmpty,
    isDataPresent,
    isNotApplicableAllowed,
    partnerInfo,
    props.composedReportMode,
    props.isQuarterlyBusinessReviewMode,
  ])

  const isShowNotApplicableMessage = useMemo(() => {
    return !IS_SHOW_NOT_APPLICABLE && isNotApplicableAllowed && isCategoryNA
  }, [isNotApplicableAllowed, isCategoryNA])

  const isShowNotApplicableWidget = useMemo(() => {
    return IS_SHOW_NOT_APPLICABLE && isNotApplicableAllowed
  }, [isNotApplicableAllowed])

  const isOn = useCallback(
    (key: string, type: TSettingsSuffix, defaultValue: boolean = false) => {
      let settingValue = defaultValue

      if (partnerInfo) {
        const field = getNAField(key, type)
        const val = sectionSettings[field]
        if (val !== undefined && val !== null) {
          settingValue = isSectionSettingOn(val)
        }
      }

      return settingValue
    },
    [partnerInfo, sectionSettings]
  )

  const isQuarterDefaultOn = useMemo(() => {
    return IS_QUARTER_DEFAULT && !isRetailer
  }, [isRetailer])

  const isOnlyQuarterlyPlanning = useMemo(() => {
    return !!props.dataSetInfo.IsOnlyQuarterlyPlanning && jbpSettings.currentFYear === fyear
  }, [fyear, jbpSettings.currentFYear, props.dataSetInfo.IsOnlyQuarterlyPlanning])

  const isQuarterPlanning = useMemo(() => {
    return (
      !isYearlyPlanning &&
      (isOnlyQuarterlyPlanning || isOn(currentCat, 'quarter', isQuarterDefaultOn))
    )
  }, [currentCat, isOn, isOnlyQuarterlyPlanning, isQuarterDefaultOn, isYearlyPlanning])

  const isShowApplySection = !isCategoryNA && isEditAllowed
  const isShowQbrUnits =
    !!props.isQuarterlyBusinessReviewMode && !!props.isQuarterlyBusinessReviewUnits
  const isShowUnitsOnPlanning = isShowUnits && !isCategoryNA && isOn(currentCat, 'units')
  const isShowUnitsSection =
    isShowUnitsOnPlanning || isShowQbrUnits || !!props.dataSetInfo.IsHideFinancial
  const isShowPlanningSection =
    !props.dataSetInfo.IsHideFinancial &&
    (!props.isQuarterlyBusinessReviewMode || !props.isQuarterlyBusinessReviewUnits)
  const isShowApplyBeforeUnits = isShowApplySection && isShowUnitsSection && isShowPlanningSection
  const isShowControlsBeforeUnits = !!props.dataSetInfo.IsHideFinancial && isEditAllowed

  const renderSmbVsEuSplitRows = (
    [smbValue, euValue]: [number, number],
    rounding: string,
    tip: string = ''
  ) => <div className={styles.itemActual}>{smbVsEuWrapper(smbValue, euValue, rounding, tip)}</div>

  const preparePlanningData = useCallback(async () => {
    dispatch(changeFinSobIsCategoryPlanningDataLoading(true))

    setValidationStatus(ValidationStatus.Valid)

    const isComposedReport = !!props.composedReportMode
    const isQuarterlyBusinessReview = !!props.isQuarterlyBusinessReviewMode

    let filteredData = props.planningData.filter(
      (el) =>
        (el.ProgramTypes === buttonCurrType || isComposedReport || isQuarterlyBusinessReview) &&
        el.Category === currentCat &&
        !el.IsTotal &&
        (!props.globalCategory || el.GlobalCategory === globalCategoryKey)
    )

    const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

    if (!isIgnorePartnerId) {
      // Show distributor's group data for Regional Distributor:
      // Get data from all Partner in group, Except Regional Distributor
      if (isRegionalDistributor && !props.isRegionalPlanning) {
        filteredData = filteredData.filter((el) => el.PartnerId !== partnerId)
      } else {
        filteredData = filteredData.filter((el) => el.PartnerId === partnerId)
      }
    }

    // Separation into Target, Actuals, Quota data
    const rawTargets = filteredData.filter(
      (el) =>
        !!el.IsTarget && (!isComposedReport || !el.IsNoSplit) && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawActuals = filteredData.filter(
      (el) =>
        !!el.IsActuals && (!isComposedReport || !el.IsNoSplit) && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawQuota = filteredData.filter(
      (el) =>
        !!el.IsQuota && (!isComposedReport || !el.IsNoSplit) && !el.IsRollUp && !el.IsPartnerCount
    )
    // Separation into NoSplit, RollUp, PartnerCount data
    const rawTargetsNoSplit = filteredData.filter(
      (el) => !!el.IsNoSplit && !!el.IsTarget && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawActualsNoSplit = filteredData.filter(
      (el) => !!el.IsNoSplit && !!el.IsActuals && !el.IsRollUp && !el.IsPartnerCount
    )
    const rawTargetsRollup = filteredData.filter((el) => !!el.IsRollUp && !!el.IsTarget)
    const rawActualsRollup = filteredData.filter((el) => !!el.IsActuals && !!el.IsRollUp)
    const rawActualsPartnerCount = filteredData.filter(
      (el) => !!el.IsPartnerCount && !!el.IsActuals
    )

    const futureYears = isShowFutureYears ? 2 : 0
    const lastFYear = fyear + futureYears

    const commonParams: IPreparePlanningItems = {
      planningSettings: props.formats,
      source: rawTargets,
      partnerId: partnerId,
      fyear: fyear,
      lastFYear: lastFYear,
      isActuals: 0,
      isDirect: 0,
      isTarget: 1,
      isQuota: 0,
      isComposedReport: isComposedReport,
      isNoSplit: 0,
      isRollUp: 0,
      isTotal: 0,
      isPartnerCount: 0,
      globalCategory: globalCategoryKey,
      smbFraction: SMBFractionTypes.Total,
    }

    // Prepare Target, Actuals, Quota data
    const targetsItems = preparePlanningItems(commonParams)
    const actualsItems = preparePlanningItems({
      ...commonParams,
      source: rawActuals,
      isTarget: 0,
      isActuals: 1,
    })
    const quotaItems = preparePlanningItems({
      ...commonParams,
      source: rawQuota,
      isTarget: 0,
      isQuota: 1,
    })
    // Prepare NoSplit, RollUp, PartnerCount data
    const actualsNoSplitItems = preparePlanningItems({
      ...commonParams,
      source: rawActualsNoSplit,
      isTarget: 0,
      isActuals: 1,
      isNoSplit: 1,
    })
    const targetsNoSplitItems = preparePlanningItems({
      ...commonParams,
      source: rawTargetsNoSplit,
      isNoSplit: 1,
    })
    const targetsRollupItems = preparePlanningItems({
      ...commonParams,
      source: rawTargetsRollup,
      isRollUp: 1,
    })
    const actualsRollupItems = preparePlanningItems({
      ...commonParams,
      source: rawActualsRollup,
      isTarget: 0,
      isActuals: 1,
      isRollUp: 1,
    })
    const actualsPartnerCountItems = preparePlanningItems({
      ...commonParams,
      source: rawActualsPartnerCount,
      isTarget: 0,
      isActuals: 1,
      isPartnerCount: 1,
    })
    // Prepare SMB vs EU split data: same source rows, narrowed by the fraction
    const actualsSmbItems = preparePlanningItems({
      ...commonParams,
      source: rawActuals,
      isTarget: 0,
      isActuals: 1,
      smbFraction: SMBFractionTypes.SMB,
    })
    const actualsEuItems = preparePlanningItems({
      ...commonParams,
      source: rawActuals,
      isTarget: 0,
      isActuals: 1,
      smbFraction: SMBFractionTypes.EU,
    })
    const targetsSmbItems = preparePlanningItems({
      ...commonParams,
      source: rawTargets,
      smbFraction: SMBFractionTypes.SMB,
    })
    const targetsEuItems = preparePlanningItems({
      ...commonParams,
      source: rawTargets,
      smbFraction: SMBFractionTypes.EU,
    })

    setTargetsItems(targetsItems)
    setActualsItems(actualsItems)
    setQuotaItems(quotaItems)
    setActualsNoSplitItems(actualsNoSplitItems)
    setTargetsNoSplitItems(targetsNoSplitItems)
    setTargetsRollupItems(targetsRollupItems)
    setActualsRollupItems(actualsRollupItems)
    setActualsPartnerCountItems(actualsPartnerCountItems)
    setActualsSmbItems(actualsSmbItems)
    setActualsEuItems(actualsEuItems)
    setTargetsSmbItems(targetsSmbItems)
    setTargetsEuItems(targetsEuItems)

    setReservedTargets([
      ...targetsItems.map((el) => {
        return { ...el }
      }),
    ])
    setReservedActuals([
      ...actualsItems.map((el) => {
        return { ...el }
      }),
    ])

    if (rawTargets.filter((el) => el.FYear === fyear).length) {
      const isCollapsedCategory = getIsCollapsedCategory(targetsItems, fyear)
      setIsCollapsed(isCollapsedCategory && isCollapseAllowed)
    }

    // Begin: calculate hideIfEmpty, dataNotEmpty
    let hideEmptyData: boolean = false
    if (props.formats) {
      props.formats.map((el) => {
        if (!!el.HideIfEmpty && !hideIfEmpty) {
          setHideIfEmpty(true)
          hideEmptyData = true
        }
      })
    }

    if (hideEmptyData) {
      let isDataPresent = false
      targetsItems.map((el) => {
        if (el.IsDataPresent) {
          isDataPresent = true
        }
      })
      setIsDataPresent(isDataPresent)
    }
    // End: calculate hideIfEmpty, dataNotEmpty

    dispatch(changeFinSobIsCategoryPlanningDataLoading(false))
  }, [
    dispatch,
    props.composedReportMode,
    props.isQuarterlyBusinessReviewMode,
    props.planningData,
    props.formats,
    props.globalCategory,
    props.isRegionalPlanning,
    fyear,
    partnerId,
    buttonCurrType,
    currentCat,
    isRegionalDistributor,
    isCollapseAllowed,
    hideIfEmpty,
  ])

  const getRowSum = (settingsIndex: number, isGetUnits: boolean) => {
    let sum = 0

    const sumParam: IGetTwoYearsSum = {
      formats: props.formats,
      settingsIndex,
      items: actualsItems,
      fyear,
      isGetUnits,
      isAddContractual: false,

      actualsType,
      isDirect: false,

      isComposedCompletedPlans: false,
      isComposedSob: false,
    }

    sum += getTwoYearsSum({ ...sumParam, items: actualsItems })
    sum += getTwoYearsSum({ ...sumParam, items: targetsItems })
    sum += getTwoYearsSum({ ...sumParam, items: quotaItems })

    return sum
  }

  /**
   * Is Overall Value for Current FY Exist and Not changed
   */
  const isOverallValueNotChanged = (partnerInfo: IFormPartnerBasicInfo | undefined): boolean => {
    let isNotChanged = false

    if (partnerInfo) {
      const valueTypeSuffix = currentValueType.toLowerCase() === 'ndp' ? 'Ndp' : 'Net'
      const currencySuffix = !currency || currency === 'USD' ? 'Usd' : 'Lc'
      const originalValueField = `OfficeHWPlan${valueTypeSuffix}${currencySuffix}`
      const originalValue = partnerInfo[originalValueField]
      if (originalValue || originalValue === 0) {
        const overallSettings = props.formats.filter(
          (el) =>
            el.ProgramType === buttonCurrType &&
            el.Category === currentCat &&
            (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
        )
        if (overallSettings.length) {
          const overallSetting = overallSettings[0]

          const sType = '' // Total
          const fq = 5 // FY Value
          const isUnits = false
          const isSoB = false
          const isDirect = false

          const newValue = getPlanValue(
            overallSetting,
            targetsItems,
            partnerId,
            fyear,
            fq,
            currentValueType,
            isUnits,
            currency,
            isFixedCollapsed,
            sType,
            isSoB,
            isDirect,
            isShowOnlyCompletedPlans,
            isShowComposedSoB,
            isRecalcPlans,
            props.composedReportMode,
            props.isQuarterlyBusinessReviewMode
          )

          if (newValue === originalValue) {
            isNotChanged = true
          }
        }
      }
    }

    return isNotChanged
  }

  const applyChanges = async (
    targetsData: IJBPPlanningItem[],
    actualsData: IJBPPlanningItem[] | null = null
  ) => {
    dispatch(changeFinSobIsCategoryPlanningApplyingChangesLoading(true))
    setIsChangeApplying(true)
    let isPlanningSaved = false

    try {
      const fromFYear = Math.max(fyear - PLAN_REQUEST_FOR_PREV_YEARS, P360_FIRST_FYEAR)
      const isUSD = !currency || currency === 'USD'
      const cleanTargets = cleanPlanningItemForApi(targetsData, fyear, isFixedCollapsed)
      const cleanActuals = cleanPlanningItemForApi(
        actualsData ?? actualsItems,
        fyear,
        isFixedCollapsed
      )

      const isTargetsChanged = cleanTargets.some((el) => !!el.IsChanged || !!el.IsChangedSoB)
      const isActualsSobChanged = cleanActuals.some((el) => !!el.IsChangedSoB)
      const isMandatoryFiledsChanged = isTargetsChanged || isActualsSobChanged

      const cleanData = [...cleanTargets, ...cleanActuals]
      const json = JSON.stringify(cleanData)

      const applyResponse = await applyJBPPlanning<IJBPPlanning>(
        partnerId,
        fyear,
        fromFYear,
        buttonCurrType,
        isQuarterPlanning,
        isUSD,
        currentValueType,
        isRegionalDistributor,
        json
      )
      isPlanningSaved = true

      if (partnerInfo?.IsGlobal) {
        dispatch(requestGlobalPartnerData({ partnerId, fYear: fyear }))
      }

      if (props.onApply) {
        const newData: IJBPPlanning[] = applyResponse?.Rows || []
        props.onApply(newData)
      }

      const isDropSignature =
        isTargetsChanged && signed > -1 && !isOverallValueNotChanged(partnerInfo)

      if (isDropSignature) {
        await dropSignature('Financial & SOB Targets')
      }

      if (isMandatoryFiledsChanged) {
        try {
          await dispatch(requestRecalculateCompleteness({ partnerId, fYear: fyear })).unwrap()
        } catch (error) {
          Logger.error(error)
          NotificationController.showWarning({
            message:
              'Planning data was saved, but completeness could not be updated. Please refresh the page later.',
          })
        }
      }

      const isRoundingNeedToSave =
        IS_ENABLE_ROUNDING && props.roundingValue !== props.roundingValueOriginal
      if (isRoundingNeedToSave) {
        // The value itself (AsIs | K | M) goes under the key that Planning reads.
        await dispatch(
          updateSectionSettings({
            flag: getRoundingField(buttonCurrType),
            state: props.roundingValue || PlanningRounding.AsIs,
            controlName: 'Planning',
          })
        )
      }

      dispatch(
        requestCompletenessStatusForFinSobSidePanelItem({
          partnerId,
          programType: buttonCurrType,
          fYear: fyear,
          category: currentCat,
        })
      )
      dispatch(invalidateFinancialCockpitData())

      if (partnerInfo?.OfficeHWPlanNdpUsd && props?.onReloadPartnerInfo) {
        props.onReloadPartnerInfo()
      }
    } catch (error) {
      Logger.error(error)

      if (isPlanningSaved) {
        NotificationController.showWarning({
          message:
            'Planning data was saved, but post-save updates failed. Please refresh the page later.',
        })
      } else {
        NotificationController.showError({
          message: 'Planning data was not saved. Please try again.',
        })
      }
    } finally {
      setIsChangeApplying(false)
      dispatch(changeFinSobIsCategoryPlanningApplyingChangesLoading(false))

      if (isPlanningSaved) {
        props.onSaveSuccess?.()
      }
    }
  }

  /**
   * Obsolete, use getFinSobValue
   */
  const getValue = (
    settingsIndex: number,
    type: 'actuals' | 'targets' | 'quota',
    fy: number,
    fq: number,
    isUnits: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean,
    isRollUp: boolean,
    isDirect: boolean,
    fieldName?: string,
    smbFraction: SMBFractionTypes = SMBFractionTypes.Total
  ): number => {
    let items = !isNoSplit ? targetsItems : targetsNoSplitItems

    if (type === 'actuals') {
      items = !isNoSplit ? actualsItems : actualsNoSplitItems
    }
    if (type === 'quota') {
      items = quotaItems
    }
    if (isRollUp) {
      if (type === 'actuals') {
        items = actualsRollupItems
      } else {
        items = targetsRollupItems
      }
    }
    // SMB vs EU split has its own datasets, only for plain Actuals / Targets
    if (smbFraction !== SMBFractionTypes.Total && type !== 'quota' && !isNoSplit && !isRollUp) {
      const isSmb = smbFraction === SMBFractionTypes.SMB
      if (type === 'actuals') {
        items = isSmb ? actualsSmbItems : actualsEuItems
      } else {
        items = isSmb ? targetsSmbItems : targetsEuItems
      }
    }

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]
      return getPlanValue(
        setting,
        items,
        partnerId,
        fy,
        fq,
        currentValueType,
        isUnits,
        currency,
        isFixedCollapsed,
        sType,
        isSoB,
        isDirect,
        isShowOnlyCompletedPlans,
        isShowComposedSoB,
        isRecalcPlans,
        props.composedReportMode,
        props.isQuarterlyBusinessReviewMode,
        fieldName
      )
    } else {
      return 0
    }
  }

  const getCalcActuals = (
    settingsIndex: number,
    fy: number,
    isUnits: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean,
    isDirect: boolean,
    smbFraction: SMBFractionTypes = SMBFractionTypes.Total
  ): number => {
    const actualQ1 = getValue(
      settingsIndex,
      'actuals',
      fy,
      1,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      false,
      isDirect,
      undefined,
      smbFraction
    )
    const actualQ2 = getValue(
      settingsIndex,
      'actuals',
      fy,
      2,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      false,
      isDirect,
      undefined,
      smbFraction
    )
    const actualQ3 = getValue(
      settingsIndex,
      'actuals',
      fy,
      3,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      false,
      isDirect,
      undefined,
      smbFraction
    )
    const targetQ4 = getValue(
      settingsIndex,
      'targets',
      fy,
      4,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      false,
      isDirect,
      undefined,
      smbFraction
    )

    return actualQ1 == null && actualQ2 == null && actualQ3 == null && targetQ4 == null
      ? targetQ4
      : (actualQ1 || 0) + (actualQ2 || 0) + (actualQ3 || 0) + (targetQ4 || 0)
  }

  // SMB vs EU split: both values come from their own sp rows, the Total row is not
  // their exact sum, so each fraction has to be read separately
  const getSmbEuValues = (
    settingsIndex: number,
    type: 'actuals' | 'targets',
    fy: number,
    fq: number,
    isUnits: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean,
    isRollUp: boolean
  ): [number, number] => [
    getValue(
      settingsIndex,
      type,
      fy,
      fq,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      isRollUp,
      false,
      undefined,
      SMBFractionTypes.SMB
    ),
    getValue(
      settingsIndex,
      type,
      fy,
      fq,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      isRollUp,
      false,
      undefined,
      SMBFractionTypes.EU
    ),
  ]

  const getCalcActualsSmbEu = (
    settingsIndex: number,
    fy: number,
    isUnits: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean
  ): [number, number] => [
    getCalcActuals(
      settingsIndex,
      fy,
      isUnits,
      sType,
      isSoB,
      isNoSplit,
      false,
      SMBFractionTypes.SMB
    ),
    getCalcActuals(settingsIndex, fy, isUnits, sType, isSoB, isNoSplit, false, SMBFractionTypes.EU),
  ]

  const formatPlanningSmbMoney = useCallback(
    (value: number) => {
      const smbRounding = props.rounding || props.roundingValue

      return formatMoneyInteger(value, getFractionDigits(smbRounding), getDivisor(smbRounding))
    },
    [props.rounding, props.roundingValue]
  )

  const getFinSobProps = (): ICheckFinSobValues => {
    const finSobProps: ICheckFinSobValues = {
      programType: buttonCurrType,
      category: currentCat,

      targetsItems,
      targetsNoSplitItems,
      actualsItems,
      actualsNoSplitItems,
      quotaItems,
      targetsRollupItems: targetsRollupItems,
      actualsRollupItems: actualsRollupItems,
      actualsPartnerCountItems,

      actualsSmbItems,
      actualsEuItems,
      targetsSmbItems,
      targetsEuItems,

      formats: props.formats,
      partnerId,
      actualsType: currentValueType,
      currency,
      isCollapsed, // Or use isFixedCollapsed?
      isShowOnlyCompletedPlans,
      isShowComposedSoB,
      isRecalcPlans,
      isComposedReportMode: props.composedReportMode,
      isQuarterlyBusinessReviewMode: props.isQuarterlyBusinessReviewMode,
      currentFQuarter: jbpSettings.currentFQuarter,

      settingsIndex: 0,
      type: 'targets',
      fy: fyear,
      fq: 0,
      isUnits: false,
      sType: '',
      isSoB: false,
      isNoSplit: false,
      isRollUp: false,
      isDirect: false,
      fieldName: '',
      partnerFlags: getPartnerFlags(partnerInfo),
      isUseContractuals,
      isDistributorPlanner: props.isDistributorPlanner,
    }

    return finSobProps
  }

  const checkPolyPlanningLevel = () => {
    let checkPolyPlanningLevelType = ''

    let polyPlanningLevel = ''
    const polyPlanningLevelItem = props.additionalInfo?.find(
      (el) => el[AdditionalInfoKeys.PolyPlanningLevel]
    )
    if (polyPlanningLevelItem) {
      polyPlanningLevel = polyPlanningLevelItem[AdditionalInfoKeys.PolyPlanningLevel]
    }

    if (
      !!partnerInfo?.IsGlobal &&
      !!props.globalCategory?.GlobalCategory &&
      !!props.additionalInfo?.length &&
      ((props.globalCategory?.GlobalCategory === POLY_CATEGORY &&
        polyPlanningLevel !== 'Category') ||
        (POLY_SUB_CATEGORIES.indexOf(props.globalCategory?.GlobalCategory) >= 0 &&
          polyPlanningLevel !== 'SubCategory'))
    ) {
      checkPolyPlanningLevelType = polyPlanningLevel
    }

    return checkPolyPlanningLevelType
  }

  const getValueFrom = (
    settingsIndex: number,
    type: 'actuals' | 'targets' | 'quota',
    fy: number,
    fq: number,
    isNoSplit: boolean,
    isRollUp: boolean,
    fieldName: 'Comment' = 'Comment'
  ): string => {
    let result = ''

    let items = !isNoSplit ? targetsItems : targetsNoSplitItems
    if (type === 'actuals') {
      items = !isNoSplit ? actualsItems : actualsNoSplitItems
    }
    if (type === 'quota') {
      items = quotaItems
    }
    if (isRollUp) {
      if (type === 'actuals') {
        items = actualsRollupItems
      } else {
        items = targetsRollupItems
      }
    }

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )

      if (sourceData.length >= 1) {
        result = sourceData[0][fieldName] ?? ''
      } else {
        // error in data
      }
    }

    return result
  }

  const setCustomField = (
    settingsIndex: number,
    value: string | null,
    fy: number,
    fq: number,
    customField: string,
    valueType: 'actuals' | 'targets' | 'quota'
  ): IJBPPlanningItem[] | null => {
    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      const isActuals = valueType === 'actuals'
      const isSob = customField === CustomFields.JustifySob
      const items = isActuals ? actualsItems : targetsItems

      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )

      if (sourceData.length >= 1) {
        // Comment is not changing SoB
        const newItem = isSob
          ? { ...sourceData[0], [customField]: value, IsChangedSoB: 1 }
          : { ...sourceData[0], [customField]: value, IsChanged: 1 }
        const data = [...items]
        const idx = items.indexOf(sourceData[0])
        data.splice(idx, 1, newItem)

        isActuals ? setActualsItems([...data]) : setTargetsItems([...data])

        return [...data]
      } else {
        // error in data
      }
    }

    return null
  }

  const setIsL3Collapsed = (sIdx: number, newValue: boolean, fy: number) => {
    if (!props.composedReportMode) {
      const { isUpdated, updatedItems } = setIsL3CollapsedInternal(targetsItems, sIdx, newValue, fy)
      if (isUpdated) {
        setTargetsItems(updatedItems)
      }
    } else {
      // For right re-calculation in composedReportMode

      const { isUpdated: isUpdTarCurFY, updatedItems: updTarCurFY } = setIsL3CollapsedInternal(
        targetsItems,
        sIdx,
        newValue,
        fy
      )
      const { isUpdated: isUpdTarPreFY, updatedItems: updTargets } = setIsL3CollapsedInternal(
        updTarCurFY,
        sIdx,
        newValue,
        fy - 1
      )
      if (isUpdTarCurFY || isUpdTarPreFY) {
        setTargetsItems(updTargets)
      }

      const { isUpdated: isUpdActCurFY, updatedItems: updActCurFY } = setIsL3CollapsedInternal(
        actualsItems,
        sIdx,
        newValue,
        fy
      )
      const { isUpdated: isUpdActPreFY, updatedItems: updActuals } = setIsL3CollapsedInternal(
        updActCurFY,
        sIdx,
        newValue,
        fy - 1
      )
      if (isUpdActCurFY || isUpdActPreFY) {
        setActualsItems(updActuals)
      }
    }
  }

  const setIsL3CollapsedInternal = (
    items: IJBPPlanningItem[],
    sIdx: number,
    newValue: boolean,
    fy: number
  ): { isUpdated: boolean; updatedItems: IJBPPlanningItem[] } => {
    return updateL3CollapsedItems({
      items,
      formats: props.formats,
      settingsIndex: sIdx,
      newValue,
      fy,
      partnerId,
      isIgnorePartnerId: !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode,
    })
  }

  const setIsNoPlan = (sIdx: number, value: boolean, fy: number, isOvr: boolean, sType: TSType) => {
    if (sIdx < props.formats.length) {
      const setting = props.formats[sIdx]

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      const items = targetsItems
      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const targetForUpdate = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          //(el.SubCategory === setting.SubCategory || !!sType) && // All SubCategories rows for Contractual
          //(el.L3Category === setting.L3Category || !!sType) && // All L3 rows for Contractual
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy
        //el.FQuarter === fq // All quarters
      )

      if (targetForUpdate.length >= 1) {
        let data = [...items]

        const isNoPlanField = sType ? 'IsNoPlanContractual' : 'IsNoPlan'

        targetForUpdate.forEach((currItem) => {
          // IsNoPlan not changing SoB
          const newItem = { ...currItem, [isNoPlanField]: value ? 1 : 0, IsChanged: 1 }
          const idx = items.indexOf(currItem)
          data.splice(idx, 1, newItem)
        })

        if (!value) {
          // Update only IsNoPlan* fields
          setTargetsItems([...data])
        } else {
          // Clean Targets Contractual for all FQ (and as result for FY)
          const finSobParams: ISetFinSobParams = {
            settingsIndex: sIdx,
            value: '0',
            type: 'targets',
            fy,
            fq: 1,
            isUnits: false,
            isOverall: isOvr,
            sType,
            isSoB: false,
            isNoSplit: false,
            itemsForUpdate: data,
            isNotManual: true,
          }
          const finParams = { ...finSobParams, isCleanChild: !!sType }
          data = setFinSob({ ...finParams, fq: 1 })
          data = setFinSob({ ...finParams, fq: 2 })
          data = setFinSob({ ...finParams, fq: 3 })
          data = setFinSob({ ...finParams, fq: 4 })

          if (!sType) {
            // Clean Targets SoB for FY and FQ
            const sobParams = { ...finSobParams, isSoB: true }
            data = setFinSob({ ...sobParams, fq: PLANNING_BY_FY_FQ })
            data = setFinSob({ ...sobParams, fq: 1 })
            data = setFinSob({ ...sobParams, fq: 2 })
            data = setFinSob({ ...sobParams, fq: 3 })
            data = setFinSob({ ...sobParams, fq: 4 })
          }
        }
      } else {
        // error in data
      }
    }
  }

  const setFinSob = (props: ISetFinSobParams): IJBPPlanningItem[] => {
    return setValue(
      props.settingsIndex,
      props.value,
      props.type,
      props.fy,
      props.fq,
      props.isUnits,
      props.isOverall,
      props.sType,
      props.isSoB,
      props.isNoSplit,
      props.itemsForUpdate,
      props.isCleanChild,
      props.sTypeOriginal,
      props.isNotManual
    )
  }

  const setValue = (
    settingsIndex: number,
    value: string | null,
    type: 'actuals' | 'targets' | 'quota',
    fy: number,
    fq: number,
    isUnits: boolean,
    isOverall: boolean,
    sType: TSType,
    isSoB: boolean,
    isNoSplit: boolean,
    itemsForUpdate?: IJBPPlanningItem[],
    isCleanChild?: boolean,
    sTypeOriginal?: TSType,
    isNotManual?: boolean
  ): IJBPPlanningItem[] => {
    let items = !isNoSplit ? targetsItems : targetsNoSplitItems
    let reserv = reservedTargets
    if (itemsForUpdate && itemsForUpdate.length && type === 'targets') {
      items = itemsForUpdate
    } else {
      if (type === 'actuals') {
        items = !isNoSplit ? actualsItems : actualsNoSplitItems
        reserv = reservedActuals
      }
      if (type === 'quota') {
        items = quotaItems
      }
    }
    let data = [...items]

    if (settingsIndex < props.formats.length) {
      const setting = props.formats[settingsIndex]

      const cat = setting.Category
      const l3Cat = setting.L3Category
      const isL3Overall = l3Cat === OVERALL_CATEGORY
      const isL3 = !!l3Cat
      const isL3DetailRow = isL3 && !isL3Overall

      const fieldProps = {
        actualsType: currentValueType,
        isUnits,
        currency,
        sType,
        isSoB,
        isDirect: false,
      }

      const isIgnorePartnerId = !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode

      // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
      const sourceData = items.filter(
        (el) =>
          (el.PartnerId === partnerId || isIgnorePartnerId) &&
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )
      if (sourceData.length >= 1) {
        const newItem = setItemValuesUniversal(
          sourceData[0],
          value,
          fieldProps,
          cat,
          !isNotManual,
          props.translationFactors,
          sTypeOriginal
        )

        const idx = items.indexOf(sourceData[0])
        data.splice(idx, 1, newItem)

        if (type === 'actuals') {
          setActualsItems([...data])
        } else {
          setTargetsItems([...data])
        }

        if (!isSoB) {
          const isPlanningByFY = fq >= PLANNING_BY_FY_FQ
          if (isPlanningByFY) {
            data = setQuarterByFYTotal({
              items: data,
              reservedItems: reserv,
              setting,
              fieldProps,
              fy,
              type,
              setTargetsItems,
              setActualsItems,
              translationFactors: props.translationFactors,
            })
          } else {
            data = setFYTotalByQuarters({
              items: data,
              setting,
              fieldProps,
              fy,
              setTargetsItems,
              translationFactors: props.translationFactors,
            })
          }

          const isL3DetailRow = isL3 && !isL3Overall

          if (!isOverall || isL3DetailRow) {
            if (isL3DetailRow) {
              // Recalc L3 Category Overall
              data = setOverallTotal(data, setting, fieldProps, fy, fq, isL3DetailRow)

              // Recalc Overall row FY by Q or Q by FY
              const overallSettingsL3 = props.formats.filter(
                (el) =>
                  el.ProgramType === setting.ProgramType &&
                  el.Category === setting.Category &&
                  el.SubCategory === setting.SubCategory
              )

              if (overallSettingsL3.length) {
                const overallSet = overallSettingsL3[0]

                if (isPlanningByFY) {
                  data = setQuarterByFYTotal({
                    items: data,
                    reservedItems: reserv,
                    setting: overallSet,
                    fieldProps,
                    fy,
                    type,
                    setTargetsItems,
                    setActualsItems,
                    translationFactors: props.translationFactors,
                  })
                } else {
                  data = setFYTotalByQuarters({
                    items: data,
                    setting: overallSet,
                    fieldProps,
                    fy,
                    setTargetsItems,
                    translationFactors: props.translationFactors,
                  })
                }
              }
            }

            // Recalc Category Overall
            // TODO: Find Category Overall if currently edit L3 Overall
            data = setOverallTotal(data, setting, fieldProps, fy, fq, false)

            // Recalc Overall row Fy by Q or Q by FY
            const overallSettings = props.formats.filter(
              (el) =>
                el.ProgramType === setting.ProgramType &&
                el.Category === setting.Category &&
                (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
            )

            if (overallSettings.length) {
              const overallSet = overallSettings[0]

              if (isPlanningByFY) {
                data = setQuarterByFYTotal({
                  items: data,
                  reservedItems: reserv,
                  setting: overallSet,
                  fieldProps,
                  fy,
                  type,
                  setTargetsItems,
                  setActualsItems,
                  translationFactors: props.translationFactors,
                })
              } else {
                data = setFYTotalByQuarters({
                  items: data,
                  setting: overallSet,
                  fieldProps,
                  fy,
                  setTargetsItems,
                  translationFactors: props.translationFactors,
                })
              }
            }
          }

          if (isOverall && !!sType && !!isCleanChild) {
            data = cleanQuartersAndFY({
              items: data,
              setting,
              fieldProps,
              fy,
              setTargetsItems,
              translationFactors: props.translationFactors,
            })
          }
        }

        // FY23 SoB algoritm
        if (
          isSoB &&
          !isSoBNewLogic &&
          fq >= PLANNING_BY_FY_FQ &&
          fy === fyear - 1 &&
          type === 'actuals'
        ) {
          data = setQuarterByFYTotal({
            items: data,
            reservedItems: reserv,
            setting,
            fieldProps,
            fy,
            type,
            setTargetsItems,
            setActualsItems,
            translationFactors: props.translationFactors,
          })
        }

        // FY25 SoB algoritm: Recalc SoB for Category Overall based on all SubCategories
        if (!isUnits && IS_RECALC_SOB && (type === 'actuals' || type === 'targets') && !isOverall) {
          data = calcSoBCategoryOverallForCategory({
            items: data,
            categorySettings: props.formats,
            fieldProps: { ...fieldProps, isSoB: true },
            programType: setting.ProgramType,
            category: setting.Category,
            fyear,
            fy,
            fq,
            type,
            setActualsItems,
            setTargetsItems,
            currentFYear: jbpSettings.currentFYear,
            currentFQuarter: jbpSettings.currentFQuarter,
            translationFactors: props.translationFactors,
            isYearlyPlanning,
          })
        }

        // FY24 SoB algoritm: 1. recalc FYear SoB if Quarters SoB changed
        if (
          isSoB &&
          isSoBNewLogic &&
          fq !== PLANNING_BY_FY_FQ &&
          (fy === fyear || fy === fyear - 1) &&
          (type === 'actuals' || type === 'targets')
        ) {
          data = setFySobByQuarters(
            data,
            setting,
            fieldProps,
            fy,
            type,
            setActualsItems,
            setTargetsItems,
            jbpSettings.currentFYear,
            jbpSettings.currentFQuarter,
            props.translationFactors
          )
        }
        // FY24 SoB algoritm: 2. recalc FYear SoB if Quarters Plan changed
        if (
          !isSoB &&
          isSoBNewLogic &&
          fq !== PLANNING_BY_FY_FQ &&
          fy === fyear &&
          type === 'targets'
        ) {
          const sobFieldProps = { ...fieldProps, isSoB: true }

          // 2.1 Recalc current row Fy by Q or Q by FY
          if (setting.IsSoBAvailable) {
            data = setFySobByQuarters(
              data,
              setting,
              sobFieldProps,
              fy,
              type,
              setActualsItems,
              setTargetsItems,
              jbpSettings.currentFYear,
              jbpSettings.currentFQuarter,
              props.translationFactors
            )
          }

          if (isL3DetailRow) {
            // 2.3 Recalc L3 Overall row Fy by Q or Q by FY
            const overallSettings = props.formats.filter(
              (el) =>
                el.ProgramType === setting.ProgramType &&
                el.Category === setting.Category &&
                el.SubCategory === setting.SubCategory &&
                el.L3Category === OVERALL_CATEGORY
            )

            if (overallSettings.length) {
              const overallSet = overallSettings[0]
              data = setFySobByQuarters(
                data,
                overallSet,
                sobFieldProps,
                fy,
                type,
                setActualsItems,
                setTargetsItems,
                jbpSettings.currentFYear,
                jbpSettings.currentFQuarter,
                props.translationFactors
              )
            }
          }

          // 2.3 Recalc Category Overall row Fy by Q or Q by FY
          const overallSettings = props.formats.filter(
            (el) =>
              el.ProgramType === setting.ProgramType &&
              el.Category === setting.Category &&
              (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
          )

          if (overallSettings.length) {
            const overallSet = overallSettings[0]
            data = setFySobByQuarters(
              data,
              overallSet,
              sobFieldProps,
              fy,
              type,
              setActualsItems,
              setTargetsItems,
              jbpSettings.currentFYear,
              jbpSettings.currentFQuarter,
              props.translationFactors
            )
          }
        }

        //updatePendingData(data)
      } else {
        // error in data
      }
    }

    return data
  }

  const setOverallTotal = (
    items: IJBPPlanningItem[],
    setting: IFormActualsTargetsSettings,
    fieldProps: IFieldProps,
    fy: number,
    fq: number,
    isL3DetailRow: boolean
  ) => {
    const { isUpdated, updatedItems } = updateOverallTotal({
      items,
      setting,
      fieldProps,
      fy,
      fq,
      isL3DetailRow,
      partnerId,
      isIgnorePartnerId: !!props.composedReportMode || !!props.isQuarterlyBusinessReviewMode,
      translationFactors: props.translationFactors,
    })

    if (isUpdated) {
      setTargetsItems([...updatedItems])
    }

    return updatedItems
  }

  const isTransactionalValid = () => {
    let isValid = true

    const isUnits = false
    const isSoB = false

    if (isUseContractuals && !isCategoryNA && isShowCurrencyBlock) {
      props.formats.forEach((format, idx) => {
        const subCat = format.SubCategory
        const isOverall = subCat === OVERALL_CATEGORY || !subCat

        if (!isFixedCollapsed || isOverall) {
          for (let q = 1; q <= 5; q++) {
            const currTargetsTotal = getValue(
              idx,
              'targets',
              fyear,
              q,
              isUnits,
              '',
              isSoB,
              false,
              false,
              false
            ) // Total
            const currTargetsContr = getValue(
              idx,
              'targets',
              fyear,
              q,
              isUnits,
              'c',
              isSoB,
              false,
              false,
              false
            ) // Contractual
            const currTargetsTran = Number(currTargetsTotal || 0) - Number(currTargetsContr || 0)

            if (currTargetsTran < 0) {
              isValid = false
            }
          }
        }
      })
    }

    return isValid
  }

  const calcCollapseMode = useCallback(() => {
    if (partnerInfo) {
      // Set IsCollapsed for Currency planning
      const flags = props.partnerFlagsState
      const cat = currentCat
      const formats = props.formats
      const isFlagsEnabledInSubCat = isPartnerFlagActive(flags, formats, cat)
      const isFlagsEnabledForUnits = isPartnerFlagActive(flags, formats, cat, true, true)
      // Retail Collapse: !isRetailer &&
      const isCollapseAllowedSetting =
        props.dataSetInfo.MandatoryType !== MANDATORY_CATEGORY_ALWAYS_EXPANDED &&
        !isFlagsEnabledInSubCat

      setIsCollapseAllowed(isCollapseAllowedSetting)
      setIsCollapsed((val) => val && isCollapseAllowedSetting && !isFlagsEnabledInSubCat)

      // Set IsCollapsed for Units planning
      if (isFlagsEnabledForUnits && !isOn(currentCat, 'units')) {
        setSetting(currentCat, 'units')
      }
      setIsUnitsMandatory(isFlagsEnabledForUnits)
    }
  }, [partnerInfo, props.dataSetInfo.MandatoryType, props.partnerFlagsState])

  const getInputElementId = useCallback((p: Partial<IFinSobValidationError>) => {
    const finSob = p.isSob ? 'sob' : 'fin'
    const units = p.isUnits ? '-units' : ''

    return `${p.categoryKey}-${p.settingIndex}-${p.valueType}-${p.year}-${p.q}-${finSob}${units}`
      .replace(/\s/g, '')
      .toLowerCase()
  }, [])

  /** -------------------- User actions handlers ----------------------- */

  const toggleShowComposedSob = useCallback(() => {
    if (!isShowComposedSoB) {
      setIsShowOnlyCompletedPlans(true)

      // Collapse Category only if it Expanded and isCollapseAllowed
      if (!isFixedCollapsed && isCollapseAllowed) {
        setIsCollapsed(!isFixedCollapsed && isCollapseAllowed)
      }
    }
    setIsShowComposedSoB((val) => !val)
  }, [isShowComposedSoB, isFixedCollapsed, isCollapseAllowed])

  const toggleIsCollapseCategory = useCallback(() => {
    setIsCollapsed(!isFixedCollapsed && isCollapseAllowed)
  }, [isFixedCollapsed, isCollapseAllowed])

  const onChangeNotApplicable = async () => {
    dispatch(changeFinSobIsCategoryPlanningDataLoading(true))
    const isNotApplicable = isCategoryNA ? 0 : 1
    await changeNotApplicableHndl({
      isNotApplicable,
      categoryField: currentCat,
    })

    dispatch(changeFinSobIsCategoryPlanningDataLoading(false))
  }

  const confirmNotApplicable = async () => {
    setIsShowConfirmNotApplicableDialog(false)
    await onChangeNotApplicable()
  }

  const cancelNotApplicable = () => {
    setIsShowConfirmNotApplicableDialog(false)
  }

  const setSetting = useCallback(
    async (key: string, type: TSettingsSuffix, currentValue?: boolean) => {
      dispatch(changeFinSobIsCategoryPlanningApplyingChangesLoading(true))

      if (currentValue === undefined) {
        const isQuarter = type === 'quarter'
        const defaultValue = isQuarter ? isQuarterDefaultOn : false
        currentValue = isQuarter ? isQuarterPlanning : isOn(key, type, defaultValue)
      }
      const newValue = currentValue ? 0 : 1
      const field = getNAField(key, type)
      const settingForUpdate = createSectionSettingsPatch({
        [field]: newValue,
      })

      await dispatch(
        updateSectionSettings({
          sectionSettings: settingForUpdate,
          controlName: 'Planning',
          flag: field,
          state: newValue,
        })
      ).unwrap()

      // Not appropriated for 'quarter' | 'sob' | 'units' switchers
      //await dropSignature('Financial & SOB Targets')

      dispatch(changeFinSobIsCategoryPlanningApplyingChangesLoading(false))
    },
    [dispatch, isOn, isQuarterDefaultOn, isQuarterPlanning]
  )

  const handleQuarterSettingChange = useCallback(() => {
    setSetting(currentCat, 'quarter')
    if (isRetailer && isYearlyPlanning) {
      props.displaySettings.actions.setIsYearlyPlanning(false)
      setSetting('', 'yearly-planning') // One for all categories
    }
  }, [currentCat, isRetailer, isYearlyPlanning, props.displaySettings.actions, setSetting])

  const discardChanges = () => {
    setTargetsItems([
      ...reservedTargets.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      }),
    ])
    setActualsItems([
      ...reservedActuals.map((el) => {
        return { ...el, IsChanged: 0, IsChangedSoB: 0 }
      }),
    ])
    const isCollapsedCategory = getIsCollapsedCategory(reservedTargets, fyear)
    setIsCollapsed(isCollapsedCategory && isCollapseAllowed)
  }

  const applyChangesHandler = async () => {
    const newPolyPlanningLevel = checkPolyPlanningLevel()
    const finSobProps = getFinSobProps()
    const finSobValidationResult = isFinSobPlanQuarterlyChecksEnabled
      ? checkFinSobValues(finSobProps)
      : []
    const isSignatureWillBeDropped =
      isNeedToShowSignDialog && !isOverallValueNotChanged(partnerInfo)

    if (newPolyPlanningLevel) {
      setPolyPlanningLevel(newPolyPlanningLevel)
    } else if (finSobValidationResult.length > 0) {
      // Find first unconfirmed Input index
      const unconfirmedInputIndexes = Array.from(
        new Set(finSobValidationResult.map((el) => el.inputIndex))
      ).sort((a, b) => a - b)
      const newInputIndex = unconfirmedInputIndexes[0]

      setValidationErrors(finSobValidationResult)
      setValidationInputIndex(newInputIndex)
      switchSplitType(newInputIndex, finSobValidationResult)

      props.setIsShowValidationPopup(true)
    } else if (!checkFinSobRate(finSobProps)) {
      setIsShowRateDialog(true)
    } else if (isSignatureWillBeDropped) {
      setIsShowSignDialog(true)
    } else if (isSwitchersChanged) {
      setIsShowConfirmSwitchersChangeDialog(true)
    } else {
      await applyChanges(targetsItems)
    }
  }

  const handleValidationApply = useCallback(
    async (justificationMessage: string) => {
      const validationErrorsInput = validationErrors.filter(
        (el) => el.inputIndex === validationInputIndex
      )
      if (!validationErrorsInput.length) {
        return
      }

      validationErrorsInput.forEach((el) => {
        el.isChecked = true
        el.justificationMessage = justificationMessage
      })

      const validationError = validationErrorsInput[0]
      let updatedData: IJBPPlanningItem[] | null = null
      const updatedDataValueType = validationError.valueType

      const isSetJustification = justificationMessage && validationError.isJustificationRequired
      if (isSetJustification) {
        const customField = getJustifyField({
          isSoB: validationError.isSob,
          isUnits: validationError.isUnits,
          sType: validationError.sType,
        })

        updatedData = setCustomField(
          validationError.settingIndex,
          justificationMessage,
          validationError.year,
          validationError.q,
          customField,
          validationError.valueType
        )
      }

      const isAllErrorsChecked = !validationErrors.filter((el) => !el.isChecked).length

      // Find unconfirmed Input indexes
      const unconfirmedInputsIndexes = Array.from(
        new Set(validationErrors.filter((el) => !el.isChecked).map((el) => el.inputIndex))
      )
      let newInputIndex = -1
      unconfirmedInputsIndexes.forEach((el) => {
        if (newInputIndex === -1 && el > validationInputIndex) {
          newInputIndex = el
        }
      })

      const newValidationInputIndex =
        newInputIndex > -1 ? newInputIndex : unconfirmedInputsIndexes[0]
      setValidationInputIndex(newValidationInputIndex)
      switchSplitType(newValidationInputIndex, validationErrors)

      setValidationInputUnconfirmedCount(unconfirmedInputsIndexes.length)

      if (isAllErrorsChecked) {
        props.setIsShowValidationPopup(false)

        const isSignatureWillBeDropped =
          isNeedToShowSignDialog && !isOverallValueNotChanged(partnerInfo)
        const finSobProps = getFinSobProps()

        if (!checkFinSobRate(finSobProps)) {
          setIsShowRateDialog(true)
        } else if (isSignatureWillBeDropped) {
          setIsShowSignDialog(true)
        } else if (isSwitchersChanged) {
          setIsShowConfirmSwitchersChangeDialog(true)
        } else {
          const isTargets = updatedDataValueType === 'targets'
          await applyChanges(
            isTargets && updatedData ? updatedData : targetsItems,
            isTargets ? null : updatedData
          )
        }
      }
    },
    [
      getFinSobProps,
      isNeedToShowSignDialog,
      isSwitchersChanged,
      partnerInfo,
      setCustomField,
      targetsItems,
      validationErrors,
    ]
  )

  const handleValidationCancel = useCallback(() => {
    props.setIsShowValidationPopup(false)
  }, [])

  const switchSplitType = useCallback(
    (newValidationInputIndex: number, newValidationErrors: IFinSobValidationError[]) => {
      const validationErrorsInput = newValidationErrors.filter(
        (el) => el.inputIndex === newValidationInputIndex
      )
      if (validationErrorsInput.length) {
        const validationError = validationErrorsInput[0]

        if (isUseContractuals) {
          if (validationError.isSob && splitType !== 'Total') {
            setSplitType('Total')
          } else if (!validationError.isSob) {
            switch (validationError.sType) {
              case 'c':
                if (splitType !== 'Contractual') {
                  setSplitType('Contractual')
                }
                break
              case 't':
                if (splitType !== 'Transactional') {
                  setSplitType('Transactional')
                }
                break
              default:
                if (splitType !== 'Total') {
                  setSplitType('Total')
                }
                break
            }
          }
        }

        // Scroll to Input element
        const inputElementId = getInputElementId(validationError)
        const inputElement = document.getElementById(inputElementId)
        if (inputElement) {
          scrollElementIntoPage(inputElement, { offset: 150, behavior: 'smooth' })
        }
      }
    },
    [getInputElementId, isUseContractuals, splitType]
  )

  const handleValidationInputPrev = useCallback(() => {
    const newValidationInputIndex =
      validationInputIndex > 0 ? validationInputIndex - 1 : validationInputsCount - 1

    setValidationInputIndex(newValidationInputIndex)
    switchSplitType(newValidationInputIndex, validationErrors)
  }, [switchSplitType, validationErrors, validationInputIndex, validationInputsCount])

  const handleValidationInputNext = useCallback(() => {
    const newValidationInputIndex =
      validationInputIndex < validationInputsCount - 1 ? validationInputIndex + 1 : 0

    setValidationInputIndex(newValidationInputIndex)
    switchSplitType(newValidationInputIndex, validationErrors)
  }, [switchSplitType, validationErrors, validationInputsCount, validationInputIndex])

  const handleSelectInput = useCallback((index: number) => {}, [])

  /** -------------------- Render methods ----------------------- */

  const renderQ = (
    idx: number,
    isOverall: boolean,
    isL3Overall: boolean,
    q: number,
    isEditAllowed: boolean,
    isUnits: boolean,
    isNoPlan: boolean,
    isNoSplit: boolean,
    isRollUp: boolean,
    mod: 'prevPrev' | 'prev' | 'calc' | 'curr' | 'futr'
  ) => {
    const isPrevPrevMod = mod === 'prevPrev'
    //const isPrevMod = mod === 'prev'
    const isPrevMod = mod === 'prev' || mod === 'calc'

    const isCalc = mod === 'calc'
    const isCurr = mod !== 'calc' // mod === 'curr' || mod === 'futr'

    const isCurrFY = mod === 'curr' // Only for visualizations
    const isFuture = mod === 'futr' // Only for visualizations

    const originalQ = q
    const isPrevYear = q < 0
    q = Math.abs(q)

    const isEditContr = isEditAllowed && (!isUseContractuals || splitType !== 'Total') && !isRollUp
    const isEditDistributor =
      isEditAllowed &&
      !isRollUp &&
      (!isUseContractuals ||
        (isShowContrTrans && splitType !== 'Total') ||
        (!isShowContrTrans && splitType !== 'Transactional'))
    const isEditFixed = props.isDistributorPlanner ? isEditDistributor : isEditContr

    const isPlanningByFY = q >= PLANNING_BY_FY_FQ
    let futureYears = 0
    if (q > PLANNING_BY_FY_FQ) {
      futureYears = q - PLANNING_BY_FY_FQ
      q = PLANNING_BY_FY_FQ
    }
    const year = fyear - (isPrevPrevMod ? 2 : 0) - (isPrevMod ? 1 : 0) + futureYears

    const isUseCalcActualsForYoY = isPlanningByFY && !isPrevYear && !isFuture && isShowCalcActuals

    const isSoB = false
    const sTotal = ''
    const rounding = isUnits ? '' : props.rounding || props.roundingValue
    const isRounding = rounding && rounding !== PlanningRounding.AsIs
    const fractionDigits = isRounding ? FIN_FRACTION_DIGITS_ROUNDING : 0

    if (isOverall || isL3Overall) {
      return renderQOverall(
        idx,
        isOverall,
        year,
        q,
        isUnits,
        isEditFixed,
        isPrevYear,
        isNoPlan,
        isNoSplit,
        isRollUp,
        futureYears,
        mod
      )
    }

    const fsProps: IGetFinSobValueProps = {
      targetsItems,
      targetsNoSplitItems,
      actualsItems,
      actualsNoSplitItems,
      quotaItems,
      targetsRollupItems: targetsRollupItems,
      actualsRollupItems: actualsRollupItems,
      actualsPartnerCountItems,

      actualsSmbItems,
      actualsEuItems,
      targetsSmbItems,
      targetsEuItems,

      formats: props.formats,
      partnerId,
      actualsType: currentValueType,
      currency,
      isCollapsed,
      isShowOnlyCompletedPlans,
      isShowComposedSoB,
      isRecalcPlans,
      isComposedReportMode: props.composedReportMode,
      isQuarterlyBusinessReviewMode: props.isQuarterlyBusinessReviewMode,

      settingsIndex: idx,
      type: 'targets',
      fy: year,
      fq: q,
      isUnits,
      sType: sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isDirect: false,
      fieldName: '',
    }

    let prevFq = q - 1
    let prevFqFy = year
    if (q >= PLANNING_BY_FY_FQ) {
      // Planning by FY
      prevFq = q
      prevFqFy = year - 1
    } else if (q === 1) {
      prevFq = 4
      prevFqFy = year - 1
    }
    // Check: isRollUp always = false for Actuals?
    const preFqTargets = getFinSobValue({ ...fsProps, type: 'targets', fy: prevFqFy, fq: prevFq })
    const preFqActuals = getFinSobValue({ ...fsProps, type: 'actuals', fy: prevFqFy, fq: prevFq })

    const isDirect = true
    const isNoDirect = false

    const preActuals = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false,
      isNoDirect
    )
    const currActuals = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false,
      isNoDirect
    )
    const currActualsDirect = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false,
      isDirect
    )
    const currQuota = getValue(
      idx,
      'quota',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect
    )
    const preTargets = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect
    )
    const currTargets = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect
    )
    const currTargetsRound = getRoundedValue(currTargets, rounding)

    const comment = getValueFrom(idx, 'targets', year, q, isNoSplit, isRollUp)
    const planState = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect,
      PLAN_STATE_FIELD
    )

    const jField = isUnits ? CustomFields.JustifyUnits : CustomFields.Justify
    const curActualTipVal = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect,
      jField
    )
    const curTargetTipVal = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect,
      jField
    )
    const curActualTip = (curActualTipVal ?? '').toString()
    const curTargetTip = (curTargetTipVal ?? '').toString()

    const calActualsFy = isUseCalcActualsForYoY ? year - 1 : year
    const preActualsCalc = getCalcActuals(
      idx,
      calActualsFy,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isNoDirect
    )
    const preActualsCalcDirect = getCalcActuals(
      idx,
      calActualsFy,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isDirect
    )

    // SMB vs EU split
    const preActualsCalcSmbEu = getCalcActualsSmbEu(
      idx,
      calActualsFy,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit
    )
    const currActualsSmbEu = getSmbEuValues(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false
    )
    const currTargetsSmbEu = getSmbEuValues(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp
    )

    const gtmOnline = getGtmPoints(marketShareData, currTargets, year, 'Online')
    const gtmInstore = getGtmPoints(marketShareData, currTargets, year, 'Instore')
    const gtmOnlineFormatted = formatMoneyInteger(gtmOnline)
    const gtmInstoreFormatted = formatMoneyInteger(gtmInstore)

    const preTargetsForYoY = preTargets
    const preActualsForYoY = isUseCalcActualsForYoY || mod === 'calc' ? preActualsCalc : preActuals

    const partnerCount = getFinSobValue({ ...fsProps, type: 'partnerCount' })
    const partnerCountPercent = partnerCount ? 100 : 0
    const partnerCountPreFy = getFinSobValue({ ...fsProps, type: 'partnerCount' })
    const partnerCountPreFq = getFinSobValue({
      ...fsProps,
      type: 'partnerCount',
      fy: prevFqFy,
      fq: prevFq,
    })

    const extraRowsProps = {
      ...commonExtraRowsProps,
      isPlanningByFY,

      partnerCount,
      partnerCountPercent,
      partnerCountYoY: calcDiff2(partnerCountPreFy, partnerCount),
      partnerCountQoQ: calcDiff2(partnerCountPreFq, partnerCount),
      isShowYoYPartnersVsPartners: isShowYoYPartnersVsPartners,
      isShowQoQPartnersVsPartners: isShowQoQPartnersVsPartners,

      yoyPlans: calcPercentage(preTargetsForYoY, currTargets),
      yoyTargets: calcPercentage(preActualsForYoY, currTargets),
      yoyActuals: calcPercentage(preActualsForYoY, currActuals),
      yoyQuota: calcPercentage(preActualsForYoY, currQuota),

      yoyTargetsAch: calcPercentage2(currActuals, currTargets),
      yoyQuotaAch: calcPercentage2(currActuals, currQuota),

      qoqPlans: calcPercentage(preFqTargets, currTargets),
      qoqTargets: calcPercentage(preFqActuals, currTargets),
      qoqActuals: calcPercentage(preFqActuals, currActuals),
      qoqQuota: calcPercentage(preFqActuals, currQuota),
    }

    const isActiveColumns =
      (isQuarterPlanning && !isPlanningByFY) ||
      (!isQuarterPlanning && isPlanningByFY) ||
      !!futureYears
    const isEditCells = isEditFixed && isActiveColumns && !isPrevYear
    //const isEditComment = isEditCells && !isPlanningByFY

    const setting = props.formats[idx]
    const isCategoryAlwaysOverall = !setting.SubCategory
    const isActiveRow =
      (isFixedCollapsed && isOverall) ||
      (!isFixedCollapsed && !isOverall) ||
      isCategoryAlwaysOverall

    const flags = partnerInfo?.PartnerFlags || ''
    const isMandatoryByFlag = isSubCategoryMandatory(
      flags,
      setting.MandatoryByFlags,
      sectionSettings,
      false
    )
    const isMandatoryUnitsByFlag = isSubCategoryMandatory(
      flags,
      setting.UnitsMandatoryByFlags,
      sectionSettings,
      false
    )
    const isShowMandatoryByFlag =
      (!isUnits && isMandatoryByFlag.isMandatory) || (isUnits && isMandatoryUnitsByFlag.isMandatory)
    const isShowMandatoryForCategory = isOverall || !isCollapseAllowed
    const isShowMandatoryCommon = isMandatoryByFlagLogic
      ? isShowMandatoryByFlag
      : isShowMandatoryForCategory

    const isTop = isTopPartner(buttonCurrType, props.partnerFlagsState, !!partnerInfo?.IsTopPartner)
    // For H2 Review - disable H1 plan
    const isDisableH1 = !!jbpSettings.isH2Review && (q === 1 || q === 2)
    const isShowMandatory =
      isShowMandatoryCommon &&
      !isPrevYear &&
      !props.composedReportMode &&
      (!isFuture || isTop) &&
      !isDisableH1

    const isShowZero = !IS_SHOW_NULL && isShowMandatory && Number(currTargets || 0) <= 0

    const isShowActualsCell = props.showActuals
    const isShowQuota = props.showQuota && !isRollUp
    const isStripCol = (!isActiveColumns || isFuture) && !isRollUp

    const isHidePrevTargets = !isShowPrevTargets && !IS_NEW_LNF
    const isHideCurrTargets = isHidePrevTargets && isPrevYear
    //const isHideCurrTargetsYoY = isHideCurrTargets || (isNoPlan && !isPrevYear)

    const isShowSeparator = isPlanningByFY
    const isShowSeparatorThin = !isPlanningByFY && q !== 1

    const editorRender = () => {
      const isCellHighlighted = planState === FIELD_STATE_HIGHLIGHT && !(currTargets || 0)
      const isInputDisabled = planState === FIELD_STATE_DISABLED || isDisableH1

      let isShowInputPopup = false
      let fieldValidationErrors: IFinSobValidationError[] = []
      if (props.isShowValidationPopup) {
        fieldValidationErrors = validationErrors.filter(
          (el) =>
            el.year === year &&
            el.q === q &&
            el.settingIndex === idx &&
            el.valueType === 'targets' &&
            el.sType === sTotal &&
            el.inputIndex === validationInputIndex &&
            !el.isSob &&
            el.isUnits === isUnits
        )
        if (fieldValidationErrors.length) {
          isShowInputPopup = true
        }
      }

      const categoryKey = `${setting.Category}-${setting.SubCategory}`
      const inputParams: Partial<IFinSobValidationError> = {
        category: setting.Category,
        categoryKey,
        settingIndex: idx,
        valueType: 'targets',
        year,
        q,
        isSob: false,
        isUnits,
      }
      const inputElementId = getInputElementId(inputParams)

      return (
        <>
          <MandatoryField value={currTargets} isShow={isShowMandatory} />
          <AbsolutePopup
            rootClassName={cn(styles.finInput, styles.filtersGroup__item, styles.filter)}
            popupContent={() => (
              <FinSobValidationPopupContent
                validationErrors={fieldValidationErrors}
                inputCount={validationInputsCount}
                inputIndex={validationInputIndex}
                inputsUnconfirmed={validationInputUnconfirmedCount}
                onPrevInput={handleValidationInputPrev}
                onNextInput={handleValidationInputNext}
                onSelectInput={handleSelectInput}
                onApply={handleValidationApply}
                onCancel={handleValidationCancel}
              />
            )}
            verticalDirection={TPopupVertical.Bottom}
            horizontalDirection={TPopupHorizontal.Left}
            verticalStartPosition={TPopupVertical.Bottom}
            horizontalStartPosition={TPopupHorizontal.Right}
            visibilityTrigger={TVisibilityTrigger.Custom}
            visibilityCallback={() => isShowInputPopup}
          >
            <FloatingNumberInput
              id={inputElementId}
              floatLength={8}
              disabled={isInputDisabled || props.isShowValidationPopup}
              hasSpin={false}
              align="right"
              classes={{
                inputClasses: {
                  root: cn(
                    styles.cell,
                    styles.cell__input,
                    { [styles.highlighted]: isCellHighlighted },
                    { [styles.validating]: isShowInputPopup }
                  ),
                  content: styles.numberInput,
                },
              }}
              value={currTargetsRound || currTargetsRound === 0 ? currTargetsRound.toString() : ''}
              onChange={(valueStr) => {
                const value = valueStr
                  ? getRestoredValue(Number(valueStr || 0), rounding).toFixed(0)
                  : null

                setValue(
                  idx,
                  value,
                  'targets',
                  year,
                  q,
                  isUnits,
                  isOverall,
                  sTotal,
                  isSoB,
                  isNoSplit
                )
              }}
              checkFn={ValidationHelper.checkNullableNumber}
              maximumFractionDigits={fractionDigits}
            />
          </AbsolutePopup>
        </>
      )
    }

    const key = `jbp-planning-cells-q-${currentCat}-${idx}-${originalQ}-${isUnits}-${isRollUp}-${mod}`

    return (
      <Fragment key={key}>
        {/* Prev FY (Calc) */}

        {isCalc && isShowCalcActuals && (
          <td
            style={{ backgroundColor: getPlanningPeriodColumnColor(isPlanningByFY, isFuture) }}
            className={cn({
              [styles.colStrip]: isStripCol,
              [styles.colSeparator]: isPlanningByFY,
            })}
          >
            <div className={styles.itemWrapper}>
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>{isShowQuota && <>&nbsp;</>}</div>
                {isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {fieldWrapper(
                      preActualsCalc,
                      year - 1,
                      isRetailer,
                      marketShareData,
                      'actuals',
                      false,
                      0,
                      rounding
                    )}
                  </div>
                )}
                {isShowActualsSplit && isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {actualsWrapper(
                      preActualsCalc,
                      preActualsCalcDirect,
                      year - 1,
                      isRetailer,
                      marketShareData,
                      false,
                      0,
                      rounding
                    )}
                  </div>
                )}
                {isShowSmbVsEuSplit &&
                  isShowActualsCell &&
                  renderSmbVsEuSplitRows(preActualsCalcSmbEu, rounding)}
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                  })}
                >
                  {isHideCurrTargets ? (
                    <>&nbsp;</>
                  ) : (
                    <>
                      {isNoPlan && !isPrevYear ? (
                        <Translation text="jbp-planning-no-plan" span />
                      ) : (
                        <>
                          <MandatoryField value={currTargets} isShow={isShowMandatory} />
                          {fieldWrapper(
                            currTargets,
                            year,
                            isRetailer,
                            marketShareData,
                            'targets',
                            isShowZero,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {isShowSmbVsEuSplit && renderSmbVsEuSplitRows(currTargetsSmbEu, rounding)}
                {/* PartnerCount, YoY, QoQ */}
                <ExtraFinRows {...extraRowsProps} />
              </div>
            </div>
          </td>
        )}

        {/* Current FY */}

        {isCurr && (
          <td
            style={{ backgroundColor: getPlanningPeriodColumnColor(isPlanningByFY, isFuture) }}
            className={cn(styles.colSeparator, {
              [styles.colStrip]: isStripCol,
              [styles.colStripCurrent]: isCurrFY,
              [styles.colSeparator]: isShowSeparator,
              [styles.colSeparatorThin]: isShowSeparatorThin,
            })}
          >
            <div className={styles.itemWrapper}>
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>
                  {isShowQuota && (
                    <>
                      {isHideCurrTargets ? (
                        <span>&nbsp;</span>
                      ) : (
                        <>
                          {fieldWrapper(
                            currQuota,
                            year,
                            isRetailer,
                            marketShareData,
                            'quota',
                            false,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {fieldWrapper(
                      currActuals,
                      year,
                      isRetailer,
                      marketShareData,
                      'actuals',
                      false,
                      0,
                      rounding,
                      curActualTip
                    )}
                  </div>
                )}
                {isShowActualsSplit && isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {actualsWrapper(
                      currActuals,
                      currActualsDirect,
                      year,
                      isRetailer,
                      marketShareData,
                      false,
                      0,
                      rounding,
                      curActualTip
                    )}
                  </div>
                )}
                {isShowSmbVsEuSplit &&
                  isShowActualsCell &&
                  renderSmbVsEuSplitRows(currActualsSmbEu, rounding, curActualTip)}
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                  })}
                >
                  {!isEditCells && <CommentIcon tooltipText={comment} />}
                  {!isEditCells ? (
                    <>
                      {isHideCurrTargets ? (
                        <>&nbsp;</>
                      ) : (
                        <>
                          {isNoPlan && !isPrevYear ? (
                            <Translation text="jbp-planning-no-plan" span />
                          ) : (
                            <>
                              <MandatoryField value={currTargets} isShow={isShowMandatory} />
                              {fieldWrapper(
                                currTargets,
                                year,
                                isRetailer,
                                marketShareData,
                                'targets',
                                isShowZero,
                                0,
                                rounding,
                                curTargetTip
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {isNoPlan && !isPrevYear ? (
                        <div className={styles.noPlanEditField}>
                          <Translation text="jbp-planning-no-plan" span />
                        </div>
                      ) : (
                        <>
                          {!isShowRetailerGtmPriorities ? (
                            editorRender()
                          ) : (
                            <Tooltip
                              tipContent={() => (
                                <span className={styles.tipContent}>
                                  <span className={styles.tipLine}>
                                    <Translation text="jbp-gtm-priorities-online-tip" span />
                                    {gtmOnlineFormatted}
                                  </span>
                                  <br />
                                  <span className={styles.tipLine}>
                                    <Translation text="jbp-gtm-priorities-instore-tip" span />
                                    {gtmInstoreFormatted}
                                  </span>
                                </span>
                              )}
                            >
                              {editorRender()}
                            </Tooltip>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {isShowSmbVsEuSplit &&
                  renderSmbVsEuSplitRows(currTargetsSmbEu, rounding, curTargetTip)}
                {/* PartnerCount, YoY, QoQ */}
                <ExtraFinRows {...extraRowsProps} />
              </div>
            </div>
          </td>
        )}
      </Fragment>
    )
  }

  const renderQContr = (
    idx: number,
    isOverall: boolean,
    q: number,
    isEditAllowed: boolean,
    isUnits: boolean,
    ctType: TCTType,
    isNoPlan: boolean,
    mod: 'prevPrev' | 'prev' | 'calc' | 'curr' | 'futr'
  ) => {
    const isPrevPrevMod = mod === 'prevPrev'
    //const isPrevMod = mod === 'prev'
    const isPrevMod = mod === 'prev' || mod === 'calc'

    const isCalc = mod === 'calc'
    const isCurr = mod !== 'calc' // mod === 'curr' || mod === 'futr'

    const isCurrFY = mod === 'curr' // Only for visualizations
    const isFuture = mod === 'futr' // Only for visualizations

    const originalQ = q
    const isPrevYear = q < 0
    q = Math.abs(q)

    const isRollUp = false
    const isEditContr = isEditAllowed && (!isUseContractuals || splitType !== 'Total') && !isRollUp
    const isEditDistributor =
      isEditAllowed &&
      !isRollUp &&
      (!isUseContractuals ||
        (isShowContrTrans && splitType !== 'Total') ||
        (!isShowContrTrans && splitType !== 'Transactional'))
    const isEditFixed = props.isDistributorPlanner ? isEditDistributor : isEditContr

    const isNoPlanFixed = isNoPlan && ctType !== 't'

    const isPlanningByFY = q >= PLANNING_BY_FY_FQ
    let futureYears = 0
    if (q > PLANNING_BY_FY_FQ) {
      futureYears = q - PLANNING_BY_FY_FQ
      q = PLANNING_BY_FY_FQ
    }
    const year = fyear - (isPrevPrevMod ? 2 : 0) - (isPrevMod ? 1 : 0) + futureYears

    const isUseCalcActualsForYoY = isPlanningByFY && !isPrevYear && !isFuture && isShowCalcActuals

    const isSoB = false
    const isNoSplit = false
    const rounding = isUnits ? '' : props.rounding || props.roundingValue
    const isRounding = rounding && rounding !== PlanningRounding.AsIs
    const fractionDigits = isRounding ? FIN_FRACTION_DIGITS_ROUNDING : 0

    const isCType = ctType === 'c'
    const isContractualType = ctType === 'c' || ctType === 't'
    const isT = ctType !== 'c' && ctType !== 't'

    const fsProps: IGetFinSobValueProps = {
      targetsItems,
      targetsNoSplitItems,
      actualsItems,
      actualsNoSplitItems,
      quotaItems,
      targetsRollupItems: targetsRollupItems,
      actualsRollupItems: actualsRollupItems,
      actualsPartnerCountItems,

      actualsSmbItems,
      actualsEuItems,
      targetsSmbItems,
      targetsEuItems,

      formats: props.formats,
      partnerId,
      actualsType: currentValueType,
      currency,
      isCollapsed,
      isShowOnlyCompletedPlans,
      isShowComposedSoB,
      isRecalcPlans,
      isComposedReportMode: props.composedReportMode,
      isQuarterlyBusinessReviewMode: props.isQuarterlyBusinessReviewMode,

      settingsIndex: idx,
      type: 'targets',
      fy: year,
      fq: q,
      isUnits,
      sType: '',
      isSoB,
      isNoSplit,
      isRollUp,
      isDirect: false,
      fieldName: '',
    }

    let prevFq = q - 1
    let prevFqFy = year
    if (q >= PLANNING_BY_FY_FQ) {
      // Planning by FY
      prevFq = q
      prevFqFy = year - 1
    } else if (q === 1) {
      prevFq = 4
      prevFqFy = year - 1
    }
    const preFqTargetsTotal = getFinSobValue({
      ...fsProps,
      type: 'targets',
      fy: prevFqFy,
      fq: prevFq,
    })
    const preFqActualsTotal = getFinSobValue({
      ...fsProps,
      type: 'actuals',
      fy: prevFqFy,
      fq: prevFq,
    })
    const preFqTargetsContr = getFinSobValue({
      ...fsProps,
      type: 'targets',
      fy: prevFqFy,
      fq: prevFq,
      sType: 'c',
    })
    const preFqActualsContr = getFinSobValue({
      ...fsProps,
      type: 'actuals',
      fy: prevFqFy,
      fq: prevFq,
      sType: 'c',
    })

    const isDirect = true
    const isNoDirect = false

    const preActualsTotal = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Total
    const currActualsTotal = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Total
    const preTargetsTotal = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Total
    const currTargetsTotal = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Total
    const currQuotaTotal = getValue(
      idx,
      'quota',
      year,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Total

    const preActualsContr = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Contractual
    const currActualsContr = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Contractual
    const preTargetsContr = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Contractual
    const currTargetsContr = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Contractual
    const currQuotaContr = getValue(
      idx,
      'quota',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      isNoDirect
    ) // Contractual
    const planState = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      PLAN_STATE_FIELD
    )

    const jCField = isUnits ? CustomFields.JustifyUnitsC : CustomFields.JustifyC
    const jTField = isUnits ? CustomFields.JustifyUnitsT : CustomFields.JustifyT
    const curCActualTipVal = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      jCField
    )
    const curCTargetTipVal = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      jCField
    )
    const curTActualTipVal = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      't',
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      jTField
    )
    const curTTargetTipVal = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      't',
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      jTField
    )
    const curCActualTip = (curCActualTipVal ?? '').toString()
    const curCTargetTip = (curCTargetTipVal ?? '').toString()
    const curTActualTip = (curTActualTipVal ?? '').toString()
    const curTTargetTip = (curTTargetTipVal ?? '').toString()
    const curActualTip = isCType ? curCActualTip : curTActualTip
    const curTargetTip = isCType ? curCTargetTip : curTTargetTip

    const preActualsTran = Number(preActualsTotal || 0) - Number(preActualsContr || 0)
    const currActualsTran = Number(currActualsTotal || 0) - Number(currActualsContr || 0)
    const preTargetsTran = Number(preTargetsTotal || 0) - Number(preTargetsContr || 0)
    const currTargetsTran = Number(currTargetsTotal || 0) - Number(currTargetsContr || 0)
    const currQuotaTran = Number(currQuotaTotal || 0) - Number(currQuotaContr || 0)
    const preFqActualsTran = Number(preFqActualsTotal || 0) - Number(preFqActualsContr || 0)
    const preFqTargetsTran = Number(preFqTargetsTotal || 0) - Number(preFqTargetsContr || 0)

    const calActualsFy = isUseCalcActualsForYoY ? year - 1 : year
    const preActualsTotalCalc = getCalcActuals(
      idx,
      calActualsFy,
      isUnits,
      '',
      isSoB,
      false,
      isNoDirect
    ) // Total
    const preActualsContrCalc = getCalcActuals(
      idx,
      calActualsFy,
      isUnits,
      'c',
      isSoB,
      false,
      isNoDirect
    ) // Contractual
    const preActualsTranCalc = Number(preActualsTotalCalc || 0) - Number(preActualsContrCalc || 0)
    const preActualsCalc = isCType ? preActualsContrCalc : preActualsTranCalc

    // SMB vs EU split
    const preActualsCalcTotalSmbEu = getCalcActualsSmbEu(
      idx,
      calActualsFy,
      isUnits,
      '',
      isSoB,
      false
    )
    const preActualsCalcContrSmbEu = getCalcActualsSmbEu(
      idx,
      calActualsFy,
      isUnits,
      'c',
      isSoB,
      false
    )
    const preActualsCalcSmbEu = isCType
      ? preActualsCalcContrSmbEu
      : getSmbEuDiff(preActualsCalcTotalSmbEu, preActualsCalcContrSmbEu)

    const currActualsTotalSmbEu = getSmbEuValues(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp
    )
    const currActualsContrSmbEu = getSmbEuValues(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp
    )
    const currActualsSmbEu = isCType
      ? currActualsContrSmbEu
      : getSmbEuDiff(currActualsTotalSmbEu, currActualsContrSmbEu)

    const currTargetsTotalSmbEu = getSmbEuValues(
      idx,
      'targets',
      year,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp
    )
    const currTargetsContrSmbEu = getSmbEuValues(
      idx,
      'targets',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp
    )
    const currTargetsSmbEu = isCType
      ? currTargetsContrSmbEu
      : getSmbEuDiff(currTargetsTotalSmbEu, currTargetsContrSmbEu)

    const currActualsDirectTotal = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      '',
      isSoB,
      false,
      isRollUp,
      isDirect
    )
    const currActualsDirectContr = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      'c',
      isSoB,
      false,
      isRollUp,
      isDirect
    )
    const currActualsDirectTran =
      Number(currActualsDirectTotal || 0) - Number(currActualsDirectContr || 0)
    const preActualsDirectTotalCalc = getCalcActuals(
      idx,
      calActualsFy,
      isUnits,
      '',
      isSoB,
      false,
      isDirect
    )
    const preActualsDirectContrCalc = getCalcActuals(
      idx,
      calActualsFy,
      isUnits,
      'c',
      isSoB,
      false,
      isDirect
    )
    const preActualsDirectTranCalc =
      Number(preActualsDirectTotalCalc || 0) - Number(preActualsDirectContrCalc || 0)
    const preActualsCalcDirect = isCType ? preActualsDirectContrCalc : preActualsDirectTranCalc
    const currActualsDirect = isCType ? currActualsDirectContr : currActualsDirectTran

    const preTargetsContrForYoY = preTargetsContr
    const preTargetsTranForYoY = preTargetsTran
    const preActualsContrForYoY =
      isUseCalcActualsForYoY || mod === 'calc' ? preActualsContrCalc : preActualsContr
    const preActualsTranForYoY =
      isUseCalcActualsForYoY || mod === 'calc' ? preActualsTranCalc : preActualsTran

    const yoyPlansContr = calcPercentage(preTargetsContrForYoY, currTargetsContr)
    const yoyPlansTran = calcPercentage(preTargetsTranForYoY, currTargetsTran)
    const yoyActualsContr = calcPercentage(preActualsContrForYoY, currActualsContr)
    const yoyActualsTran = calcPercentage(preActualsTranForYoY, currActualsTran)
    const yoyTargetsContr = calcPercentage(preActualsContrForYoY, currTargetsContr)
    const yoyTargetsTran = calcPercentage(preActualsTranForYoY, currTargetsTran)
    const yoyQuotaContr = calcPercentage(preActualsContrForYoY, currQuotaContr)
    const yoyQuotaTran = calcPercentage(preActualsTranForYoY, currQuotaTran)

    const yoyTargetsContrAch = calcPercentage2(currActualsContr, currTargetsContr)
    const yoyTargetsTranAch = calcPercentage2(currActualsTran, currTargetsTran)
    const yoyQuotaContrAch = calcPercentage2(currActualsContr, currQuotaContr)
    const yoyQuotaTranAch = calcPercentage2(currActualsTran, currQuotaTran)

    const qoqPlansContr = calcPercentage(preFqTargetsContr, currTargetsContr)
    const qoqPlansTran = calcPercentage(preFqTargetsTran, currTargetsTran)
    const qoqActualsContr = calcPercentage(preFqActualsContr, currActualsContr)
    const qoqActualsTran = calcPercentage(preFqActualsTran, currActualsTran)
    const qoqTargetsContr = calcPercentage(preFqActualsContr, currTargetsContr)
    const qoqTargetsTran = calcPercentage(preFqActualsTran, currTargetsTran)
    const qoqQuotaContr = calcPercentage(preFqActualsContr, currQuotaContr)
    const qoqQuotaTran = calcPercentage(preFqActualsTran, currQuotaTran)

    const partnerCountTotal = getFinSobValue({ ...fsProps, type: 'partnerCount' })
    const partnerCountC = getFinSobValue({ ...fsProps, type: 'partnerCount', sType: 'c' })
    const partnerCountT = partnerCountTotal - partnerCountC
    const partnerCount = isCType ? partnerCountC : partnerCountT
    const partnerCountPercent = calcPercentage2(partnerCount, partnerCountTotal) ?? 0

    const partnerCountPreFyTotal = getFinSobValue({ ...fsProps, type: 'partnerCount' })
    const partnerCountPreFyC = getFinSobValue({ ...fsProps, type: 'partnerCount', sType: 'c' })
    const partnerCountPreFqTotal = getFinSobValue({
      ...fsProps,
      type: 'partnerCount',
      fy: prevFqFy,
      fq: prevFq,
    })
    const partnerCountPreFqC = getFinSobValue({
      ...fsProps,
      type: 'partnerCount',
      fy: prevFqFy,
      fq: prevFq,
      sType: 'c',
    })
    const partnerCountPreFyT = partnerCountPreFyTotal - partnerCountPreFyC
    const partnerCountPreFqT = partnerCountPreFqTotal - partnerCountPreFqC
    const partnerCountPreFy = isCType ? partnerCountPreFyC : partnerCountPreFyT
    const partnerCountPreFq = isCType ? partnerCountPreFqC : partnerCountPreFqT

    const extraRowsProps = {
      ...commonExtraRowsProps,
      isPlanningByFY,
      sType: ctType,

      partnerCount,
      partnerCountPercent,
      partnerCountYoY: calcDiff2(partnerCountPreFy, partnerCount),
      partnerCountQoQ: calcDiff2(partnerCountPreFq, partnerCount),
      isShowYoYPartnersVsPartners: isShowYoYPartnersVsPartners,
      isShowQoQPartnersVsPartners: isShowQoQPartnersVsPartners,

      yoyPlans: isCType ? yoyPlansContr : yoyPlansTran,
      yoyTargets: isCType ? yoyTargetsContr : yoyTargetsTran,
      yoyActuals: isCType ? yoyActualsContr : yoyActualsTran,
      yoyQuota: isCType ? yoyQuotaContr : yoyQuotaTran,

      yoyTargetsAch: isCType ? yoyTargetsContrAch : yoyTargetsTranAch,
      yoyQuotaAch: isCType ? yoyQuotaContrAch : yoyQuotaTranAch,

      qoqPlans: isCType ? qoqPlansContr : qoqPlansTran,
      qoqTargets: isCType ? qoqTargetsContr : qoqTargetsTran,
      qoqActuals: isCType ? qoqActualsContr : qoqActualsTran,
      qoqQuota: isCType ? qoqQuotaContr : qoqQuotaTran,
    }

    const setting = props.formats[idx]
    const isCategoryAlwaysOverall = !setting.SubCategory
    const isActiveColumns =
      (isQuarterPlanning && !isPlanningByFY) ||
      (!isQuarterPlanning && isPlanningByFY) ||
      !!futureYears

    const l3Cat = setting.L3Category
    const isL3Overall = l3Cat === OVERALL_CATEGORY
    const isL3 = !!l3Cat
    const isL3Collapsed = getIsCollapsedL3Category(targetsItems, fyear, setting.SubCategory)

    const isL2ActiveRow =
      (isFixedCollapsed && isOverall) ||
      (!isFixedCollapsed && !isOverall) ||
      isCategoryAlwaysOverall
    const isL3ActiveRow =
      (isL3Collapsed && isL3Overall) || (!isL3Collapsed && !isL3Overall) || isCategoryAlwaysOverall
    const isActiveRow = isL3 ? isL3ActiveRow : isL2ActiveRow

    const isEditCells = isEditFixed && isActiveRow && isActiveColumns && !isPrevYear

    const isItemOverall = isOverall && !(props.showActuals || props.showQuota) && !isEditCells
    // TODO: Use only logic based on flags in FY24
    const isShowContractuals = buttonCurrType === ProgramTypes.CorePrint

    const flags = partnerInfo?.PartnerFlags || ''
    const isMandatoryByFlag = isSubCategoryMandatory(
      flags,
      setting.MandatoryByFlags,
      sectionSettings,
      false
    )
    const isMandatoryUnitsByFlag = isSubCategoryMandatory(
      flags,
      setting.UnitsMandatoryByFlags,
      sectionSettings,
      false
    )
    const isSkipTransactional =
      (!isUnits && isMandatoryByFlag.isSkipTransactional) ||
      (isUnits && isMandatoryUnitsByFlag.isSkipTransactional)
    const isShowMandatoryByFlag =
      (ctType !== 't' || !isSkipTransactional) &&
      ((!isUnits && isMandatoryByFlag.isMandatory) ||
        (isUnits && isMandatoryUnitsByFlag.isMandatory))
    const isShowMandatoryForCategory = isOverall || !isCollapseAllowed
    const isShowMandatoryCommon = isMandatoryByFlagLogic
      ? isShowMandatoryByFlag
      : isShowMandatoryForCategory

    const isTop = isTopPartner(buttonCurrType, props.partnerFlagsState, !!partnerInfo?.IsTopPartner)
    // For H2 Review - disable H1 plan
    const isDisableH1 = !!jbpSettings.isH2Review && (q === 1 || q === 2)
    const isShowMandatory =
      isShowMandatoryCommon &&
      !isPrevYear &&
      !props.composedReportMode &&
      isShowContractuals &&
      (!isFuture || isTop) &&
      !isDisableH1

    const isShowTransactionalWarning = isShowContractuals && !isPrevYear

    const value = isCType ? currTargetsContr : currTargetsTran
    const valueRound = getRoundedValue(value, rounding)

    const isShowZero = !IS_SHOW_NULL && isShowMandatory && Number(value || 0) <= 0

    const isHidePrevTargets = !isShowPrevTargets && !IS_NEW_LNF
    const isHideCurrTargets = isHidePrevTargets && isPrevYear
    //const isHideCurrTargetsYoY = isHideCurrTargets || (isNoPlanFixed && !isPrevYear)

    const isShowSeparator = isPlanningByFY
    const isShowSeparatorThin = !isPlanningByFY && q !== 1

    const editorRender = () => {
      const isCellHighlighted = planState === FIELD_STATE_HIGHLIGHT && !(value || 0)
      const isInputDisabled = planState === FIELD_STATE_DISABLED || isDisableH1

      let isShowInputPopup = false
      let fieldValidationErrors: IFinSobValidationError[] = []
      if (props.isShowValidationPopup) {
        fieldValidationErrors = validationErrors.filter(
          (el) =>
            el.year === year &&
            el.q === q &&
            el.settingIndex === idx &&
            el.valueType === 'targets' &&
            el.sType === ctType &&
            el.inputIndex === validationInputIndex &&
            !el.isSob &&
            el.isUnits === isUnits
        )
        if (fieldValidationErrors.length) {
          isShowInputPopup = true
        }
      }

      const categoryKey = `${setting.Category}-${setting.SubCategory}`
      const inputParams: Partial<IFinSobValidationError> = {
        category: setting.Category,
        categoryKey,
        settingIndex: idx,
        valueType: 'targets',
        year,
        q,
        isSob: false,
        isUnits,
      }
      const inputElementId = getInputElementId(inputParams)

      return (
        <>
          <MandatoryField value={value} isShow={isShowMandatory} />
          <AbsolutePopup
            rootClassName={cn(styles.finInput, styles.filtersGroup__item, styles.filter)}
            popupContent={() => (
              <FinSobValidationPopupContent
                validationErrors={fieldValidationErrors}
                inputCount={validationInputsCount}
                inputIndex={validationInputIndex}
                inputsUnconfirmed={validationInputUnconfirmedCount}
                onPrevInput={handleValidationInputPrev}
                onNextInput={handleValidationInputNext}
                onSelectInput={handleSelectInput}
                onApply={handleValidationApply}
                onCancel={handleValidationCancel}
              />
            )}
            verticalDirection={TPopupVertical.Bottom}
            horizontalDirection={TPopupHorizontal.Left}
            verticalStartPosition={TPopupVertical.Bottom}
            horizontalStartPosition={TPopupHorizontal.Right}
            visibilityTrigger={TVisibilityTrigger.Custom}
            visibilityCallback={() => isShowInputPopup}
          >
            <FloatingNumberInput
              id={inputElementId}
              floatLength={8}
              disabled={isInputDisabled || props.isShowValidationPopup}
              hasSpin={false}
              align="right"
              classes={{
                inputClasses: {
                  root: cn(
                    styles.cell,
                    styles.cell__input,
                    { [styles.highlighted]: isCellHighlighted },
                    { [styles.validating]: isShowInputPopup }
                  ),
                  content: styles.numberInput,
                },
              }}
              value={valueRound || valueRound === 0 ? valueRound.toString() : ''}
              onChange={(valueStr) => {
                const value = valueStr
                  ? getRestoredValue(Number(valueStr || 0), rounding).toFixed(0)
                  : null

                // Orignal variant:
                // setValue(idx, value, 'targets', year, q, isUnits, isOverall, sType, isSoB, false)

                const commonParams: ISetFinSobParams = {
                  settingsIndex: idx,
                  value: value,
                  type: 'targets',
                  fy: year,
                  fq: q,
                  isUnits: isUnits,
                  isOverall: isOverall,
                  sType: 'c',
                  isSoB: isSoB,
                  isNoSplit: false,
                }
                if (props.isDistributorPlanner) {
                  // Save Distributor Planner:
                  //          Stored in DB    Save Value
                  // Total    yes             OK
                  // Cont(nA) yes             OK
                  // Tran (A) NO (calc T-C)   not edit
                  if (isCType) {
                    // Value = new Contractual (Non-Power)
                    setFinSob(commonParams)
                  }
                } else {
                  // Save Fin Sob Planning:
                  //          Stored in DB    Save Value      And...
                  // Total    yes             not edit
                  // Cont     yes             OK              New Total = New Contractual + Transactional
                  // Tran     NO (calc T-C)   [] Need to save Total = Contr + Tran AND Save Contr = PrevTotal - Tran
                  if (isCType) {
                    // Value = new Contractual
                    // 1. Set new Contractual
                    const updatedItems = setFinSob(commonParams)
                    // 2. Set: Updated Total = new Contractual + Transactional
                    const t = (Number(currTargetsTran || 0) + Number(value || 0)).toString()
                    //console.log(`isCType: '${isCType}', Input: ${value}, Contr: ${value}, Total: ${t}`)
                    setFinSob({
                      ...commonParams,
                      value: t,
                      sType: '',
                      itemsForUpdate: updatedItems,
                      isNotManual: false,
                    })
                  } else {
                    // Value = new Transactional
                    // 1. Set: Updated Contractual = Total - New Transactional
                    const c = (Number(currTargetsTotal || 0) - Number(value || 0)).toString()
                    setFinSob({ ...commonParams, value: c, sTypeOriginal: 't' })
                    // 2. Set: Updated Total = Updated Contractual + New Transactional
                    const newTotal = (Number(currTargetsContr || 0) + Number(value || 0)).toString()
                    //console.log(`isCType: '${isCType}', Input: ${value}, Contr: ${c}, Total: ${t}`)
                    setFinSob({
                      ...commonParams,
                      value: newTotal,
                      sType: '',
                      sTypeOriginal: 't',
                      isNotManual: false,
                    })
                  }
                }
              }}
              checkFn={ValidationHelper.checkNullableNumber}
              maximumFractionDigits={fractionDigits}
            />
          </AbsolutePopup>
        </>
      )
    }

    const key = `jbp-planning-cells-q-contr-${currentCat}-${idx}-${originalQ}-${isUnits}-${isRollUp}-${mod}`

    return (
      <Fragment key={key}>
        {/* Prev FY (Calc) */}

        {isCalc && isShowCalcActuals && (
          <td
            style={{ backgroundColor: getPlanningPeriodColumnColor(isPlanningByFY, isFuture) }}
            className={cn({
              [styles.colStrip]: !isActiveColumns,
              [styles.colSeparator]: isPlanningByFY,
            })}
          >
            <div className={cn(styles.itemWrapper, { [styles.itemOverall]: isItemOverall })}>
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>{props.showQuota && <>&nbsp;</>}</div>
                <div className={styles.itemActual}>
                  {fieldWrapper(
                    preActualsCalc,
                    year - 1,
                    isRetailer,
                    marketShareData,
                    'actuals',
                    false,
                    0,
                    rounding
                  )}
                </div>
                {isShowActualsSplit && (
                  <div className={styles.itemActual}>
                    {actualsWrapper(
                      preActualsCalc,
                      preActualsCalcDirect,
                      year - 1,
                      isRetailer,
                      marketShareData,
                      false,
                      0,
                      rounding
                    )}
                  </div>
                )}
                {isShowSmbVsEuSplit && renderSmbVsEuSplitRows(preActualsCalcSmbEu, rounding)}
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                  })}
                >
                  {isHideCurrTargets ? (
                    <>&nbsp;</>
                  ) : (
                    <>
                      {isNoPlanFixed && !isPrevYear ? (
                        <Translation text="jbp-planning-no-plan" span />
                      ) : (
                        <>
                          <MandatoryField value={value} isShow={isShowMandatory} />
                          {fieldWrapper(
                            value,
                            year,
                            isRetailer,
                            marketShareData,
                            'targets',
                            isShowZero,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {isShowSmbVsEuSplit && renderSmbVsEuSplitRows(currTargetsSmbEu, rounding)}
                {/* PartnerCount, YoY, QoQ */}
                <ExtraFinRows {...extraRowsProps} />
              </div>
            </div>
          </td>
        )}

        {/* Current FY */}

        {isCurr && (
          <td
            style={{ backgroundColor: getPlanningPeriodColumnColor(isPlanningByFY, isFuture) }}
            className={cn(styles.colSeparator, {
              [styles.colStrip]: !isActiveColumns,
              [styles.colStripCurrent]: isCurrFY,
              [styles.colSeparator]: isShowSeparator,
              [styles.colSeparatorThin]: isShowSeparatorThin,
            })}
          >
            <div className={cn(styles.itemWrapper, { [styles.itemOverall]: isItemOverall })}>
              <div className={styles.itemValues}>
                {isContractualType && (
                  <>
                    <div className={styles.itemQuota}>
                      {props.showQuota && (
                        <>
                          {isHideCurrTargets ? (
                            <span>&nbsp;</span>
                          ) : (
                            <>
                              {fieldWrapper(
                                isCType ? currQuotaContr : currQuotaTran,
                                year,
                                isRetailer,
                                marketShareData,
                                'quota',
                                false,
                                0,
                                rounding
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                    {props.showActuals && (
                      <div className={styles.itemActual}>
                        {props.showActuals &&
                          fieldWrapper(
                            isCType ? currActualsContr : currActualsTran,
                            year,
                            isRetailer,
                            marketShareData,
                            'actuals',
                            false,
                            0,
                            rounding,
                            curActualTip
                          )}
                      </div>
                    )}
                    {isShowActualsSplit && props.showActuals && (
                      <div className={styles.itemActual}>
                        {actualsWrapper(
                          isCType ? currActualsContr : currActualsTran,
                          currActualsDirect,
                          year,
                          isRetailer,
                          marketShareData,
                          false,
                          0,
                          rounding
                        )}
                      </div>
                    )}
                    {isShowSmbVsEuSplit &&
                      props.showActuals &&
                      renderSmbVsEuSplitRows(currActualsSmbEu, rounding)}
                    <div
                      className={cn(styles.itemTarget, {
                        [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                      })}
                    >
                      {!isEditCells ? (
                        <>
                          {isHideCurrTargets ? (
                            <>&nbsp;</>
                          ) : (
                            <>
                              {isNoPlanFixed && !isPrevYear ? (
                                <Translation text="jbp-planning-no-plan" span />
                              ) : (
                                <>
                                  <MandatoryField value={value} isShow={isShowMandatory} />
                                  {fieldWrapper(
                                    value,
                                    year,
                                    isRetailer,
                                    marketShareData,
                                    'targets',
                                    isShowZero,
                                    0,
                                    rounding,
                                    curTargetTip
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {isNoPlanFixed && !isPrevYear ? (
                            <div className={styles.noPlanEditField}>
                              <Translation text="jbp-planning-no-plan" span />
                            </div>
                          ) : (
                            <>{editorRender()}</>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
                {isT && (
                  <>
                    <div className={styles.itemQuota}>
                      {props.showQuota && (
                        <>
                          {isHideCurrTargets ? (
                            <span>&nbsp;</span>
                          ) : (
                            <>
                              {fieldWrapper(
                                currQuotaTran,
                                year,
                                isRetailer,
                                marketShareData,
                                'quota',
                                false,
                                0,
                                rounding
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                    {props.showActuals && (
                      <div className={styles.itemActual}>
                        {props.showActuals &&
                          fieldWrapper(
                            currActualsTran,
                            year,
                            isRetailer,
                            marketShareData,
                            'actuals',
                            false,
                            0,
                            rounding
                          )}
                      </div>
                    )}
                    <div className={styles.itemTarget}>
                      {isHideCurrTargets ? (
                        <>&nbsp;</>
                      ) : (
                        <>
                          <WarningField
                            value={(currTargetsTran || 0).toFixed(0)}
                            isShow={isShowTransactionalWarning}
                          />
                          {fieldWrapper(
                            currTargetsTran,
                            year,
                            isRetailer,
                            marketShareData,
                            'targets',
                            false,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
                {isShowSmbVsEuSplit && renderSmbVsEuSplitRows(currTargetsSmbEu, rounding)}
                {/* PartnerCount, YoY, QoQ */}
                <ExtraFinRows {...extraRowsProps} />
              </div>
            </div>
          </td>
        )}
      </Fragment>
    )
  }

  const renderSoB = (
    idx: number,
    isOverall: boolean,
    q: number,
    isEditAllowed: boolean,
    isUnits: boolean,
    isNoPlan: boolean,
    isRollUp: boolean,
    mod: 'prevPrev' | 'prev' | 'calc' | 'curr' | 'futr'
  ) => {
    const isPrevPrevMod = mod === 'prevPrev'
    //const isPrevMod = mod === 'prev'
    const isPrevMod = mod === 'prev' || mod === 'calc'

    const isCalc = mod === 'calc'
    const isCurr = mod !== 'calc' // mod === 'curr' || mod === 'futr'

    const isCurrFY = mod === 'curr' // Only for visualizations
    const isFuture = mod === 'futr' // Only for visualizations

    const originalQ = q
    const isPrevYear = q < 0
    q = Math.abs(q)

    const isPlanningByFY = q >= PLANNING_BY_FY_FQ
    let futureYears = 0
    if (q > PLANNING_BY_FY_FQ) {
      futureYears = q - PLANNING_BY_FY_FQ
      q = PLANNING_BY_FY_FQ
    }
    const year = fyear - (isPrevPrevMod ? 2 : 0) - (isPrevMod ? 1 : 0) + futureYears

    const isEditFixed = isEditAllowed && !isRollUp

    const isShowActualsCell = props.showActuals

    const isSoB = true
    const isNoSplit = false
    const sTotal = ''

    const fsProps: IGetFinSobValueProps = {
      targetsItems,
      targetsNoSplitItems,
      actualsItems,
      actualsNoSplitItems,
      quotaItems,
      targetsRollupItems: targetsRollupItems,
      actualsRollupItems: actualsRollupItems,
      actualsPartnerCountItems,

      actualsSmbItems,
      actualsEuItems,
      targetsSmbItems,
      targetsEuItems,

      formats: props.formats,
      partnerId,
      actualsType: currentValueType,
      currency,
      isCollapsed,
      isShowOnlyCompletedPlans,
      isShowComposedSoB,
      isRecalcPlans,
      isComposedReportMode: props.composedReportMode,
      isQuarterlyBusinessReviewMode: props.isQuarterlyBusinessReviewMode,

      settingsIndex: idx,
      type: 'targets',
      fy: year,
      fq: q,
      isUnits,
      sType: sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isDirect: false,
      fieldName: '',
    }

    let prevFq = q - 1
    let prevFqFy = year
    if (q >= PLANNING_BY_FY_FQ) {
      // Planning by FY
      prevFq = q
      prevFqFy = year - 1
    } else if (q === 1) {
      prevFq = 4
      prevFqFy = year - 1
    }
    const preFqTargets = getFinSobValue({ ...fsProps, type: 'targets', fy: prevFqFy, fq: prevFq })
    const preFqActuals = getFinSobValue({ ...fsProps, type: 'actuals', fy: prevFqFy, fq: prevFq })

    // const isDirect = true
    const isNoDirect = false

    const preActual = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect
    )
    const preTarget = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect
    )
    const curActual = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect
    )
    const curTarget = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect
    )

    const curActualTipVal = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      CustomFields.JustifySob
    )
    const curTargetTipVal = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      CustomFields.JustifySob
    )
    const curActualTip = (curActualTipVal ?? '').toString()
    const curTargetTip = (curTargetTipVal ?? '').toString()

    const preActualState = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      SOB_STATE_FIELD
    )
    const preTargetState = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      SOB_STATE_FIELD
    )
    const curActualState = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      SOB_STATE_FIELD
    )
    const curTargetState = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      false,
      isRollUp,
      isNoDirect,
      SOB_STATE_FIELD
    )

    // TODO: is CompletenessItem need for RollUp?
    //const preActCompleteness = getCompletenessItem({ formats: props.formats, settingsIndex: idx, items: actualsItems, fy: year - 1, isSoB: true })
    //const preTarCompleteness = getCompletenessItem({ formats: props.formats, settingsIndex: idx, items: targetsItems, fy: year - 1, isSoB: true })
    const curActCompleteness = getCompletenessItem({
      formats: props.formats,
      settingsIndex: idx,
      items: actualsItems,
      fy: year,
      isSoB: true,
    })
    const curTarCompleteness = getCompletenessItem({
      formats: props.formats,
      settingsIndex: idx,
      items: targetsItems,
      fy: year,
      isSoB: true,
    })

    const isActiveColumns = true

    // Retail SOB
    const sobNotRetailerCondition = !isRetailer && (!isPlanningByFY || !!futureYears)
    const sobRetailerCondition = isRetailer && isPlanningByFY && !isPrevPrevMod
    const sobNewLogicCondition = isEditFixed && (sobNotRetailerCondition || sobRetailerCondition)

    const isEditCellsActuals = isSoBNewLogic ? sobNewLogicCondition : isEditFixed
    const isEditCellsTarget = isSoBNewLogic ? sobNewLogicCondition : isEditFixed && !isPrevYear
    const isEditCellsActualsOnly = isEditCellsActuals && !isEditCellsTarget

    const setting = props.formats[idx]

    const cat = setting.Category
    const subCat = setting.SubCategory
    const l3Cat = setting.L3Category

    const flags = partnerInfo?.PartnerFlags || ''
    const isMandatoryByFlag = isSubCategoryMandatory(
      flags,
      setting.SOBMandatoryByFlags,
      sectionSettings,
      false
    )

    const isTop = isTopPartner(buttonCurrType, props.partnerFlagsState, !!partnerInfo?.IsTopPartner)
    const isShowMandatoryCommon =
      (isMandatoryByFlag.isMandatory || cat === ROOM_CATEGORY) &&
      !isUnits &&
      !props.composedReportMode
    // Only TopPartners has mandatory SoB Target in Future FY
    const isShowMandatory = isShowMandatoryCommon && !isPrevYear && (!isFuture || isTop)
    const isPrevActualsFq4Mandatory = q !== 4 || !isPrevMod || isActualsFq4Come
    const isShowMandatoryActuals =
      isShowMandatoryCommon && isPrevMod && !isNoPlan && isPrevActualsFq4Mandatory

    const isShowZero = !IS_SHOW_NULL && isShowMandatory && Number(curTarget || 0) <= 0

    //const isShowPreActCompletenessField = !!props.composedReportMode && !!preActCompleteness.partnersNotCompleted
    //const isShowPreTarCompletenessField = !!props.composedReportMode && !!preTarCompleteness.partnersNotCompleted
    const isShowCurActCompletenessField =
      !!props.composedReportMode && !!curActCompleteness.partnersNotCompleted
    const isShowCurTarCompletenessField =
      !!props.composedReportMode && !!curTarCompleteness.partnersNotCompleted

    const isShowSeparator = isPlanningByFY
    const isShowSeparatorThin = !isPlanningByFY && q !== 1

    const editorRender = (type: 'actuals' | 'targets' | 'quota', fy: number, isPrev: boolean) => {
      const isActuals = type === 'actuals'
      const isTarget = type === 'targets'

      const actualsValue = isPrev ? preActual : curActual
      const value = isActuals ? actualsValue : curTarget

      const preState = isActuals ? preActualState : preTargetState
      const curState = isActuals ? curActualState : curTargetState
      const sobState = isPrev ? preState : curState
      const isCellHighlighted = sobState === FIELD_STATE_HIGHLIGHT && !(value || 0)

      // For H2 Review - disable H1 plan
      const isDisableH1 = isTarget && !!jbpSettings.isH2Review && (q === 1 || q === 2)

      // Retail SOB
      const isInputDisabled =
        sobState === FIELD_STATE_DISABLED ||
        (isActuals && isFuture) ||
        (isTarget && isPrevMod) ||
        (isRetailer && isActuals && isCurrFY) ||
        isDisableH1

      const isShowMandatoryField =
        ((isTarget && isShowMandatory) || (isActuals && isShowMandatoryActuals)) && !isDisableH1

      let isShowInputPopup = false
      let fieldValidationErrors: IFinSobValidationError[] = []
      if (props.isShowValidationPopup) {
        fieldValidationErrors = validationErrors.filter(
          (el) =>
            el.year === fy &&
            el.q === q &&
            el.settingIndex === idx &&
            el.valueType === type &&
            el.sType === sTotal &&
            el.inputIndex === validationInputIndex &&
            el.isSob &&
            !el.isUnits
        )
        if (fieldValidationErrors.length) {
          isShowInputPopup = true
        }
      }

      const categoryKey = `${setting.Category}-${setting.SubCategory}`
      const inputParams: Partial<IFinSobValidationError> = {
        category: setting.Category,
        categoryKey,
        settingIndex: idx,
        valueType: type,
        year: fy,
        q,
        isSob: true,
        isUnits: false,
      }
      const inputElementId = getInputElementId(inputParams)

      return (
        <>
          <MandatoryField value={value} isShow={isShowMandatoryField} />
          <AbsolutePopup
            rootClassName={cn(styles.sobInput, styles.filtersGroup__item, styles.filter)}
            popupContent={() => (
              <FinSobValidationPopupContent
                validationErrors={fieldValidationErrors}
                inputCount={validationInputsCount}
                inputIndex={validationInputIndex}
                inputsUnconfirmed={validationInputUnconfirmedCount}
                onPrevInput={handleValidationInputPrev}
                onNextInput={handleValidationInputNext}
                onSelectInput={handleSelectInput}
                onApply={handleValidationApply}
                onCancel={handleValidationCancel}
              />
            )}
            verticalDirection={TPopupVertical.Bottom}
            horizontalDirection={TPopupHorizontal.Left}
            verticalStartPosition={TPopupVertical.Bottom}
            horizontalStartPosition={TPopupHorizontal.Right}
            visibilityTrigger={TVisibilityTrigger.Custom}
            visibilityCallback={() => isShowInputPopup}
          >
            <FloatingNumberInput
              id={inputElementId}
              floatLength={8}
              disabled={isInputDisabled || props.isShowValidationPopup}
              hasSpin={false}
              align="right"
              classes={{
                inputClasses: {
                  root: cn(
                    { [styles.highlighted]: isCellHighlighted },
                    { [styles.validating]: isShowInputPopup }
                  ),
                  content: styles.numberInput,
                },
              }}
              value={value || value === 0 ? value.toString() : ''}
              onChange={(value) => {
                setValue(idx, value, type, fy, q, isUnits, isOverall, sTotal, isSoB, false)
              }}
              checkFn={ValidationHelper.checkNullablePercent}
              maximumFractionDigits={SOB_FRACTION_DIGITS}
            />
          </AbsolutePopup>
        </>
      )
    }

    const onSoBCompletenessClick = (partnersCompleteness: IPartnersCompleteness) => {
      const fullPartnersCompleteness = {
        ...partnersCompleteness,

        fYear: fyear,
        fQuarter: PLANNING_BY_FY_FQ,
        category: cat,
        subCategory: subCat,
        l3Category: l3Cat,
        isActuals: 0,
        isTargets: 1,

        isSob: 1,
      }

      setPartnersCompleteness(fullPartnersCompleteness)
    }

    const completenessTag = isShowOnlyCompletedPlans ? 'sobAck' : 'sob'

    const isHidePrevTargets = !isShowPrevTargets && !IS_NEW_LNF
    const isHideCurrTargets = isHidePrevTargets && isPrevYear
    const isHideCurrTargetsYoY = isHideCurrTargets || (isNoPlan && !isPrevYear)
    //const isShowPrevActualsEditor = isEditFixed && !isPrevYear && isSoBNewLogic

    const extraRowsProps = {
      ...commonExtraRowsProps,
      isPlanningByFY,
      isHideCurrTargetsYoY,
      isCalc,

      yoyPlans: calcDiff2(preTarget, curTarget),
      yoyTargets: calcDiff2(preActual, curTarget),
      yoyActuals: calcDiff2(preActual, curActual),

      qoqPlans: calcDiff2(preFqTargets, curTarget),
      qoqTargets: calcDiff2(preFqActuals, curTarget),
      qoqActuals: calcDiff2(preFqActuals, curActual),
    }

    const key = `jbp-planning-cells-q-sob-${currentCat}-${idx}-${originalQ}-${isUnits}-${isRollUp}-${mod}`

    return (
      <Fragment key={key}>
        {/* Prev FY (Calc) */}

        {isCalc && isShowCalcActuals && (
          <td
            style={{
              backgroundColor: getPlanningPeriodColumnColor(isPlanningByFY, isFuture, true),
            }}
            className={cn({
              [styles.colStrip]: !isActiveColumns,
              [styles.colSeparator]: isPlanningByFY,
              [styles.rollUp]: isRollUp,
            })}
          >
            <div className={styles.itemWrapper}>
              <div className={styles.itemValues}>
                <div className={cn(styles.itemActual, styles.itemTarget)}>&nbsp;</div>
                <div
                  className={cn(styles.itemTarget, {
                    [styles.itemSoBEditCell]: isEditFixed && isEditCellsTarget,
                    [styles.itemSoBEdit]:
                      isEditFixed && !isEditCellsTarget && !isEditCellsActualsOnly,
                    [styles.itemSoBEditActuals]: isEditFixed && isEditCellsActualsOnly,
                  })}
                >
                  &nbsp;
                </div>
                {/* PartnerCount, YoY, QoQ */}
                <ExtraSobRows {...extraRowsProps} />
              </div>
            </div>
          </td>
        )}

        {/* Current FY */}

        {isCurr && (
          <td
            style={{
              backgroundColor: getPlanningPeriodColumnColor(isPlanningByFY, isFuture, true),
            }}
            className={cn(styles.colSeparator, {
              [styles.colStrip]: !isActiveColumns,
              [styles.colStripCurrentSob]: isCurrFY,
              [styles.colSeparator]: isShowSeparator,
              [styles.colSeparatorThin]: isShowSeparatorThin,
              [styles.rollUp]: isRollUp,
            })}
          >
            <div className={styles.itemWrapper}>
              <div className={styles.itemValues}>
                <div className={cn(styles.itemActual, styles.itemTarget)}>
                  {isShowActualsCell && (
                    <>
                      {isShowCurActCompletenessField ? (
                        <PartnersCompletenessField
                          translationTag={completenessTag}
                          partnersCompleteness={curActCompleteness}
                          onClick={onSoBCompletenessClick}
                          type="actuals"
                        />
                      ) : (
                        <>
                          {!isEditCellsActuals ? (
                            <>
                              <MandatoryField value={curActual} isShow={isShowMandatoryActuals} />
                              {fieldWrapper(
                                curActual,
                                year,
                                isRetailer,
                                marketShareData,
                                'actuals',
                                isShowZero,
                                SOB_FRACTION_DIGITS,
                                '',
                                curActualTip
                              )}
                            </>
                          ) : (
                            editorRender('actuals', year, false)
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                <div
                  className={cn(styles.itemTarget, {
                    [styles.itemSoBEditCell]: isEditFixed && isEditCellsTarget,
                    [styles.itemSoBEdit]:
                      isEditFixed && !isEditCellsTarget && !isEditCellsActualsOnly,
                    [styles.itemSoBEditActuals]: isEditFixed && isEditCellsActualsOnly,
                  })}
                >
                  {isNoPlan && !isPrevYear ? (
                    <Translation text="jbp-planning-no-plan" span />
                  ) : (
                    <>
                      {isShowCurTarCompletenessField ? (
                        <PartnersCompletenessField
                          translationTag={completenessTag}
                          partnersCompleteness={curTarCompleteness}
                          onClick={onSoBCompletenessClick}
                          type="targets"
                        />
                      ) : (
                        <>
                          {!isEditCellsTarget ? (
                            <>
                              {isHideCurrTargets ? (
                                <>&nbsp;</>
                              ) : (
                                <>
                                  <MandatoryField value={curTarget} isShow={isShowMandatory} />
                                  {fieldWrapper(
                                    curTarget,
                                    year,
                                    isRetailer,
                                    marketShareData,
                                    'targets',
                                    isShowZero,
                                    SOB_FRACTION_DIGITS,
                                    '',
                                    curTargetTip
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            editorRender('targets', year, false)
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {/* PartnerCount, YoY, QoQ */}
                <ExtraSobRows {...extraRowsProps} />
              </div>
            </div>
          </td>
        )}
      </Fragment>
    )
  }

  const renderQOverall = (
    idx: number,
    isOverall: boolean,
    year: number,
    q: number,
    isUnits: boolean,
    isEditAllowed: boolean,
    isPrevYear: boolean,
    isNoPlan: boolean,
    isNoSplit: boolean,
    isRollUp: boolean,
    futureYears: number,
    mod: 'prevPrev' | 'prev' | 'calc' | 'curr' | 'futr'
  ) => {
    //const isPrevPrevMod = mod === 'prevPrev'
    //const isPrevMod = mod === 'prev' || mod === 'calc'

    const isCalc = mod === 'calc'
    const isCurr = mod !== 'calc' // mod === 'curr' || mod === 'futr'

    const isCurrFY = mod === 'curr' // Only for visualizations
    const isFuture = mod === 'futr' // Only for visualizations

    const isEditContr = isEditAllowed && (!isUseContractuals || splitType !== 'Total') && !isRollUp
    const isEditDistributor =
      isEditAllowed &&
      !isRollUp &&
      (!isUseContractuals ||
        (isShowContrTrans && splitType !== 'Total') ||
        (!isShowContrTrans && splitType !== 'Transactional'))
    const isEditFixed = props.isDistributorPlanner ? isEditDistributor : isEditContr

    const isPlanningByFY = q >= PLANNING_BY_FY_FQ

    const isUseCalcActualsForYoY = isPlanningByFY && !isPrevYear && !isFuture && isShowCalcActuals

    const sTotal = ''
    const isSoB = false
    const rounding = isUnits ? '' : props.rounding || props.roundingValue
    const isRounding = rounding && rounding !== PlanningRounding.AsIs
    const fractionDigits = isRounding ? FIN_FRACTION_DIGITS_ROUNDING : 0

    const fsProps: IGetFinSobValueProps = {
      targetsItems,
      targetsNoSplitItems,
      actualsItems,
      actualsNoSplitItems,
      quotaItems,
      targetsRollupItems: targetsRollupItems,
      actualsRollupItems: actualsRollupItems,
      actualsPartnerCountItems,

      actualsSmbItems,
      actualsEuItems,
      targetsSmbItems,
      targetsEuItems,

      formats: props.formats,
      partnerId,
      actualsType: currentValueType,
      currency,
      isCollapsed,
      isShowOnlyCompletedPlans,
      isShowComposedSoB,
      isRecalcPlans,
      isComposedReportMode: props.composedReportMode,
      isQuarterlyBusinessReviewMode: props.isQuarterlyBusinessReviewMode,

      settingsIndex: idx,
      type: 'targets',
      fy: year,
      fq: q,
      isUnits,
      sType: sTotal,
      isSoB,
      isNoSplit,
      isRollUp: false,
      isDirect: false,
      fieldName: '',
    }

    let prevFq = q - 1
    let prevFqFy = year
    if (q >= PLANNING_BY_FY_FQ) {
      // Planning by FY
      prevFq = q
      prevFqFy = year - 1
    } else if (q === 1) {
      prevFq = 4
      prevFqFy = year - 1
    }
    const preFqTargets = getFinSobValue({ ...fsProps, type: 'targets', fy: prevFqFy, fq: prevFq })
    const preFqActuals = getFinSobValue({ ...fsProps, type: 'actuals', fy: prevFqFy, fq: prevFq })

    const isDirect = true
    const isNoDirect = false

    const preActuals = getValue(
      idx,
      'actuals',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false,
      isNoDirect
    )
    const currActuals = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false,
      isNoDirect
    )
    const currActualsDirect = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false,
      isDirect
    )
    const currQuota = getValue(
      idx,
      'quota',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect
    )
    const preTargets = getValue(
      idx,
      'targets',
      year - 1,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect
    )
    const currTargets = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect
    )
    const currTargetsRound = getRoundedValue(currTargets, rounding)

    const comment = getValueFrom(idx, 'targets', year, q, isNoSplit, isRollUp)
    const planState = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect,
      PLAN_STATE_FIELD
    )

    const jField = isUnits ? CustomFields.JustifyUnits : CustomFields.Justify
    const curActualTipVal = getValue(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect,
      jField
    )
    const curTargetTipVal = getValue(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp,
      isNoDirect,
      jField
    )
    const curActualTip = (curActualTipVal ?? '').toString()
    const curTargetTip = (curTargetTipVal ?? '').toString()

    const calActualsFy = isUseCalcActualsForYoY ? year - 1 : year
    const preActualsCalc = getCalcActuals(
      idx,
      calActualsFy,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isNoDirect
    )
    const preActualsCalcDirect = getCalcActuals(
      idx,
      calActualsFy,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isDirect
    )

    const preTargetsForYoY = preTargets
    const preActualsForYoY = isUseCalcActualsForYoY || mod === 'calc' ? preActualsCalc : preActuals

    const partnerCount = getFinSobValue({ ...fsProps, type: 'partnerCount' })
    const partnerCountPercent = partnerCount ? 100 : 0
    const partnerCountPreFy = getFinSobValue({ ...fsProps, type: 'partnerCount' })
    const partnerCountPreFq = getFinSobValue({
      ...fsProps,
      type: 'partnerCount',
      fy: prevFqFy,
      fq: prevFq,
    })

    const extraRowsProps = {
      ...commonExtraRowsProps,
      isPlanningByFY,

      partnerCount,
      partnerCountPercent,
      partnerCountYoY: calcDiff2(partnerCountPreFy, partnerCount),
      partnerCountQoQ: calcDiff2(partnerCountPreFq, partnerCount),
      isShowYoYPartnersVsPartners: isShowYoYPartnersVsPartners,
      isShowQoQPartnersVsPartners: isShowQoQPartnersVsPartners,

      yoyPlans: calcPercentage(preTargetsForYoY, currTargets),
      yoyTargets: calcPercentage(preActualsForYoY, currTargets),
      yoyActuals: calcPercentage(preActualsForYoY, currActuals),
      yoyQuota: calcPercentage(preActualsForYoY, currQuota),

      yoyTargetsAch: calcPercentage2(currActuals, currTargets),
      yoyQuotaAch: calcPercentage2(currActuals, currQuota),

      qoqPlans: calcPercentage(preFqTargets, currTargets),
      qoqTargets: calcPercentage(preFqActuals, currTargets),
      qoqActuals: calcPercentage(preFqActuals, currActuals),
      qoqQuota: calcPercentage(preFqActuals, currQuota),
    }

    const gtmOnline = getGtmPoints(marketShareData, currTargets, year, 'Online')
    const gtmInstore = getGtmPoints(marketShareData, currTargets, year, 'Instore')
    const gtmOnlineFormatted = formatMoneyInteger(gtmOnline)
    const gtmInstoreFormatted = formatMoneyInteger(gtmInstore)

    // SMB vs EU split
    const preActualsCalcSmbEu = getCalcActualsSmbEu(
      idx,
      calActualsFy,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit
    )
    const currActualsSmbEu = getSmbEuValues(
      idx,
      'actuals',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      false
    )
    const currTargetsSmbEu = getSmbEuValues(
      idx,
      'targets',
      year,
      q,
      isUnits,
      sTotal,
      isSoB,
      isNoSplit,
      isRollUp
    )

    const isActiveColumns =
      (isQuarterPlanning && !isPlanningByFY) ||
      (!isQuarterPlanning && isPlanningByFY) ||
      !!futureYears

    const setting = props.formats[idx]
    const isCategoryAlwaysOverall = !setting.SubCategory

    const l3Cat = setting.L3Category
    const isL3 = !!l3Cat
    const isL3Collapsed = getIsCollapsedL3Category(targetsItems, fyear, setting.SubCategory)
    const isEditModeForCollapsed = isEditFixed && (isFixedCollapsed || isCategoryAlwaysOverall)
    const isEditModeForL3Collapsed = isEditFixed && isL3Collapsed
    const isEditCells =
      (isL3 ? isEditModeForL3Collapsed : isEditModeForCollapsed) && isActiveColumns && !isPrevYear
    //const isEditComment = isEditCells && !isPlanningByFY

    const isActiveRow =
      (isFixedCollapsed && isOverall) ||
      (!isFixedCollapsed && !isOverall) ||
      isCategoryAlwaysOverall

    const flags = partnerInfo?.PartnerFlags || ''
    const isMandatoryByFlag = isSubCategoryMandatory(
      flags,
      setting.MandatoryByFlags,
      sectionSettings,
      false
    )
    const isMandatoryUnitsByFlag = isSubCategoryMandatory(
      flags,
      setting.UnitsMandatoryByFlags,
      sectionSettings,
      false
    )
    const isShowMandatoryByFlag =
      (!isUnits && isMandatoryByFlag.isMandatory) || (isUnits && isMandatoryUnitsByFlag.isMandatory)
    const isShowMandatoryForCategory = isOverall || !isCollapseAllowed
    const isShowMandatoryCommon = isMandatoryByFlagLogic
      ? isShowMandatoryByFlag
      : isShowMandatoryForCategory

    const isTop = isTopPartner(buttonCurrType, props.partnerFlagsState, !!partnerInfo?.IsTopPartner)
    // For H2 Review - disable H1 plan
    const isDisableH1 = !!jbpSettings.isH2Review && (q === 1 || q === 2)
    const isShowMandatory =
      isShowMandatoryCommon &&
      !isPrevYear &&
      !props.composedReportMode &&
      (!isFuture || isTop) &&
      !isDisableH1

    const isShowZero = !IS_SHOW_NULL && isShowMandatory && Number(currTargets || 0) <= 0

    let isShowNoSplitActuals = true
    if (isNoSplit) {
      const actualsNoSplitSum = getTwoYearsSum({
        formats: props.formats,
        settingsIndex: idx,
        items: actualsNoSplitItems,
        fyear,
        isGetUnits: false,
        isAddContractual: false,
        actualsType,
        isDirect: false,
        isComposedCompletedPlans: isShowOnlyCompletedPlans,
        isComposedSob: false,
      })
      isShowNoSplitActuals = !!actualsNoSplitSum
    }

    const isShowActualsCell = isNoSplit ? isShowNoSplitActuals : props.showActuals
    const isShowQuota = props.showQuota && !isRollUp
    const isStripCol = (!isActiveColumns || isFuture) && !isRollUp

    const isHidePrevTargets = !isShowPrevTargets && !IS_NEW_LNF
    const isHideCurrTargets = isHidePrevTargets && isPrevYear
    //const isHideCurrTargetsYoY = isHideCurrTargets || (isNoPlan && !isPrevYear)

    const isShowSeparator = isPlanningByFY
    const isShowSeparatorThin = !isPlanningByFY && q !== 1

    const editorRender = () => {
      const isCellHighlighted = planState === FIELD_STATE_HIGHLIGHT && !(currTargets || 0)
      const isInputDisabled = planState === FIELD_STATE_DISABLED || isDisableH1

      let isShowInputPopup = false
      let fieldValidationErrors: IFinSobValidationError[] = []
      if (props.isShowValidationPopup) {
        fieldValidationErrors = validationErrors.filter(
          (el) =>
            el.year === year &&
            el.q === q &&
            el.settingIndex === idx &&
            el.valueType === 'targets' &&
            el.sType === sTotal &&
            el.inputIndex === validationInputIndex &&
            !el.isSob &&
            el.isUnits === isUnits
        )
        if (fieldValidationErrors.length) {
          isShowInputPopup = true
        }
      }

      const categoryKey = `${setting.Category}-${setting.SubCategory}`
      const inputParams: Partial<IFinSobValidationError> = {
        category: setting.Category,
        categoryKey,
        settingIndex: idx,
        valueType: 'targets',
        year,
        q,
        isSob: false,
        isUnits,
      }
      const inputElementId = getInputElementId(inputParams)

      return (
        <>
          <MandatoryField value={currTargets} isShow={isShowMandatory} />
          <AbsolutePopup
            rootClassName={cn(styles.finInput, styles.filtersGroup__item, styles.filter)}
            popupContent={() => (
              <FinSobValidationPopupContent
                validationErrors={fieldValidationErrors}
                inputCount={validationInputsCount}
                inputIndex={validationInputIndex}
                inputsUnconfirmed={validationInputUnconfirmedCount}
                onPrevInput={handleValidationInputPrev}
                onNextInput={handleValidationInputNext}
                onSelectInput={handleSelectInput}
                onApply={handleValidationApply}
                onCancel={handleValidationCancel}
              />
            )}
            verticalDirection={TPopupVertical.Bottom}
            horizontalDirection={TPopupHorizontal.Left}
            verticalStartPosition={TPopupVertical.Bottom}
            horizontalStartPosition={TPopupHorizontal.Right}
            visibilityTrigger={TVisibilityTrigger.Custom}
            visibilityCallback={() => isShowInputPopup}
          >
            <FloatingNumberInput
              id={inputElementId}
              floatLength={8}
              disabled={isInputDisabled || props.isShowValidationPopup}
              hasSpin={false}
              align="right"
              classes={{
                inputClasses: {
                  root: cn(
                    styles.cell,
                    styles.cell__input,
                    { [styles.highlighted]: isCellHighlighted },
                    { [styles.validating]: isShowInputPopup }
                  ),
                  content: styles.numberInput,
                },
              }}
              value={currTargetsRound || currTargetsRound === 0 ? currTargetsRound.toString() : ''}
              onChange={(valueStr) => {
                const value = valueStr
                  ? getRestoredValue(Number(valueStr || 0), rounding).toFixed(0)
                  : null

                setValue(
                  idx,
                  value,
                  'targets',
                  year,
                  q,
                  isUnits,
                  isOverall,
                  sTotal,
                  isSoB,
                  isNoSplit
                )
              }}
              checkFn={ValidationHelper.checkNullableNumber}
              maximumFractionDigits={fractionDigits}
            />
          </AbsolutePopup>
        </>
      )
    }

    const key = `jbp-planning-cells-q-overall-${currentCat}-${idx}-${q}-${futureYears}-${isUnits}-${isRollUp}-${mod}`

    return (
      <Fragment key={key}>
        {/* Prev FY (Calc) */}

        {isCalc && isShowCalcActuals && (
          <td
            style={{ backgroundColor: getPlanningPeriodColumnColor(isPlanningByFY, isFuture) }}
            className={cn({
              [styles.colStrip]: isStripCol,
              [styles.colSeparator]: isPlanningByFY,
            })}
          >
            <div
              className={cn(styles.itemWrapper, {
                [styles.itemOverall]: !(props.showActuals || isShowQuota) && !isEditCells,
              })}
            >
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>{isShowQuota && <>&nbsp;</>}</div>
                {isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {fieldWrapper(
                      preActualsCalc,
                      year - 1,
                      isRetailer,
                      marketShareData,
                      'actuals',
                      false,
                      0,
                      rounding
                    )}
                  </div>
                )}
                {isShowActualsSplit && isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {actualsWrapper(
                      preActualsCalc,
                      preActualsCalcDirect,
                      year - 1,
                      isRetailer,
                      marketShareData,
                      false,
                      0,
                      rounding
                    )}
                  </div>
                )}
                {isShowSmbVsEuSplit &&
                  isShowActualsCell &&
                  renderSmbVsEuSplitRows(preActualsCalcSmbEu, rounding)}
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                  })}
                >
                  {isHideCurrTargets ? (
                    <>&nbsp;</>
                  ) : (
                    <>
                      {isNoPlan && !isPrevYear ? (
                        <Translation text="jbp-planning-no-plan" span />
                      ) : (
                        <>
                          <MandatoryField value={currTargets} isShow={isShowMandatory} />
                          {fieldWrapper(
                            currTargets,
                            year,
                            isRetailer,
                            marketShareData,
                            'targets',
                            isShowZero,
                            0,
                            rounding
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {isShowSmbVsEuSplit && renderSmbVsEuSplitRows(currTargetsSmbEu, rounding)}
                {/* PartnerCount, YoY, QoQ */}
                <ExtraFinRows {...extraRowsProps} />
              </div>
            </div>
          </td>
        )}

        {/* Current FY */}

        {isCurr && (
          <td
            style={{ backgroundColor: getPlanningPeriodColumnColor(isPlanningByFY, isFuture) }}
            className={cn(styles.colSeparator, {
              [styles.colStrip]: isStripCol,
              [styles.colStripCurrent]: isCurrFY,
              [styles.colSeparator]: isShowSeparator,
              [styles.colSeparatorThin]: isShowSeparatorThin,
            })}
          >
            <div
              className={cn(styles.itemWrapper, {
                [styles.itemOverall]: !(props.showActuals || isShowQuota) && !isEditCells,
              })}
            >
              <div className={styles.itemValues}>
                <div className={styles.itemQuota}>
                  {isShowQuota && (
                    <>
                      {isHideCurrTargets ? (
                        <span>&nbsp;</span>
                      ) : (
                        <>
                          {fieldWrapper(
                            currQuota,
                            year,
                            isRetailer,
                            marketShareData,
                            'quota',
                            false,
                            0,
                            rounding,
                            curActualTip
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                <div className={styles.itemActual}>
                  {isShowActualsCell &&
                    fieldWrapper(
                      currActuals,
                      year,
                      isRetailer,
                      marketShareData,
                      'actuals',
                      false,
                      0,
                      rounding
                    )}
                </div>
                {isShowActualsSplit && isShowActualsCell && (
                  <div className={styles.itemActual}>
                    {actualsWrapper(
                      currActuals,
                      currActualsDirect,
                      year,
                      isRetailer,
                      marketShareData,
                      false,
                      0,
                      rounding
                    )}
                  </div>
                )}
                {isShowSmbVsEuSplit &&
                  isShowActualsCell &&
                  renderSmbVsEuSplitRows(currActualsSmbEu, rounding)}
                <div
                  className={cn(styles.itemTarget, {
                    [styles.targetEdit]: isEditFixed && isActiveRow && !isEditCells,
                  })}
                >
                  {!isEditCells && <CommentIcon tooltipText={comment} />}
                  {!isEditCells ? (
                    <>
                      {isHideCurrTargets ? (
                        <>&nbsp;</>
                      ) : (
                        <>
                          {isNoPlan && !isPrevYear ? (
                            <Translation text="jbp-planning-no-plan" span />
                          ) : (
                            <>
                              <MandatoryField value={currTargets} isShow={isShowMandatory} />
                              {fieldWrapper(
                                currTargets,
                                year,
                                isRetailer,
                                marketShareData,
                                'targets',
                                isShowZero,
                                0,
                                rounding,
                                curTargetTip
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {isNoPlan && !isPrevYear ? (
                        <div className={styles.noPlanEditField}>
                          <Translation text="jbp-planning-no-plan" span />
                        </div>
                      ) : (
                        <>
                          {!isShowRetailerGtmPriorities ? (
                            editorRender()
                          ) : (
                            <Tooltip
                              tipContent={() => (
                                <span className={styles.tipContent}>
                                  <span className={styles.tipLine}>
                                    <Translation text="jbp-gtm-priorities-online-tip" span />
                                    {gtmOnlineFormatted}
                                  </span>
                                  <br />
                                  <span className={styles.tipLine}>
                                    <Translation text="jbp-gtm-priorities-instore-tip" span />
                                    {gtmInstoreFormatted}
                                  </span>
                                </span>
                              )}
                            >
                              {editorRender()}
                            </Tooltip>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {isShowSmbVsEuSplit && renderSmbVsEuSplitRows(currTargetsSmbEu, rounding)}
                {/* PartnerCount, YoY, QoQ */}
                <ExtraFinRows {...extraRowsProps} />
              </div>
            </div>
          </td>
        )}
      </Fragment>
    )
  }

  const renderApplySection = () => {
    const isApplyDisabled =
      !isDataChanged ||
      isNotChanged ||
      validationStatus !== ValidationStatus.Valid ||
      !isTransactionalValid()

    return (
      <table className={cn(stylesTable.table, stylesCompensation.table, styles.table)}>
        <caption className={styles.footer}>
          <div className={styles.buttonContent}>
            {isChangeApplying && <Loader className={styles.loader} />}
            <Button
              className={styles.footer__apply}
              disabled={isApplyDisabled}
              onClick={applyChangesHandler}
            >
              <Translation text={applyButtonKey} span />
            </Button>
          </div>
          <Button
            disabled={!isDataChanged || isNotChanged || validationStatus !== ValidationStatus.Valid}
            onClick={discardChanges}
            color={'grey'}
            className={styles.button}
          >
            <Translation text="jbp-cancel" span />
          </Button>
        </caption>
      </table>
    )
  }

  /** -------------------- Effects ----------------------- */

  useEffect(() => {
    let availableActualsTypes: ActualsValueTypes[] = []
    if (props.dataSetInfo.Settings?.ActualsValueTypes?.length) {
      availableActualsTypes = props.dataSetInfo.Settings.ActualsValueTypes
      if (props.dataSetInfo.Settings?.ActualsValueTypesDefault) {
        setCategoryValueType(props.dataSetInfo.Settings?.ActualsValueTypesDefault)
      }
    }
    setCategoryValueTypes(availableActualsTypes)
  }, [props.dataSetInfo.Settings])

  useEffect(() => {
    if (!props.urlActualsValueType) return

    const urlTypeLower = props.urlActualsValueType.toLowerCase()
    const urlType = Object.values(ActualsValueTypes).find((v) => v.toLowerCase() === urlTypeLower)
    if (!urlType) return

    if (categoryValueTypes.length) {
      if (categoryValueTypes.includes(urlType)) {
        setCategoryValueType(urlType)
      }
    } else {
      if (actualsTypes.includes(urlType)) {
        onChangeActualsType(urlType)
      }
    }
  }, [props.urlActualsValueType, categoryValueTypes, actualsTypes, onChangeActualsType])

  useEffect(() => {
    if (partnerInfo) {
      calcCollapseMode()
    }
  }, [partnerInfo, calcCollapseMode])

  useEffect(() => {
    updatePendingData(undefined, ValidationStatus.Valid)

    if (
      (partnerId && fyear && buttonCurrType) ||
      props.composedReportMode ||
      props.isQuarterlyBusinessReviewMode
    ) {
      preparePlanningData()
    }
  }, [
    partnerId,
    fyear,
    buttonCurrType,
    props.composedReportMode,
    props.isQuarterlyBusinessReviewMode,
    preparePlanningData,
  ])

  useEffect(() => {
    if (!isCollapsed) {
      setIsShowComposedSoB(false)
    }
  }, [isCollapsed])

  useEffect(() => {
    const unconfirmedInputs = Array.from(
      new Set(validationErrors.filter((el) => !el.isChecked).map((el) => el.inputIndex))
    )
    setValidationInputUnconfirmedCount(unconfirmedInputs.length)
  }, [validationErrors])

  useEffect(() => {
    if (isYearlyPlanning) {
      const isYearlyPlanningDefault = !!isRetailer
      const isYearlyPlanningOn = isOn('', 'yearly-planning', isYearlyPlanningDefault) // One for all categories
      if (!isYearlyPlanningOn) {
        props.displaySettings.actions.setIsYearlyPlanning(false)
      }
    }
  }, [currentCat, isOn, isRetailer, isYearlyPlanning, props.displaySettings.actions, setSetting])

  /** -------------------- Render ----------------------- */

  const isPlanningSmbVisible =
    !isDistributor &&
    !!props.isOfferingPlanningCompleted &&
    (!isNotApplicableAllowed || !isCategoryNA)

  return (
    <div className={styles.root}>
      <Controller
        onValidationStatusChange={({ status }) => {
          status !== 'WIP' && setValidationStatus(status)
          updatePendingData(undefined, status)
        }}
      >
        {isShowPlanningSection && (
          <table className={cn(stylesTable.table, stylesCompensation.table, styles.table)}>
            <caption>
              <CategoryInfo
                dataSetInfo={props.dataSetInfo}
                partnerCountryCode={partnerInfo?.CountryCode}
                isShowTotal={props.isShowTotal}
                categoryName={categoryName}
                isShowValueTypeWarning={isShowValueTypeWarning}
              />
              <WidgetHeaderWithHelpButton section={HelpSection.FinancialAndSOB}>
                {categoryHeaderKey}
              </WidgetHeaderWithHelpButton>
              {isEditAllowed && (
                <div>
                  <div className={styles.captionCell}>
                    <div className={styles.switchersContainer}>
                      {isEditAllowed && isShowNotApplicableWidget && (
                        <NotApplicableWidget
                          value={isCategoryNA}
                          className={styles.input}
                          canEdit={isNotApplicableAllowed && isEditAllowed}
                          onChange={async () => {
                            if (isNeedToShowSignNADialog) {
                              setIsShowSignDialogNA(true)
                            } else {
                              if (isCategoryNA) {
                                await onChangeNotApplicable()
                              } else {
                                setIsShowConfirmNotApplicableDialog(true)
                              }
                            }
                          }}
                        />
                      )}
                      {(!isNotApplicableAllowed || !isCategoryNA) && (
                        <>
                          {isEditAllowed && (
                            <>
                              <div className={styles.switcher}>
                                <Switch
                                  padding
                                  disabled={isOnlyQuarterlyPlanning}
                                  checked={isQuarterPlanning}
                                  onChange={handleQuarterSettingChange}
                                />
                                <div className={styles.switcherText}>
                                  <Translation span text="jbp-planning-quarter-switcher" />
                                </div>
                              </div>
                              {!!props.dataSetInfo.IsSoBAvailable && !IS_ALWAYS_SHOW_SOB && (
                                <div className={styles.switcher}>
                                  <Switch
                                    padding
                                    checked={isOn(currentCat, 'sob', IS_ALWAYS_SHOW_SOB)}
                                    onChange={() => setSetting(currentCat, 'sob')}
                                  />
                                  <div className={styles.switcherText}>
                                    <Translation span text="jbp-planning-sob-switcher" />
                                  </div>
                                </div>
                              )}
                              {!!props.dataSetInfo.IsUnitsAvailable && (
                                <div className={styles.switcher}>
                                  <Switch
                                    padding
                                    disabled={isUnitsMandatory}
                                    checked={isOn(currentCat, 'units')}
                                    onChange={() => setSetting(currentCat, 'units')}
                                  />
                                  <div className={styles.switcherText}>
                                    <Translation span text="jbp-planning-units-switcher" />
                                  </div>
                                </div>
                              )}
                              {!!props.dataSetInfo.IsSoBAvailable && (
                                <div className={styles.switcher}>
                                  <Switch
                                    padding
                                    disabled={isSobDetailsMandatory}
                                    checked={
                                      isSobDetailsMandatory || isOn(currentCat, 'sob-details')
                                    }
                                    onChange={() => setSetting(currentCat, 'sob-details')}
                                  />
                                  <div className={styles.switcherText}>
                                    <Translation span text="jbp-planning-sob-details-switcher" />
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {isShowNotApplicableMessage && (
                <div>
                  <div className={styles.captionCell}>
                    <div className={styles.input}>
                      <Translation span text="jbp-not-applicable-status-not-applicable" />
                    </div>
                  </div>
                </div>
              )}

              {!isCategoryNA && (
                <div>
                  <div className={styles.captionCell}>
                    <div
                      className={cn(styles.switchersContainer, {
                        [styles.switchersContainerFull]: isPlanningSmbVisible,
                      })}
                    >
                      {isShowCurrencyCtrl && <CurrenciesButtons />}
                      {isShowNetNdpCtrl && (
                        <>
                          <div className={styles.filterNextItemEmpty} />
                          {isShowCategoryValueTypes ? (
                            <ValueTypeSwitcher
                              onChangeValueType={handleChangeCategoryValueType}
                              valueType={actualsType}
                              valueTypes={categoryValueTypes}
                            />
                          ) : (
                            <ActualsTypeButtons />
                          )}
                        </>
                      )}
                      {isShowSalesTypeCtrl && (
                        <>
                          <div className={styles.filterNextItemEmpty} />
                          <div className={styles.sellTypeNoWrap}>
                            <SellTypeButtons actualsType={actualsType} />
                          </div>
                        </>
                      )}
                      {IS_ENABLE_ROUNDING && (
                        <>
                          <div className={styles.filterNextItemEmpty} />
                          <Tooltip
                            inline
                            tipContent={() => <Translation span text="jbp-planning-rounding-tip" />}
                            horizontalStartPosition={TPopupHorizontal.Center}
                            horizontalDirection={TPopupHorizontal.Right}
                          >
                            <RowButtons
                              generateTranslationKey={(value) => value}
                              value={props.roundingValue}
                              options={ROUNDING_VALUES}
                              onOptionClick={props.setRoundingValue}
                            />
                          </Tooltip>
                          {isRetailer && (
                            <>
                              <div className={styles.filterNextItemEmpty} />
                              <div className={styles.optionSwitcherContainer}>
                                <RowButtons
                                  value={isShowDetailedPlanning ? 'Hierarchical' : 'Flat'}
                                  options={DISPLAY_OPTIONS}
                                  generateTranslationKey={(val) => generateTranslationKey(val)}
                                  onOptionClick={() =>
                                    props.displaySettings.actions.setIsShowDetailedPlanning(
                                      !isShowDetailedPlanning
                                    )
                                  }
                                />
                              </div>
                            </>
                          )}
                          {isExistControlsAfterRounding && (
                            <div className={styles.filterNextItemEmpty}></div>
                          )}
                        </>
                      )}
                      {isShowActualsCtrl && !IS_ALWAYS_SHOW_ACTUALS && (
                        <div
                          className={cn(styles.filterItem, {
                            [styles.filterNextItem]: !isShowActualsCtrlFirst,
                          })}
                          style={{ color: actualsColor }}
                        >
                          <Checkbox
                            checked={props.showActuals}
                            label={<Translation text={'jbp-partner-actuals-show-actuals'} span />}
                            onChange={(val) => props.setShowActuals(!!val)}
                          />
                        </div>
                      )}
                      {isShowQuotaCtrl && (
                        <div
                          className={cn(styles.filterItem, {
                            [styles.filterNextItem]: !isShowQuotaCtrlFirst,
                          })}
                          style={{ color: quotaColor }}
                        >
                          <Checkbox
                            checked={props.showQuota}
                            label={<Translation text={'jbp-partner-actuals-show-quota'} span />}
                            onChange={(val) => props.setShowQuota(!!val)}
                          />
                        </div>
                      )}
                      {isDistributor && isRegionalDistributor && (
                        <Checkbox
                          className={cn(styles.filterItem, {
                            [styles.filterNextItem]: !isShowDistributorCtrlFirst,
                          })}
                          checked={props.isRegionalPlanning}
                          label={
                            <Translation text={'jbp-distributor-show-regional-planning'} span />
                          }
                          onChange={(val) => props.setIsRegionalPlanning(!!val)}
                        />
                      )}
                      {isShowComposedModeSwitchers && (
                        <>
                          <div className={styles.switcher}>
                            <Switch
                              padding
                              disabled={isShowComposedSoB}
                              checked={isShowOnlyCompletedPlans}
                              onChange={() => setIsShowOnlyCompletedPlans((val) => !val)}
                            />
                            <div className={styles.switcherText}>
                              <Translation span text="jbp-planning-show-only-completed-plans" />
                            </div>
                          </div>
                          {!!props.dataSetInfo.IsSoBAvailable && (
                            <div className={styles.switcher}>
                              <Switch
                                padding
                                disabled={isComposedSobDisabled}
                                checked={isShowComposedSoB}
                                onChange={toggleShowComposedSob}
                              />
                              <div className={styles.switcherText}>
                                <Translation span text="jbp-planning-show-sob" />
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      {isShowPrevTargetsCtrl && (
                        <div className={styles.filterItem}>
                          <Checkbox
                            checked={isShowPrevTargets}
                            onChange={(val) =>
                              props.displaySettings.actions.setIsShowPreviousPlans(!val)
                            }
                            label={
                              <Translation
                                span
                                text={`jbp-planning-show-prev-targets${
                                  props.showQuota ? '-quota' : ''
                                }`}
                                replaceParams={showPrevTargetsParams}
                              />
                            }
                          />
                        </div>
                      )}
                      {isShowComposedModeSwitchers &&
                        IS_USE_RECALC_PLANS_FROM_BOTTOM_FUNCTIONALITY && (
                          <div className={styles.switcher}>
                            <Switch
                              padding
                              checked={isRecalcPlans}
                              onChange={() => setIsRecalcPlans((val) => !val)}
                            />
                            <div className={styles.switcherText}>
                              <Translation span text="jbp-planning-recalc-plans-from-bottom" />
                            </div>
                          </div>
                        )}
                      {isPlanningSmbVisible && (
                        <div className={styles.smbEuSlot}>
                          <PlanningSmbSwitcher
                            isVisible={isPlanningSmbVisible}
                            formats={props.planningSmbFormats ?? props.formats}
                            planningData={props.planningData}
                            planningSmb={props.planningSmbData || []}
                            partnerId={partnerId}
                            partnerName={partnerInfo?.PartnerName || partnerId}
                            isDistributor={isDistributor}
                            fYear={fyear}
                            programType={planningSmbProgramType}
                            category={currentCat}
                            sectionSettings={sectionSettings}
                            globalCategory={props.globalCategory ? globalCategoryKey : undefined}
                            planActualsType={currentValueType}
                            planCurrency={currency}
                            actualsTypes={
                              isShowCategoryValueTypes ? categoryValueTypes : actualsTypes
                            }
                            currencies={availableCurrencies}
                            roundingValue={props.roundingValue}
                            roundingOptions={ROUNDING_VALUES}
                            onRoundingChange={(value) =>
                              props.setRoundingValue(value as PlanningRounding)
                            }
                            isQuarterlyPlanning={isQuarterPlanning}
                            isQuarterlyPlanningDisabled={isOnlyQuarterlyPlanning}
                            isEditMode={isEditMode}
                            // SMB save reloads all planning data. Lock every editor while any rendered
                            // category has local Financial/SOB edits so the reload cannot discard them.
                            isEditAllowed={
                              isEditAllowed &&
                              isNotChanged &&
                              props.isPlanningSmbEditAllowed !== false
                            }
                            formatMoney={formatPlanningSmbMoney}
                            onSaved={() => props.onReloadPlanningData?.()}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </caption>

            {!isCategoryNA && (
              <thead>
                {isShowInformationBanners && (
                  <tr>
                    <th colSpan={planningColSpan}>
                      {props.showActuals && (
                        <div className={styles.infoContainer}>
                          <i
                            className={cn('kbase kbase-info-alt', styles.infoIcon)}
                            aria-hidden="true"
                          />
                          <span className={styles.actualsLegend}>
                            <Translation text="jbp-planning-actuals-legend" actionsInside />
                          </span>
                          <span className={styles.targetsLegend}>
                            <Translation text="jbp-planning-targets-legend" actionsInside />
                          </span>
                        </div>
                      )}
                      <div className={styles.infoContainer}>
                        {!props.showActuals && (
                          <i
                            className={cn('kbase kbase-info-alt', styles.infoIcon)}
                            aria-hidden="true"
                          />
                        )}
                        <Translation
                          text={
                            props.showActuals
                              ? 'jbp-planning-targets-info'
                              : 'jbp-planning-actuals-info'
                          }
                          actionsInside
                        />
                      </div>
                      <div className={styles.infoContainer}>
                        <MandatoryField value={null} isShow={true} />
                        <Translation text="jbp-planning-mandatory-legend" />
                      </div>
                    </th>
                  </tr>
                )}
                {isUseContractuals && (
                  <SplitPlanningRow
                    splitType={splitType}
                    setSplitType={setSplitType}
                    isShowAllSplits={isShowAllSplits}
                    setIsShowAllSplits={setIsShowAllSplits}
                    isDistributorPlanner={props.isDistributorPlanner}
                    colSpan={planningColSpan}
                  />
                )}
                {!isCategoryNA && (
                  <>
                    {isShowMapRow && (
                      <MapRow
                        mapData={props.mapData}
                        fyear={fyear}
                        category={currentCat}
                        subCategory={OVERALL_CATEGORY}
                        tag="jbp-market-growth-guidance"
                        isYearlyPlanning={isYearlyPlanning}
                        isShowCalcActuals={isShowCalcActuals}
                        isShowFutureYears={isShowFutureYears}
                        hideIfEmpty
                      />
                    )}
                    <CategoryHeader
                      translationKey="jbp-planning-header"
                      fyear={fyear}
                      isYearlyPlanning={isYearlyPlanning}
                      isShowCalcActuals={isShowCalcActuals}
                      isShowFutureYears={isShowFutureYears}
                      currentFQuarter={jbpSettings.currentFQuarter}
                      periodFQuarters={fQuarters}
                      isQbrYtd={props.isQuarterlyBusinessReviewMode}
                    />
                  </>
                )}
              </thead>
            )}
            {!isCategoryNA && isShowCurrencyBlock && (
              <tbody>
                {props.formats.map((format, idx) => {
                  const cat = format.Category
                  const subCat = format.SubCategory

                  const isOverall = subCat === OVERALL_CATEGORY || !subCat
                  const isShowCollapseButton =
                    (isEditAllowed || props.composedReportMode) &&
                    isCollapseAllowed &&
                    !isOverallOnly &&
                    isOverall &&
                    !isAlwaysExpanded

                  const l3Cat = format.L3Category
                  const isL3Overall = l3Cat === OVERALL_CATEGORY
                  const isL3 = !!l3Cat

                  // Retail Collapse: isRetailer ||
                  const isCatForcedExpanded = getIsExpandedByFlags({
                    settings: format.Settings,
                    flagsState: props.partnerFlagsState,
                  })

                  const isL3Collapsed =
                    getIsCollapsedL3Category(targetsItems, fyear, subCat) && !isCatForcedExpanded
                  const isShowL3CollapseButton =
                    (isEditAllowed || props.composedReportMode) &&
                    isL3 &&
                    isL3Overall &&
                    !isCatForcedExpanded
                  const isShowL3Border = isL3 && (!isL3Overall || (isL3Overall && !isL3Collapsed))
                  const isL3SubCat = isL3 && !isL3Overall
                  const l3Idx = getL3Index(format)

                  const flags = partnerInfo?.PartnerFlags || ''

                  // Is row NoPlan
                  const fyFq = PLANNING_BY_FY_FQ
                  const isNoPlan = getIsNoPlan(targetsItems, props.formats, idx, fyear, fyFq, false)
                  const isNoPlanCon = getIsNoPlan(
                    targetsItems,
                    props.formats,
                    idx,
                    fyear,
                    fyFq,
                    true
                  )
                  const withPlanCount = getSubCategoriesWithPlanCount(
                    targetsItems,
                    props.formats,
                    idx,
                    fyear,
                    fyFq,
                    false,
                    isMandatoryByFlagLogic,
                    flags,
                    sectionSettings
                  )
                  const withPlanCountCon = getSubCategoriesWithPlanCount(
                    targetsItems,
                    props.formats,
                    idx,
                    fyear,
                    fyFq,
                    true,
                    isMandatoryByFlagLogic,
                    flags,
                    sectionSettings
                  )
                  const isLastWithPlan = !isNoPlan && withPlanCount <= 1
                  const isLastWithPlanCon = !isNoPlanCon && withPlanCountCon <= 1

                  // Mandatory - is Show
                  // (the same for contractual logic)
                  const isMandatoryByFlag = isSubCategoryMandatory(
                    flags,
                    format.MandatoryByFlags,
                    sectionSettings,
                    true
                  )
                  const isShowMandatoryForCategory = isOverall || !isCollapseAllowed
                  const isShowMandatoryCommon = isMandatoryByFlagLogic
                    ? isMandatoryByFlag.isMandatory
                    : isShowMandatoryForCategory
                  const isShowMandatory = isShowMandatoryCommon && !props.composedReportMode

                  // Calc Mandatory Count only on Current Level L2 or L3
                  // (the same for contractual logic?)
                  const mandatoryInCatCount = getMandatoryLinesInCategoryCount({
                    partnerFlags: flags,
                    formats: props.formats,
                    currentFormat: format,
                    sectionSettings,
                    isUnits: false,
                    restrictL3Child: '',
                  })

                  // Is Show NoPlan
                  const isShowNoPlanCommon =
                    isShowMandatory &&
                    isEditAllowed &&
                    isEditFixed &&
                    (!isMandatoryByFlagLogic || mandatoryInCatCount > 1) &&
                    !isCatForcedExpanded &&
                    !isOverall
                  const isShowNoPlan = isShowNoPlanCommon && !isCollapseAllowed
                  const isShowNoPlanCon = isShowNoPlanCommon

                  // Is Disable NoPlan
                  const isNoPlanDisabled = (isL3Overall && !isL3Collapsed) || isLastWithPlan
                  const isNotActiveRows =
                    (isL3Overall && !isL3Collapsed) || (isOverall && !isFixedCollapsed)
                  const isNoPlanDisabledCon = (isNotActiveRows && !isOverall) || isLastWithPlanCon

                  const uniqueCategory = isOverall ? cat : subCat
                  const uniqueKey = `jbp-planning-contractual-${uniqueCategory}`

                  const isEditRow = isEditAllowed && (!isOverall || isFixedCollapsed)
                  const isEditRowSob = isEditAllowed

                  const isShowPartnersCompletenessForCategory =
                    IS_SHOW_PARTNERS_COMPLETENESS_FOR_SUB_CATEGORIES || isOverall

                  const isShowPartnersCompleteness =
                    !!props.composedReportMode &&
                    isShowPartnersCompletenessForCategory &&
                    (IS_SHOW_PARTNERS_COMPLETENESS_FOR_ALL_ROWS ||
                      (!isShowOnlyCompletedPlans &&
                        ((!isL3Overall && !isOverall) ||
                          (isL3Overall && isL3Collapsed) ||
                          (isOverall && isFixedCollapsed))))
                  const isShowPartnersCompletenessForContractualPlan =
                    isShowPartnersCompleteness && IS_SHOW_PARTNERS_COMPLETENESS_FOR_CONTRACTUAL_PLAN
                  const isAdjustPartnersCompleteness = isOverall || isL3Overall

                  const isEmptyRow = !getRowSum(idx, false)
                  const isHideRow =
                    (isFixedCollapsed && !isOverall) ||
                    (isL3Collapsed && !isL3Overall) ||
                    (isEmptyRow &&
                      !isOverall &&
                      !isEditMode &&
                      !isAlwaysExpanded &&
                      !props.composedReportMode &&
                      !props.isQuarterlyBusinessReviewMode)

                  if (isHideRow) {
                    return (
                      <Fragment
                        key={`jbp-target-actuals-rows-${uniqueKey}-${idx}-hided`}
                      ></Fragment>
                    )
                  }

                  const isShowGlobalSoB =
                    !!partnerInfo?.IsGlobal && !!props.globalCategory?.IsSoBAvailable

                  // Retail SOB
                  // const isSobDetailsMandatoryCondition =
                  //   (!isRetailer && isSobDetailsMandatory) ||
                  //   (isRetailer && isSobDetailsMandatory && !isL3SubCat)
                  const isSobDetailsMandatoryCondition = isSobDetailsMandatory
                  const isShowSobDetailCondition =
                    isOverall || isSobDetailsMandatoryCondition || isOn(currentCat, 'sob-details')

                  const isShowSoB =
                    isShowGlobalSoB ||
                    (!partnerInfo?.IsGlobal &&
                      !isHideSoB &&
                      (isOverall || !props.composedReportMode) &&
                      (!props.composedReportMode || isShowComposedSoB) &&
                      isShowSobDetailCondition &&
                      ((!IS_ALWAYS_SHOW_SOB && isOn(currentCat, 'sob', IS_ALWAYS_SHOW_SOB)) ||
                        (IS_ALWAYS_SHOW_SOB && !!format.IsSoBAvailable)) &&
                      isNoSplitPlans)

                  const isEditSoB = isEditAllowed && isShowSoB

                  const completenessItem = getCompletenessItem({
                    formats: props.formats,
                    settingsIndex: idx,
                    items: targetsItems,
                    fy: fyear,
                    isSoB: false,
                  })
                  const completenessAckTag = isShowOnlyCompletedPlans ? 'ack' : 'all'
                  const completenessTag = isShowSoB ? 'ful' : completenessAckTag

                  const isShowNoSplit =
                    !!props.composedReportMode &&
                    ((isOverall && !isFixedCollapsed) || (isL3Overall && !isL3Collapsed))

                  const onPartnersCompletenessClick = (
                    partnersCompleteness: IPartnersCompleteness
                  ) => {
                    const fullPartnersCompleteness: IPartnersCompleteness = {
                      ...partnersCompleteness,

                      fYear: fyear,
                      fQuarter: PLANNING_BY_FY_FQ,
                      category: cat,
                      subCategory: subCat,
                      l3Category: l3Cat,
                      isActuals: 0,
                      isTargets: 1,
                      isSob: 0,

                      isAcknowledged: isShowOnlyCompletedPlans ? 1 : 0,
                      isCompleted: isShowSoB ? 1 : 0,
                    }

                    setPartnersCompleteness(fullPartnersCompleteness)
                  }

                  const ctType: TCTType = splitType === 'Contractual' ? 'c' : 't'
                  let sFullType: TSType = ''
                  if (splitType !== 'Total') {
                    sFullType = ctType
                  }

                  // Old clause for Global: !!partnerInfo?.IsGlobal && !isOverall
                  const isHideCategoryToolTip = false

                  return (
                    <Fragment key={`jbp-target-actuals-rows-${uniqueKey}-${idx}`}>
                      {isShowMapRow && !isOverall && (
                        <SubCategoryMapRow
                          mapData={props.mapData}
                          fyear={fyear}
                          category={cat}
                          subCategory={subCat}
                          l3Category={l3Cat}
                          tag="jbp-market-growth-guidance-short"
                          isShowCalcActuals={isShowCalcActuals}
                          isShowFutureYears={isShowFutureYears}
                          hideIfEmpty
                        />
                      )}
                      <tr
                        key={`jbp-target-actuals-${uniqueKey}-${idx}`}
                        className={cn({ [styles.contractualTotalRow]: isUseContractuals })}
                      >
                        <td
                          className={cn(
                            styles.totalCell,
                            { [styles.catTitle]: !isEditRow },
                            { [styles.catTitleEdit]: isEditRow },
                            { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                            { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                            { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                            { [styles.catL3p]: isL3 },
                            { [styles.catL2]: !isOverall && !isL3 },
                            { [styles.catL3]: isL3SubCat && !isEditAllowed },
                            { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                          )}
                        >
                          {isShowCollapseButton && (
                            <div className={styles.categoryTitle}>
                              <span
                                className={styles.icon_expanded}
                                onClick={toggleIsCollapseCategory}
                              >
                                <i
                                  className={cn('kbase', {
                                    'kbase-compress': !isFixedCollapsed,
                                    'kbase-expand': isFixedCollapsed,
                                  })}
                                  style={{ marginRight: '8px' }}
                                  aria-hidden="true"
                                />
                                <div>
                                  <CategoryTitle
                                    category={cat}
                                    subCategory={subCat}
                                    l3Category={l3Cat}
                                    tip={format.PopupComment}
                                    tipPrefix={globalCategoryTipPrefix}
                                    isHideTooltip={isHideCategoryToolTip}
                                  />
                                  {isNoSplitPlans && isShowNoPlan && (
                                    <NoPlanCheckbox
                                      isNoPlanDisabled={isNoPlanDisabled}
                                      isNoPlan={isNoPlan}
                                      onToggle={() =>
                                        setIsNoPlan(idx, !isNoPlan, fyear, isOverall, '')
                                      }
                                      withPlanCount={withPlanCount}
                                    />
                                  )}
                                  {!isNoSplitPlans && isShowNoPlanCon && ctType !== 't' && (
                                    <NoPlanCheckbox
                                      isNoPlanDisabled={isNoPlanDisabledCon}
                                      isNoPlan={isNoPlanCon}
                                      onToggle={() =>
                                        setIsNoPlan(idx, !isNoPlanCon, fyear, isOverall, ctType)
                                      }
                                      withPlanCount={withPlanCount}
                                      variant="contractual"
                                    />
                                  )}
                                </div>
                              </span>
                              <CategorySubTitle
                                isShowSubTitles={!props.composedReportMode}
                                isShowQuotas={props.showQuota}
                                isShowActuals={props.showActuals}
                                isShowActualsSplit={isShowActualsSplit}
                                isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                                isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                isShowPlanAchievement={isShowPlanAchievement}
                                isShowQuotaAchievement={isShowQuotaAchievement}
                                isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                isDistributorPlanner={props.isDistributorPlanner}
                                isShowPartnerCount={isShowPartnerCount}
                                isEditRow={isEditRow}
                                sType={sFullType}
                              />
                            </div>
                          )}
                          {isShowL3CollapseButton && (
                            <div className={styles.categoryTitle}>
                              <span
                                className={styles.icon_expanded}
                                onClick={() => {
                                  setIsL3Collapsed(idx, !isL3Collapsed, fyear)
                                }}
                              >
                                <i
                                  className={cn('kbase', {
                                    'kbase-compress': !isL3Collapsed,
                                    'kbase-expand': isL3Collapsed,
                                  })}
                                  style={{ marginRight: '8px' }}
                                  aria-hidden="true"
                                ></i>
                                <div>
                                  <CategoryTitle
                                    category={cat}
                                    subCategory={subCat}
                                    l3Category={l3Cat}
                                    endContent={<></>}
                                    tip={format.PopupComment}
                                    tipPrefix={globalCategoryTipPrefix}
                                    isHideTooltip={isHideCategoryToolTip}
                                  />
                                  {isNoSplitPlans && isShowNoPlan && (
                                    <NoPlanCheckbox
                                      isNoPlanDisabled={isNoPlanDisabled}
                                      isNoPlan={isNoPlan}
                                      onToggle={() =>
                                        setIsNoPlan(idx, !isNoPlan, fyear, isOverall, '')
                                      }
                                      withPlanCount={withPlanCount}
                                    />
                                  )}
                                  {!isNoSplitPlans && isShowNoPlanCon && ctType !== 't' && (
                                    <NoPlanCheckbox
                                      isNoPlanDisabled={isNoPlanDisabledCon}
                                      isNoPlan={isNoPlanCon}
                                      onToggle={() =>
                                        setIsNoPlan(idx, !isNoPlanCon, fyear, isOverall, ctType)
                                      }
                                      withPlanCount={withPlanCount}
                                      variant="contractual"
                                    />
                                  )}
                                </div>
                              </span>
                              <CategorySubTitle
                                isShowSubTitles={!props.composedReportMode}
                                isShowQuotas={props.showQuota}
                                isShowActuals={props.showActuals}
                                isShowActualsSplit={isShowActualsSplit}
                                isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                                isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                isShowPlanAchievement={isShowPlanAchievement}
                                isShowQuotaAchievement={isShowQuotaAchievement}
                                isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                isDistributorPlanner={props.isDistributorPlanner}
                                isShowPartnerCount={isShowPartnerCount}
                                isEditRow={isEditRow}
                                sType={sFullType}
                              />
                            </div>
                          )}
                          {isL3 && !isL3Overall && IS_USE_LEVEL_ICON && (
                            <span className={styles.l3icon}>
                              <i
                                className={'kbase kbase-arrow-right'}
                                style={{ color: '#2c3038', fontWeight: 'bold' }}
                              />
                            </span>
                          )}
                          {!isShowCollapseButton && !isShowL3CollapseButton && (
                            <div className={styles.categoryTitle}>
                              <div>
                                <CategoryTitle
                                  category={cat}
                                  subCategory={subCat}
                                  l3Category={l3Cat}
                                  tip={format.PopupComment}
                                  tipPrefix={globalCategoryTipPrefix}
                                  isHideTooltip={isHideCategoryToolTip}
                                />
                                {isNoSplitPlans && isShowNoPlan && (
                                  <NoPlanCheckbox
                                    isNoPlanDisabled={isNoPlanDisabled}
                                    isNoPlan={isNoPlan}
                                    onToggle={() =>
                                      setIsNoPlan(idx, !isNoPlan, fyear, isOverall, '')
                                    }
                                    withPlanCount={withPlanCount}
                                  />
                                )}
                                {!isNoSplitPlans && isShowNoPlanCon && ctType !== 't' && (
                                  <NoPlanCheckbox
                                    isNoPlanDisabled={isNoPlanDisabledCon}
                                    isNoPlan={isNoPlanCon}
                                    onToggle={() =>
                                      setIsNoPlan(idx, !isNoPlanCon, fyear, isOverall, ctType)
                                    }
                                    withPlanCount={withPlanCount}
                                    variant="contractual"
                                  />
                                )}
                              </div>
                              <CategorySubTitle
                                isShowSubTitles={!props.composedReportMode}
                                isShowQuotas={props.showQuota}
                                isShowActuals={props.showActuals}
                                isShowActualsSplit={isShowActualsSplit}
                                isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                                isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                isShowPlanAchievement={isShowPlanAchievement}
                                isShowQuotaAchievement={isShowQuotaAchievement}
                                isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                isDistributorPlanner={props.isDistributorPlanner}
                                isShowPartnerCount={isShowPartnerCount}
                                isEditRow={isEditRow}
                                sType={sFullType}
                              />
                            </div>
                          )}
                          {isShowPartnersCompleteness && (
                            <div
                              className={cn(styles.partnersCompleteness, {
                                [styles.partnersCompletenessAdjust]: isAdjustPartnersCompleteness,
                              })}
                            >
                              <br />
                              <PartnersCompletenessField
                                translationTag={completenessTag}
                                partnersCompleteness={completenessItem}
                                onClick={onPartnersCompletenessClick}
                              />
                            </div>
                          )}
                        </td>

                        {isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              -fyFq,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              false,
                              'prevPrev'
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              false,
                              ctType,
                              isNoPlanCon,
                              'prevPrev'
                            )}

                        {isYearlyPlanning ? (
                          <></>
                        ) : (
                          fQuarters.map((q) =>
                            isNoSplitPlans
                              ? renderQ(
                                  idx,
                                  isOverall,
                                  isL3Overall,
                                  -q,
                                  isEditAllowed,
                                  false,
                                  isNoPlan,
                                  false,
                                  false,
                                  'prev'
                                )
                              : renderQContr(
                                  idx,
                                  isOverall,
                                  -q,
                                  isEditAllowed,
                                  false,
                                  ctType,
                                  isNoPlanCon,
                                  'prev'
                                )
                          )
                        )}
                        {isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              -fyFq,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              false,
                              'prev'
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              false,
                              ctType,
                              isNoPlanCon,
                              'prev'
                            )}
                        {isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              -fyFq,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              false,
                              'calc'
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              false,
                              ctType,
                              isNoPlanCon,
                              'calc'
                            )}

                        {isYearlyPlanning ? (
                          <></>
                        ) : (
                          fQuarters.map((q) =>
                            isNoSplitPlans
                              ? renderQ(
                                  idx,
                                  isOverall,
                                  isL3Overall,
                                  q,
                                  isEditAllowed,
                                  false,
                                  isNoPlan,
                                  false,
                                  false,
                                  'curr'
                                )
                              : renderQContr(
                                  idx,
                                  isOverall,
                                  q,
                                  isEditAllowed,
                                  false,
                                  ctType,
                                  isNoPlanCon,
                                  'curr'
                                )
                          )
                        )}
                        {isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              false,
                              'curr'
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              fyFq,
                              isEditAllowed,
                              false,
                              ctType,
                              isNoPlanCon,
                              'curr'
                            )}

                        {isShowFutureYears &&
                          (isNoSplitPlans
                            ? renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                fyFq + 1,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                false,
                                false,
                                'futr'
                              )
                            : renderQContr(
                                idx,
                                isOverall,
                                fyFq + 1,
                                isEditAllowed,
                                false,
                                ctType,
                                isNoPlanCon,
                                'futr'
                              ))}
                        {isShowFutureYears &&
                          (isNoSplitPlans
                            ? renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                fyFq + 2,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                false,
                                false,
                                'futr'
                              )
                            : renderQContr(
                                idx,
                                isOverall,
                                fyFq + 2,
                                isEditAllowed,
                                false,
                                ctType,
                                isNoPlanCon,
                                'futr'
                              ))}
                      </tr>

                      {isShowNoSplit && (
                        <tr
                          key={`jbp-target-split-${subCat}-${idx}`}
                          className={cn({ [styles.contractualTotalRow]: isUseContractuals })}
                        >
                          <td
                            className={cn(
                              styles.totalCell,
                              { [styles.catTitle]: !isEditRow },
                              { [styles.catTitleEdit]: isEditRow },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              {
                                [styles.catL2]:
                                  (!isOverall && !isL3) || (isShowNoSplit && isOverall),
                              },
                              {
                                [styles.catL3]:
                                  (isL3SubCat && !isEditAllowed) || (isShowNoSplit && isL3Overall),
                              },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                            )}
                          >
                            <Translation text="jbp-planning-composed-no-split" span actionsInside />
                          </td>

                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            false,
                            'prevPrev'
                          )}

                          {isYearlyPlanning ? (
                            <></>
                          ) : (
                            fQuarters.map((q) =>
                              renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                -q,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                true,
                                false,
                                'prev'
                              )
                            )
                          )}
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            false,
                            'prev'
                          )}
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            false,
                            'calc'
                          )}

                          {isYearlyPlanning ? (
                            <></>
                          ) : (
                            fQuarters.map((q) =>
                              renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                q,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                true,
                                false,
                                'curr'
                              )
                            )
                          )}
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            false,
                            'curr'
                          )}

                          {isShowFutureYears &&
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 1,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              true,
                              false,
                              'futr'
                            )}
                          {isShowFutureYears &&
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 2,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              true,
                              false,
                              'futr'
                            )}
                        </tr>
                      )}

                      {!!partnerInfo?.IsGlobal && (
                        <tr
                          key={`jbp-target-rollup-${subCat}-${idx}`}
                          className={cn(styles.contractualRow, styles.rollupRow)}
                        >
                          <td
                            className={cn(
                              { [styles.catTitle]: !isEditRow },
                              { [styles.catTitleEdit]: isEditRow },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              {
                                [styles.catL2]:
                                  (!isOverall && !isL3) || (isShowNoSplit && isOverall),
                              },
                              {
                                [styles.catL3]:
                                  (isL3SubCat && !isEditAllowed) || (isShowNoSplit && isL3Overall),
                              },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                            )}
                          >
                            <div className={styles.categoryTitle}>
                              <div className={styles.cellTitle}>
                                <Translation text="jbp-planning-rollup" span actionsInside />
                              </div>
                              <CategorySubTitle
                                isShowSubTitles={!props.composedReportMode}
                                isShowQuotas={false}
                                isShowActuals={props.showActuals}
                                isShowActualsSplit={isShowActualsSplit}
                                isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                                isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                isShowPlanAchievement={isShowPlanAchievement}
                                isShowQuotaAchievement={isShowQuotaAchievement}
                                isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                isDistributorPlanner={props.isDistributorPlanner}
                                isShowPartnerCount={isShowPartnerCount}
                                isEditRow={isEditRow}
                                sType={sFullType}
                              />
                            </div>
                          </td>

                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            true,
                            'prevPrev'
                          )}

                          {isYearlyPlanning ? (
                            <></>
                          ) : (
                            fQuarters.map((q) =>
                              renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                -q,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                false,
                                true,
                                'prev'
                              )
                            )
                          )}
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            true,
                            'prev'
                          )}
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            true,
                            'calc'
                          )}

                          {isYearlyPlanning ? (
                            <></>
                          ) : (
                            fQuarters.map((q) =>
                              renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                q,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                false,
                                true,
                                'curr'
                              )
                            )
                          )}
                          {renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            true,
                            'curr'
                          )}

                          {isShowFutureYears &&
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 1,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              true,
                              'futr'
                            )}
                          {isShowFutureYears &&
                            renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 2,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              true,
                              'futr'
                            )}
                        </tr>
                      )}

                      {isUseContractuals && (
                        <>
                          {isShowContrTrans && (
                            <tr key={`${uniqueKey}-${idx}-c`} className={styles.contractualRow}>
                              <td
                                className={cn(
                                  { [styles.catTitle]: !isEditRow },
                                  { [styles.catTitleEdit]: isEditRow },
                                  { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                                  { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                                  { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                                  { [styles.catL3p]: isL3 },
                                  { [styles.catL2]: !isOverall && !isL3 },
                                  { [styles.catL3]: isL3SubCat && !isEditAllowed },
                                  { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                                )}
                              >
                                <div className={styles.categoryTitle}>
                                  <Translation
                                    span
                                    text={
                                      props.isDistributorPlanner
                                        ? 'jbp-planning-contractual-non-power'
                                        : 'jbp-planning-contractual-contractual'
                                    }
                                  />
                                  <CategorySubTitle
                                    isShowSubTitles={!props.composedReportMode}
                                    isShowQuotas={props.showQuota}
                                    isShowActuals={props.showActuals}
                                    isShowActualsSplit={isShowActualsSplit}
                                    isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                                    isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                    isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                    isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                    isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                    isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                    isShowPlanAchievement={isShowPlanAchievement}
                                    isShowQuotaAchievement={isShowQuotaAchievement}
                                    isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                    isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                    isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                    isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                    isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                    isDistributorPlanner={props.isDistributorPlanner}
                                    isShowPartnerCount={isShowPartnerCount}
                                    isEditRow={isEditRow}
                                    sType={'c'}
                                  />
                                </div>

                                {isShowNoPlanCon && (
                                  <>
                                    <br />
                                    <div
                                      className={cn(
                                        styles.noPlanSwitcher,
                                        styles.noPlanContractual
                                      )}
                                    >
                                      <Checkbox
                                        padding
                                        disabled={isNoPlanDisabledCon}
                                        checked={isNoPlanCon}
                                        onChange={() => {
                                          setIsNoPlan(idx, !isNoPlanCon, fyear, isOverall, ctType)
                                        }}
                                      />
                                      <div
                                        className={cn(styles.noPlanSwitcherText, {
                                          [styles.disabledItem]: isNoPlanDisabledCon,
                                        })}
                                      >
                                        <Translation span text="jbp-planning-no-plan-switcher" />
                                      </div>
                                    </div>
                                  </>
                                )}
                                {isShowPartnersCompletenessForContractualPlan && (
                                  <div
                                    className={cn(styles.partnersCompleteness, {
                                      [styles.partnersCompletenessAdjust]:
                                        isAdjustPartnersCompleteness,
                                    })}
                                  >
                                    <br />
                                    <PartnersCompletenessField
                                      translationTag={completenessTag}
                                      partnersCompleteness={completenessItem}
                                      onClick={onPartnersCompletenessClick}
                                    />
                                  </div>
                                )}
                              </td>

                              {renderQContr(
                                idx,
                                isOverall,
                                -fyFq,
                                isEditAllowed,
                                false,
                                'c',
                                isNoPlanCon,
                                'prevPrev'
                              )}

                              {isYearlyPlanning ? (
                                <></>
                              ) : (
                                fQuarters.map((q) =>
                                  renderQContr(
                                    idx,
                                    isOverall,
                                    -q,
                                    isEditAllowed,
                                    false,
                                    'c',
                                    isNoPlanCon,
                                    'prev'
                                  )
                                )
                              )}
                              {renderQContr(
                                idx,
                                isOverall,
                                -fyFq,
                                isEditAllowed,
                                false,
                                'c',
                                isNoPlanCon,
                                'prev'
                              )}
                              {renderQContr(
                                idx,
                                isOverall,
                                -fyFq,
                                isEditAllowed,
                                false,
                                'c',
                                isNoPlanCon,
                                'calc'
                              )}

                              {isYearlyPlanning ? (
                                <></>
                              ) : (
                                fQuarters.map((q) =>
                                  renderQContr(
                                    idx,
                                    isOverall,
                                    q,
                                    isEditAllowed,
                                    false,
                                    'c',
                                    isNoPlanCon,
                                    'curr'
                                  )
                                )
                              )}
                              {renderQContr(
                                idx,
                                isOverall,
                                fyFq,
                                isEditAllowed,
                                false,
                                'c',
                                isNoPlanCon,
                                'curr'
                              )}

                              {isShowFutureYears &&
                                renderQContr(
                                  idx,
                                  isOverall,
                                  fyFq + 1,
                                  isEditAllowed,
                                  false,
                                  'c',
                                  isNoPlanCon,
                                  'futr'
                                )}
                              {isShowFutureYears &&
                                renderQContr(
                                  idx,
                                  isOverall,
                                  fyFq + 2,
                                  isEditAllowed,
                                  false,
                                  'c',
                                  isNoPlanCon,
                                  'futr'
                                )}
                            </tr>
                          )}
                          {isShowContrTrans && (
                            <tr key={`${uniqueKey}-${idx}-t`} className={styles.contractualRow}>
                              <td
                                className={cn(
                                  { [styles.catTitle]: !isEditRow },
                                  { [styles.catTitleEdit]: isEditRow },
                                  { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                                  { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                                  { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                                  { [styles.catL3p]: isL3 },
                                  { [styles.catL2]: !isOverall && !isL3 },
                                  { [styles.catL3]: isL3SubCat && !isEditAllowed },
                                  { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                                )}
                              >
                                <div className={styles.categoryTitle}>
                                  <Translation
                                    span
                                    text={
                                      props.isDistributorPlanner
                                        ? 'jbp-planning-contractual-power'
                                        : 'jbp-planning-contractual-transactional'
                                    }
                                  />
                                  <CategorySubTitle
                                    isShowSubTitles={!props.composedReportMode}
                                    isShowQuotas={props.showQuota}
                                    isShowActuals={props.showActuals}
                                    isShowActualsSplit={isShowActualsSplit}
                                    isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                                    isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                    isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                    isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                    isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                    isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                    isShowPlanAchievement={isShowPlanAchievement}
                                    isShowQuotaAchievement={isShowQuotaAchievement}
                                    isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                    isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                    isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                    isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                    isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                    isDistributorPlanner={props.isDistributorPlanner}
                                    isShowPartnerCount={isShowPartnerCount}
                                    isEditRow={isEditRow}
                                    sType={'t'}
                                  />
                                </div>
                              </td>

                              {renderQContr(
                                idx,
                                isOverall,
                                -fyFq,
                                isEditAllowed,
                                false,
                                't',
                                isNoPlanCon,
                                'prevPrev'
                              )}

                              {isYearlyPlanning ? (
                                <></>
                              ) : (
                                fQuarters.map((q) =>
                                  renderQContr(
                                    idx,
                                    isOverall,
                                    -q,
                                    isEditAllowed,
                                    false,
                                    't',
                                    isNoPlanCon,
                                    'prev'
                                  )
                                )
                              )}
                              {renderQContr(
                                idx,
                                isOverall,
                                -fyFq,
                                isEditAllowed,
                                false,
                                't',
                                isNoPlanCon,
                                'prev'
                              )}
                              {renderQContr(
                                idx,
                                isOverall,
                                -fyFq,
                                isEditAllowed,
                                false,
                                't',
                                isNoPlanCon,
                                'calc'
                              )}

                              {isYearlyPlanning ? (
                                <></>
                              ) : (
                                fQuarters.map((q) =>
                                  renderQContr(
                                    idx,
                                    isOverall,
                                    q,
                                    isEditAllowed,
                                    false,
                                    't',
                                    isNoPlanCon,
                                    'curr'
                                  )
                                )
                              )}
                              {renderQContr(
                                idx,
                                isOverall,
                                fyFq,
                                isEditAllowed,
                                false,
                                't',
                                isNoPlanCon,
                                'curr'
                              )}

                              {isShowFutureYears &&
                                renderQContr(
                                  idx,
                                  isOverall,
                                  fyFq + 1,
                                  isEditAllowed,
                                  false,
                                  't',
                                  isNoPlanCon,
                                  'futr'
                                )}
                              {isShowFutureYears &&
                                renderQContr(
                                  idx,
                                  isOverall,
                                  fyFq + 2,
                                  isEditAllowed,
                                  false,
                                  't',
                                  isNoPlanCon,
                                  'futr'
                                )}
                            </tr>
                          )}
                        </>
                      )}

                      {isShowSoB && (
                        <tr
                          key={`jbp-planning-sob-${subCat}-${idx}`}
                          className={cn(styles.contractualRow, styles.sobRow)}
                        >
                          <td
                            className={cn(
                              { [styles.catTitle]: !isEditSoB },
                              { [styles.sobTitleEdit]: isEditSoB },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              { [styles.catL2]: !isOverall && !isL3 },
                              { [styles.catL3]: isL3SubCat && !isEditAllowed },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                            )}
                          >
                            <div className={styles.categoryTitle}>
                              <div className={styles.cellTitle}>
                                <Translation span text="jbp-planning-sob-row" />
                              </div>
                              <CategorySubTitle
                                isShowSubTitles={!props.composedReportMode}
                                isShowQuotas={props.showQuota}
                                isShowActuals={props.showActuals}
                                isShowActualsSplit={false}
                                isShowSmbVsEuSplit={false}
                                isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                isShowPlanAchievement={isShowPlanAchievement}
                                isShowQuotaAchievement={isShowQuotaAchievement}
                                isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                isDistributorPlanner={props.isDistributorPlanner}
                                isShowPartnerCount={isShowPartnerCount}
                                isEditRow={isEditRowSob}
                                isSob
                                sType={sFullType}
                              />
                            </div>
                          </td>

                          {renderSoB(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            'prevPrev'
                          )}

                          {isYearlyPlanning ? (
                            <></>
                          ) : (
                            fQuarters.map((q) =>
                              renderSoB(
                                idx,
                                isOverall,
                                -q,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                false,
                                'prev'
                              )
                            )
                          )}
                          {renderSoB(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            'prev'
                          )}
                          {renderSoB(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            'calc'
                          )}

                          {isYearlyPlanning ? (
                            <></>
                          ) : (
                            fQuarters.map((q) =>
                              renderSoB(
                                idx,
                                isOverall,
                                q,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                false,
                                'curr'
                              )
                            )
                          )}
                          {renderSoB(
                            idx,
                            isOverall,
                            fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            false,
                            'curr'
                          )}

                          {isShowFutureYears &&
                            renderSoB(
                              idx,
                              isOverall,
                              fyFq + 1,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              'futr'
                            )}
                          {isShowFutureYears &&
                            renderSoB(
                              idx,
                              isOverall,
                              fyFq + 2,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              false,
                              'futr'
                            )}
                        </tr>
                      )}

                      {isShowGlobalSoB && (
                        <tr
                          key={`jbp-planning-sob-rollup-${subCat}-${idx}`}
                          className={cn(styles.contractualRow, styles.rollupRow)}
                        >
                          <td
                            className={cn(
                              { [styles.catTitle]: !isEditRow },
                              { [styles.catTitleEdit]: isEditRow },
                              { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                              { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                              { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                              { [styles.catL3p]: isL3 },
                              {
                                [styles.catL2]:
                                  (!isOverall && !isL3) || (isShowNoSplit && isOverall),
                              },
                              {
                                [styles.catL3]:
                                  (isL3SubCat && !isEditAllowed) || (isShowNoSplit && isL3Overall),
                              },
                              { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                            )}
                          >
                            <div className={styles.categoryTitle}>
                              <div className={styles.cellTitle}>
                                <Translation text="jbp-planning-sob-rollup" span actionsInside />
                              </div>
                              <CategorySubTitle
                                isShowSubTitles={!props.composedReportMode}
                                isShowQuotas={props.showQuota}
                                isShowActuals={props.showActuals}
                                isShowActualsSplit={false}
                                isShowSmbVsEuSplit={false}
                                isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                isShowPlanAchievement={isShowPlanAchievement}
                                isShowQuotaAchievement={isShowQuotaAchievement}
                                isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                isDistributorPlanner={props.isDistributorPlanner}
                                isShowPartnerCount={isShowPartnerCount}
                                isEditRow={isEditRowSob}
                                isSob
                                sType={sFullType}
                              />
                            </div>
                          </td>

                          {renderSoB(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            'prevPrev'
                          )}

                          {isYearlyPlanning ? (
                            <></>
                          ) : (
                            fQuarters.map((q) =>
                              renderSoB(
                                idx,
                                isOverall,
                                -q,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                true,
                                'prev'
                              )
                            )
                          )}
                          {renderSoB(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            'prev'
                          )}
                          {renderSoB(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            'calc'
                          )}

                          {isYearlyPlanning ? (
                            <></>
                          ) : (
                            fQuarters.map((q) =>
                              renderSoB(
                                idx,
                                isOverall,
                                q,
                                isEditAllowed,
                                false,
                                isNoPlan,
                                true,
                                'curr'
                              )
                            )
                          )}
                          {renderSoB(
                            idx,
                            isOverall,
                            fyFq,
                            isEditAllowed,
                            false,
                            isNoPlan,
                            true,
                            'curr'
                          )}

                          {isShowFutureYears &&
                            renderSoB(
                              idx,
                              isOverall,
                              fyFq + 1,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              true,
                              'futr'
                            )}
                          {isShowFutureYears &&
                            renderSoB(
                              idx,
                              isOverall,
                              fyFq + 2,
                              isEditAllowed,
                              false,
                              isNoPlan,
                              true,
                              'futr'
                            )}
                        </tr>
                      )}
                    </Fragment>
                  )
                })}
              </tbody>
            )}

            {isShowComposedReportCollapsedWarning && (
              <tfoot>
                <tr>
                  <th colSpan={planningColSpan}>
                    {props.showActuals && (
                      <div className={styles.infoContainer}>
                        <i
                          className={cn('kbase kbase-info-alt', styles.infoIcon)}
                          aria-hidden="true"
                        />
                        <span className={styles.composedReportLegend}>
                          <Translation text="jbp-planning-composed-report-warning" actionsInside />
                        </span>
                      </div>
                    )}
                  </th>
                </tr>
              </tfoot>
            )}
          </table>
        )}

        {isShowApplyBeforeUnits && renderApplySection()}

        {isShowUnitsSection && isShowNotApplicableMessage && (
          <table
            className={cn(
              stylesTable.table,
              stylesCompensation.table,
              styles.table,
              styles.unitsTable
            )}
          >
            <caption>
              <WidgetHeader>{categoryUnitsHeaderKey}</WidgetHeader>
              <div>
                <div className={styles.captionCell}>
                  <div className={styles.input}>
                    <Translation span text="jbp-not-applicable-status-not-applicable" />
                  </div>
                </div>
              </div>
            </caption>
          </table>
        )}

        {isShowUnitsSection && !isCategoryNA && (
          <table
            className={cn(
              stylesTable.table,
              stylesCompensation.table,
              styles.table,
              styles.unitsTable
            )}
          >
            {isShowCurrencyBlock && (
              <caption>
                <CategoryInfo
                  dataSetInfo={props.dataSetInfo}
                  isShowTotal={props.isShowTotal}
                  categoryName={categoryName}
                  isUnits={true}
                />
                <WidgetHeader
                  className={cn({
                    [styles.unitsHeader]: !isEditAllowed && !!props.dataSetInfo.IsMainHierarchy,
                  })}
                >
                  {categoryUnitsHeaderKey}
                </WidgetHeader>
              </caption>
            )}
            <thead>
              {!!props.isQuarterlyBusinessReviewMode && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.switchersContainer}>
                      {isShowCurrencyCtrl && <CurrenciesButtons />}
                      {isShowNetNdpCtrl && <ActualsTypeButtons />}
                    </div>
                  </th>
                </tr>
              )}
              {isShowControlsBeforeUnits && (
                <tr>
                  <th colSpan={planningColSpan}>
                    <div className={styles.switchersContainer}>
                      <div className={styles.switcher}>
                        <Switch
                          padding
                          disabled={isOnlyQuarterlyPlanning}
                          checked={isQuarterPlanning}
                          onChange={handleQuarterSettingChange}
                        />
                        <div className={styles.switcherText}>
                          <Translation span text="jbp-planning-quarter-switcher" />
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              )}
              {isUseContractuals && (
                <SplitPlanningRow
                  splitType={splitType}
                  setSplitType={setSplitType}
                  isShowAllSplits={isShowAllSplits}
                  setIsShowAllSplits={setIsShowAllSplits}
                  isDistributorPlanner={props.isDistributorPlanner}
                  colSpan={planningColSpan}
                />
              )}

              {isShowMapRow && (
                <MapRow
                  mapData={props.mapData}
                  fyear={fyear}
                  category={currentCat}
                  subCategory={OVERALL_CATEGORY}
                  tag="jbp-market-growth-guidance-units"
                  isUnits={true}
                  isYearlyPlanning={isYearlyPlanning}
                  isShowCalcActuals={isShowCalcActuals}
                  isShowFutureYears={isShowFutureYears}
                  hideIfEmpty
                />
              )}
              <CategoryHeader
                translationKey="jbp-planning-header-units"
                fyear={fyear}
                isYearlyPlanning={isYearlyPlanning}
                isShowCalcActuals={isShowCalcActuals}
                isShowFutureYears={isShowFutureYears}
                currentFQuarter={jbpSettings.currentFQuarter}
                periodFQuarters={fQuarters}
                isQbrYtd={props.isQuarterlyBusinessReviewMode}
              />
            </thead>
            <tbody>
              {props.formats.map((format, idx) => {
                const cat = format.Category
                const subCat = format.SubCategory
                const isOverall = subCat === OVERALL_CATEGORY || !subCat
                const isShowCollapseButton =
                  isCollapseAllowed && isEditAllowed && !isOverallOnly && isOverall

                const l3Cat = format.L3Category
                const isL3Overall = l3Cat === OVERALL_CATEGORY
                const isL3 = !!l3Cat

                // Retail Collapse
                const isCatForcedExpanded = getIsExpandedByFlags({
                  settings: format.Settings,
                  flagsState: props.partnerFlagsState,
                })

                const isL3Collapsed =
                  getIsCollapsedL3Category(targetsItems, fyear, subCat) && !isCatForcedExpanded
                const isShowL3CollapseButton =
                  isL3 && isL3Overall && isEditAllowed && !isCatForcedExpanded
                const isShowL3Border = isL3 && (!isL3Overall || (isL3Overall && !isL3Collapsed))
                const isL3SubCat = isL3 && !isL3Overall
                const l3Idx = getL3Index(format)

                const fyFq = PLANNING_BY_FY_FQ
                const isNoPlan = false
                const isNoPlanCon = false

                const uniqueCategory = isOverall ? cat : subCat
                const uniqueKey = `jbp-planning-contractual-${uniqueCategory}`

                const isEditRow = isEditAllowed && (!isOverall || isFixedCollapsed)

                const isEmptyRow = !getRowSum(idx, true)
                const isSkipCurrentCategory =
                  (isFixedCollapsed && !isOverall) ||
                  (isL3Collapsed && !isL3Overall) ||
                  (!format.IsUnitsAvailable && !props.isQuarterlyBusinessReviewMode) ||
                  (isEmptyRow &&
                    !isOverall &&
                    !isEditMode &&
                    !props.composedReportMode &&
                    !props.isQuarterlyBusinessReviewMode)

                const ctType: TCTType = splitType === 'Contractual' ? 'c' : 't'
                let sFullType: TSType = ''
                if (splitType !== 'Total') {
                  sFullType = ctType
                }

                if (isSkipCurrentCategory) {
                  return (
                    <Fragment key={`jbp-target-actuals-${subCat}-units-${idx}-hided`}></Fragment>
                  )
                }

                // Old clause for Global: !!partnerInfo?.IsGlobal && !isOverall
                const isHideCategoryToolTip = false

                return (
                  <Fragment key={`jbp-target-actuals-rows-${cat}-${subCat}-units-${idx}`}>
                    {isShowMapRow && !isOverall && (
                      <SubCategoryMapRow
                        mapData={props.mapData}
                        fyear={fyear}
                        category={cat}
                        subCategory={subCat}
                        l3Category={l3Cat}
                        tag="jbp-market-growth-guidance-units-short"
                        isUnits={true}
                        isShowCalcActuals={isShowCalcActuals}
                        isShowFutureYears={isShowFutureYears}
                        hideIfEmpty
                      />
                    )}
                    <tr key={`jbp-target-actuals-${subCat}-units-${idx}`}>
                      <td
                        className={cn(
                          styles.totalCell,
                          { [styles.catTitle]: !isEditRow },
                          { [styles.catTitleEdit]: isEditRow },
                          { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                          { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                          { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                          { [styles.catL3p]: isL3 },
                          { [styles.catL2]: !isOverall && !isL3 },
                          { [styles.catL3]: isL3SubCat && !isEditAllowed },
                          { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                        )}
                      >
                        {isShowCollapseButton && (
                          <div className={styles.categoryTitle}>
                            <span
                              className={styles.icon_expanded}
                              onClick={toggleIsCollapseCategory}
                            >
                              <i
                                className={cn('kbase', {
                                  'kbase-compress': !isFixedCollapsed,
                                  'kbase-expand': isFixedCollapsed,
                                })}
                                style={{ marginRight: '8px' }}
                                aria-hidden="true"
                              />
                              &nbsp;
                              <CategoryTitle
                                category={cat}
                                subCategory={subCat}
                                l3Category={l3Cat}
                                tip={format.PopupComment}
                                tipPrefix={globalCategoryTipPrefix}
                                isHideTooltip={isHideCategoryToolTip}
                              />
                            </span>
                            <CategorySubTitle
                              isShowSubTitles={!props.composedReportMode}
                              isShowQuotas={props.showQuota}
                              isShowActuals={props.showActuals}
                              isShowActualsSplit={isShowActualsSplit}
                              isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                              isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                              isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                              isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                              isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                              isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                              isShowPlanAchievement={isShowPlanAchievement}
                              isShowQuotaAchievement={isShowQuotaAchievement}
                              isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                              isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                              isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                              isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                              isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                              isDistributorPlanner={props.isDistributorPlanner}
                              isShowPartnerCount={isShowPartnerCount}
                              isEditRow={isEditRow}
                              sType={sFullType}
                            />
                          </div>
                        )}
                        {isShowL3CollapseButton && (
                          <div className={styles.categoryTitle}>
                            <span
                              className={styles.icon_expanded}
                              onClick={() => {
                                setIsL3Collapsed(idx, !isL3Collapsed, fyear)
                              }}
                            >
                              <i
                                className={cn('kbase', {
                                  'kbase-compress': !isL3Collapsed,
                                  'kbase-expand': isL3Collapsed,
                                })}
                                style={{ marginRight: '8px' }}
                                aria-hidden="true"
                              ></i>
                              &nbsp;
                              <CategoryTitle
                                category={cat}
                                subCategory={subCat}
                                l3Category={l3Cat}
                                tip={format.PopupComment}
                                tipPrefix={globalCategoryTipPrefix}
                                isHideTooltip={isHideCategoryToolTip}
                              />
                            </span>
                            <CategorySubTitle
                              isShowSubTitles={!props.composedReportMode}
                              isShowQuotas={props.showQuota}
                              isShowActuals={props.showActuals}
                              isShowActualsSplit={isShowActualsSplit}
                              isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                              isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                              isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                              isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                              isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                              isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                              isShowPlanAchievement={isShowPlanAchievement}
                              isShowQuotaAchievement={isShowQuotaAchievement}
                              isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                              isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                              isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                              isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                              isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                              isDistributorPlanner={props.isDistributorPlanner}
                              isShowPartnerCount={isShowPartnerCount}
                              isEditRow={isEditRow}
                              sType={sFullType}
                            />
                          </div>
                        )}
                        {!isShowCollapseButton && !isShowL3CollapseButton && (
                          <div className={styles.categoryTitle}>
                            <CategoryTitle
                              category={cat}
                              subCategory={subCat}
                              l3Category={l3Cat}
                              tip={format.PopupComment}
                              tipPrefix={globalCategoryTipPrefix}
                              isHideTooltip={isHideCategoryToolTip}
                            />
                            <CategorySubTitle
                              isShowSubTitles={!props.composedReportMode}
                              isShowQuotas={props.showQuota}
                              isShowActuals={props.showActuals}
                              isShowActualsSplit={isShowActualsSplit}
                              isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                              isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                              isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                              isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                              isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                              isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                              isShowPlanAchievement={isShowPlanAchievement}
                              isShowQuotaAchievement={isShowQuotaAchievement}
                              isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                              isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                              isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                              isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                              isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                              isDistributorPlanner={props.isDistributorPlanner}
                              isShowPartnerCount={isShowPartnerCount}
                              isEditRow={isEditRow}
                              sType={sFullType}
                            />
                          </div>
                        )}
                      </td>

                      {isNoSplitPlans
                        ? renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            true,
                            isNoPlan,
                            false,
                            false,
                            'prevPrev'
                          )
                        : renderQContr(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            true,
                            ctType,
                            isNoPlanCon,
                            'prevPrev'
                          )}

                      {isYearlyPlanning ? (
                        <></>
                      ) : (
                        fQuarters.map((q) =>
                          isNoSplitPlans
                            ? renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                -q,
                                isEditAllowed,
                                true,
                                isNoPlan,
                                false,
                                false,
                                'prev'
                              )
                            : renderQContr(
                                idx,
                                isOverall,
                                -q,
                                isEditAllowed,
                                true,
                                ctType,
                                isNoPlanCon,
                                'prev'
                              )
                        )
                      )}
                      {isNoSplitPlans
                        ? renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            true,
                            isNoPlan,
                            false,
                            false,
                            'prev'
                          )
                        : renderQContr(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            true,
                            ctType,
                            isNoPlanCon,
                            'prev'
                          )}
                      {isNoSplitPlans
                        ? renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            -fyFq,
                            isEditAllowed,
                            true,
                            isNoPlan,
                            false,
                            false,
                            'calc'
                          )
                        : renderQContr(
                            idx,
                            isOverall,
                            -fyFq,
                            isEditAllowed,
                            true,
                            ctType,
                            isNoPlanCon,
                            'calc'
                          )}

                      {isYearlyPlanning ? (
                        <></>
                      ) : (
                        fQuarters.map((q) =>
                          isNoSplitPlans
                            ? renderQ(
                                idx,
                                isOverall,
                                isL3Overall,
                                q,
                                isEditAllowed,
                                true,
                                isNoPlan,
                                false,
                                false,
                                'curr'
                              )
                            : renderQContr(
                                idx,
                                isOverall,
                                q,
                                isEditAllowed,
                                true,
                                ctType,
                                isNoPlanCon,
                                'curr'
                              )
                        )
                      )}
                      {isNoSplitPlans
                        ? renderQ(
                            idx,
                            isOverall,
                            isL3Overall,
                            fyFq,
                            isEditAllowed,
                            true,
                            isNoPlan,
                            false,
                            false,
                            'curr'
                          )
                        : renderQContr(
                            idx,
                            isOverall,
                            fyFq,
                            isEditAllowed,
                            true,
                            ctType,
                            isNoPlanCon,
                            'curr'
                          )}

                      {isShowFutureYears &&
                        (isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 1,
                              isEditAllowed,
                              true,
                              isNoPlan,
                              false,
                              false,
                              'futr'
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              fyFq + 1,
                              isEditAllowed,
                              true,
                              ctType,
                              isNoPlanCon,
                              'futr'
                            ))}

                      {isShowFutureYears &&
                        (isNoSplitPlans
                          ? renderQ(
                              idx,
                              isOverall,
                              isL3Overall,
                              fyFq + 2,
                              isEditAllowed,
                              true,
                              isNoPlan,
                              false,
                              false,
                              'futr'
                            )
                          : renderQContr(
                              idx,
                              isOverall,
                              fyFq + 2,
                              isEditAllowed,
                              true,
                              ctType,
                              isNoPlanCon,
                              'futr'
                            ))}
                    </tr>

                    {isUseContractuals && (
                      <>
                        {isShowContrTrans && (
                          <tr key={`${uniqueKey}-${idx}-units-c`} className={styles.contractualRow}>
                            <td
                              className={cn(
                                { [styles.catTitle]: !isEditRow },
                                { [styles.catTitleEdit]: isEditRow },
                                { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                                { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                                { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                                { [styles.catL3p]: isL3 },
                                { [styles.catL2]: !isOverall && !isL3 },
                                { [styles.catL3]: isL3SubCat && !isEditAllowed },
                                { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                              )}
                            >
                              <div className={styles.categoryTitle}>
                                <Translation
                                  span
                                  text={
                                    props.isDistributorPlanner
                                      ? 'jbp-planning-contractual-non-power'
                                      : 'jbp-planning-contractual-contractual'
                                  }
                                />
                                <CategorySubTitle
                                  isShowSubTitles={!props.composedReportMode}
                                  isShowQuotas={props.showQuota}
                                  isShowActuals={props.showActuals}
                                  isShowActualsSplit={isShowActualsSplit}
                                  isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                                  isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                  isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                  isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                  isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                  isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                  isShowPlanAchievement={isShowPlanAchievement}
                                  isShowQuotaAchievement={isShowQuotaAchievement}
                                  isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                  isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                  isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                  isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                  isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                  isDistributorPlanner={props.isDistributorPlanner}
                                  isShowPartnerCount={isShowPartnerCount}
                                  isEditRow={isEditRow}
                                  sType={'c'}
                                />
                              </div>
                            </td>

                            {renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              true,
                              'c',
                              isNoPlanCon,
                              'prevPrev'
                            )}

                            {isYearlyPlanning ? (
                              <></>
                            ) : (
                              fQuarters.map((q) =>
                                renderQContr(
                                  idx,
                                  isOverall,
                                  -q,
                                  isEditAllowed,
                                  true,
                                  'c',
                                  isNoPlanCon,
                                  'prev'
                                )
                              )
                            )}
                            {renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              true,
                              'c',
                              isNoPlanCon,
                              'prev'
                            )}
                            {renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              true,
                              'c',
                              isNoPlanCon,
                              'calc'
                            )}

                            {isYearlyPlanning ? (
                              <></>
                            ) : (
                              fQuarters.map((q) =>
                                renderQContr(
                                  idx,
                                  isOverall,
                                  q,
                                  isEditAllowed,
                                  true,
                                  'c',
                                  isNoPlanCon,
                                  'curr'
                                )
                              )
                            )}
                            {renderQContr(
                              idx,
                              isOverall,
                              fyFq,
                              isEditAllowed,
                              true,
                              'c',
                              isNoPlanCon,
                              'curr'
                            )}

                            {isShowFutureYears &&
                              renderQContr(
                                idx,
                                isOverall,
                                fyFq + 1,
                                isEditAllowed,
                                true,
                                'c',
                                isNoPlanCon,
                                'futr'
                              )}
                            {isShowFutureYears &&
                              renderQContr(
                                idx,
                                isOverall,
                                fyFq + 2,
                                isEditAllowed,
                                true,
                                'c',
                                isNoPlanCon,
                                'futr'
                              )}
                          </tr>
                        )}

                        {isShowContrTrans && (
                          <tr key={`${uniqueKey}-${idx}-units-t`} className={styles.contractualRow}>
                            <td
                              className={cn(
                                { [styles.catTitle]: !isEditRow },
                                { [styles.catTitleEdit]: isEditRow },
                                { [styles.catL30]: isShowL3Border && l3Idx === 0 },
                                { [styles.catL31]: isShowL3Border && l3Idx === 1 },
                                { [styles.catL32]: isShowL3Border && l3Idx === 2 },
                                { [styles.catL3p]: isL3 },
                                { [styles.catL2]: !isOverall && !isL3 },
                                { [styles.catL3]: isL3SubCat && !isEditAllowed },
                                { [styles.catL3Edit]: isL3SubCat && isEditAllowed }
                              )}
                            >
                              <div className={styles.categoryTitle}>
                                <Translation
                                  span
                                  text={
                                    props.isDistributorPlanner
                                      ? 'jbp-planning-contractual-power'
                                      : 'jbp-planning-contractual-transactional'
                                  }
                                />
                                <CategorySubTitle
                                  isShowSubTitles={!props.composedReportMode}
                                  isShowQuotas={props.showQuota}
                                  isShowActuals={props.showActuals}
                                  isShowActualsSplit={isShowActualsSplit}
                                  isShowSmbVsEuSplit={isShowSmbVsEuSplit}
                                  isShowYoYActualsVsActuals={isShowYoYActualsVsActuals}
                                  isShowYoYActualsVsPlans={isShowYoYActualsVsPlans}
                                  isShowYoYPlansVsPlans={isShowYoYPlansVsPlans}
                                  isShowYoYQuotaVsActuals={isShowYoYQuotaVsActuals}
                                  isShowYoYPartnersVsPartners={isShowYoYPartnersVsPartners}
                                  isShowPlanAchievement={isShowPlanAchievement}
                                  isShowQuotaAchievement={isShowQuotaAchievement}
                                  isShowQoQActualsVsActuals={isShowQoQActualsVsActuals}
                                  isShowQoQActualsVsPlans={isShowQoQActualsVsPlans}
                                  isShowQoQPlansVsPlans={isShowQoQPlansVsPlans}
                                  isShowQoQQuotaVsActuals={isShowQoQQuotaVsActuals}
                                  isShowQoQPartnersVsPartners={isShowQoQPartnersVsPartners}
                                  isDistributorPlanner={props.isDistributorPlanner}
                                  isShowPartnerCount={isShowPartnerCount}
                                  isEditRow={isEditRow}
                                  sType={'t'}
                                />
                              </div>
                            </td>

                            {renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              true,
                              't',
                              isNoPlanCon,
                              'prevPrev'
                            )}

                            {isYearlyPlanning ? (
                              <></>
                            ) : (
                              fQuarters.map((q) =>
                                renderQContr(
                                  idx,
                                  isOverall,
                                  -q,
                                  isEditAllowed,
                                  true,
                                  't',
                                  isNoPlanCon,
                                  'prev'
                                )
                              )
                            )}
                            {renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              true,
                              't',
                              isNoPlanCon,
                              'prev'
                            )}
                            {renderQContr(
                              idx,
                              isOverall,
                              -fyFq,
                              isEditAllowed,
                              true,
                              't',
                              isNoPlanCon,
                              'calc'
                            )}

                            {isYearlyPlanning ? (
                              <></>
                            ) : (
                              fQuarters.map((q) =>
                                renderQContr(
                                  idx,
                                  isOverall,
                                  q,
                                  isEditAllowed,
                                  true,
                                  't',
                                  isNoPlanCon,
                                  'curr'
                                )
                              )
                            )}
                            {renderQContr(
                              idx,
                              isOverall,
                              fyFq,
                              isEditAllowed,
                              true,
                              't',
                              isNoPlanCon,
                              'curr'
                            )}

                            {isShowFutureYears &&
                              renderQContr(
                                idx,
                                isOverall,
                                fyFq + 1,
                                isEditAllowed,
                                true,
                                't',
                                isNoPlanCon,
                                'futr'
                              )}
                            {isShowFutureYears &&
                              renderQContr(
                                idx,
                                isOverall,
                                fyFq + 2,
                                isEditAllowed,
                                true,
                                't',
                                isNoPlanCon,
                                'futr'
                              )}
                          </tr>
                        )}
                      </>
                    )}
                  </Fragment>
                )
              })}
            </tbody>
          </table>
        )}

        {isShowApplySection && renderApplySection()}

        {/** -------------------- Render dialogs ----------------------- */}

        <ConfirmNotApplicableDialog
          isShowDialog={isShowConfirmNotApplicableDialog}
          category={t(currentCat)}
          onConfirm={confirmNotApplicable}
          onClose={cancelNotApplicable}
        />

        <ModalDialog
          show={isShowSignDialogNA}
          size={'sm'}
          content={CommitmentChangeDialog}
          header={() => (
            <WidgetHeader className={styles.modalDialogHeader}>jbp-confirm-changes</WidgetHeader>
          )}
          contentProps={{
            partnerId: partnerId,
            fyear: fyear,
            programType: buttonCurrType,
            metrics: props.metrics,
            onApply: async () => {
              setIsShowSignDialogNA(false)

              await onChangeNotApplicable()
            },
            onCancel: () => setIsShowSignDialogNA(false),
          }}
          onClose={() => setIsShowSignDialogNA(false)}
        />

        <ModalDialog
          show={isShowRateDialog}
          size={'sm'}
          content={TypeChangeDialog}
          contentProps={{
            content: <Translation span text="jbp-planning-rounding-warning" />,
            onDiscard: () => {
              setIsShowRateDialog(false)
              discardChanges()
            },
            onApply: async () => {
              setIsShowRateDialog(false)

              const isSignatureWillBeDropped =
                isNeedToShowSignDialog && !isOverallValueNotChanged(partnerInfo)

              if (isSignatureWillBeDropped) {
                setIsShowSignDialog(true)
              } else if (isSwitchersChanged) {
                setIsShowConfirmSwitchersChangeDialog(true)
              } else {
                await applyChanges(targetsItems)
              }
            },
            onCancel: () => setIsShowRateDialog(false),
          }}
          onClose={() => setIsShowRateDialog(false)}
        />

        <ModalDialog
          show={isShowSignDialog}
          size={'sm'}
          content={CommitmentChangeDialog}
          header={() => (
            <WidgetHeader className={styles.modalDialogHeader}>jbp-confirm-changes</WidgetHeader>
          )}
          contentProps={{
            partnerId: partnerId,
            fyear: fyear,
            programType: buttonCurrType,
            metrics: props.metrics,
            onDiscard: () => {
              setIsShowSignDialog(false)
              discardChanges()
            },
            onApply: async () => {
              setIsShowSignDialog(false)

              if (isSwitchersChanged) {
                setIsShowConfirmSwitchersChangeDialog(true)
              } else {
                await applyChanges(targetsItems)
              }
            },
            onCancel: () => setIsShowSignDialog(false),
          }}
          onClose={() => setIsShowSignDialog(false)}
        />

        <ConfirmSwitchersChangeDialog
          isShowDialog={isShowConfirmSwitchersChangeDialog}
          currCurrency={props.originalCurrency}
          currActualsValueType={props.originalActualsValueType}
          currency={currency}
          actualsValueType={actualsType}
          onConfirm={async () => {
            setIsShowConfirmSwitchersChangeDialog(false)
            await applyChanges(targetsItems)
          }}
          onClose={() => {
            setIsShowConfirmSwitchersChangeDialog(false)
          }}
        />

        <EditCommentDialog
          isShowDialog={!!editCommentEditor}
          currentEditComment={editCommentEditor?.comment || ''}
          onApply={async (value: any) => {
            if (editCommentEditor) {
              setCustomField(
                editCommentEditor.index,
                value,
                editCommentEditor.year,
                editCommentEditor.q,
                'Comment',
                'targets'
              )
            }

            setCommentEditor(undefined)
          }}
          onCancel={() => {
            setCommentEditor(undefined)
          }}
        />

        <ConfirmPolyPlanningLevelDialog
          isShowDialog={!!polyPlanningLevel}
          newPolyPlanningLevel={polyPlanningLevel}
          onConfirm={async () => {
            setPolyPlanningLevel('')

            const finSobProps = getFinSobProps()
            const finSobValidationResult = isFinSobPlanQuarterlyChecksEnabled
              ? checkFinSobValues(finSobProps)
              : []
            const isSignatureWillBeDropped =
              isNeedToShowSignDialog && !isOverallValueNotChanged(partnerInfo)

            if (finSobValidationResult.length > 0) {
              // Find first unconfirmed Input index
              const unconfirmedInputIndexes = Array.from(
                new Set(finSobValidationResult.map((el) => el.inputIndex))
              ).sort((a, b) => a - b)
              const newInputIndex = unconfirmedInputIndexes[0]

              setValidationErrors(finSobValidationResult)
              setValidationInputIndex(newInputIndex)
              switchSplitType(newInputIndex, finSobValidationResult)

              props.setIsShowValidationPopup(true)
            } else if (!checkFinSobRate(finSobProps)) {
              setIsShowRateDialog(true)
            } else if (isSignatureWillBeDropped) {
              setIsShowSignDialog(true)
            } else if (isSwitchersChanged) {
              setIsShowConfirmSwitchersChangeDialog(true)
            } else {
              await applyChanges(targetsItems)
            }
          }}
          onClose={() => {
            setPolyPlanningLevel('')
          }}
        />

        <PartnersCompletenessDialog
          isShowDialog={!!partnersCompleteness}
          partnersCompleteness={partnersCompleteness}
          onConfirm={async () => {
            setPartnersCompleteness(undefined)
          }}
          onClose={() => {
            setPartnersCompleteness(undefined)
          }}
        />
      </Controller>
    </div>
  )
}
